/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ErrorProcessRequestImport } from './routes/error-process-request'
import { Route as BreadcrumbsLayoutImport } from './routes/_breadcrumbsLayout'
import { Route as IndexImport } from './routes/index'
import { Route as BreadcrumbsLayoutAccountIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360RouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/route'
import { Route as BreadcrumbsLayoutAccountIdExploreRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdTicketsSplatImport } from './routes/_breadcrumbsLayout/$accountId/tickets/$'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdCaasmSplatImport } from './routes/_breadcrumbsLayout/$accountId/caasm/$'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/roi/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/risk/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/overview/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/explore/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsUsersRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/users/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsDashboardRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/dashboard/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsQueryRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/query/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/profile-settings/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsIconsRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/icons/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/backoffice-actions/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/account-usage/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/account-settings/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/workflows/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/risk-score/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/easm-settings/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/authentication-sources/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformAliasesRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/aliases/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsPivotRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/pivot/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesUsersRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/users/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/tenants/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/remediation/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/overview/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/identity-findings/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/alerts/route'
import { Route as BreadcrumbsLayoutAccountIdExploreLogsRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/logs/route'
import { Route as BreadcrumbsLayoutAccountIdExploreEntitiesRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/entities/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsPivotRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/pivot/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsUsersRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/users/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policy-compliance/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/asset-inventory/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/roi/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/risk/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/overview/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/explore/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsUsersIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/users/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsDashboardIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/dashboard/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsQueryIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/query/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/profile-settings/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsIconsIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/icons/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/backoffice-actions/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/account-usage/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/account-settings/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/workflows/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/risk-score/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/easm-settings/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/authentication-sources/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformAliasesIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/aliases/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsPivotIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/pivot/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesUsersIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/users/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/tenants/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/identity-findings/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/alerts/index'
import { Route as BreadcrumbsLayoutAccountIdExploreLogsIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/logs/index'
import { Route as BreadcrumbsLayoutAccountIdExploreEntitiesIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/entities/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsPivotIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/pivot/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsUsersIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/users/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policy-compliance/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/asset-inventory/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/users/visual/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsUsersIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/users/$id/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/ui-config/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/severity/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/visual/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/overview/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/assets/visual/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/alerts/visual/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/create/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/create/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/create/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/account-settings/audit/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factors/visual/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/create/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/create/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/runs/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/easm-settings/create/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-purge/runs/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/fields/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/pivot/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/incidents/visual/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/users/visual/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/users/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/incidents/visual/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/ui-config/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/logs/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/create/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/pivot/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/incidents/visual/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/create/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/alerts/visual/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/users/visual/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsUsersIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/users/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ui-config/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/create/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/assets/visual/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/users/visual/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsUsersIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/users/$id/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/ui-config/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/severity/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/visual/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/overview/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/assets/visual/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/alerts/visual/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/create/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/create/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/create/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/account-settings/audit/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factors/visual/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/create/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/create/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/runs/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/easm-settings/create/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-purge/runs/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/fields/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/pivot/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/incidents/visual/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/users/visual/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/users/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/tenants/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/settings/ui-config/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/incidents/visual/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/ui-config/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/logs/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/create/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/pivot/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/incidents/visual/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/create/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/alerts/visual/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/users/visual/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsUsersIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/users/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ui-config/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/create/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/assets/visual/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/create/$type/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/create/$type/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id.$organizationId/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id.$organizationId/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/route'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id.$organizationId/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/index'
import { Route as BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id.$organizationId/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/{-$mode}/{-$id}/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/audit.$id/route'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/{-$mode}/{-$id}/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/audit.$id/index'
import { Route as BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/index'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/route'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/route'
import { Route as BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/index'
import { Route as BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexImport } from './routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/index'

// Create Virtual Routes

const BreadcrumbsLayoutAccountIdPlatformImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/platform',
)()
const BreadcrumbsLayoutAccountIdIndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/',
)()
const BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyImport =
  createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/')()
const BreadcrumbsLayoutAccountIdRisk360IndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/risk360/',
)()
const BreadcrumbsLayoutAccountIdIncidentsIndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/incidents/',
)()
const BreadcrumbsLayoutAccountIdIdentitiesIndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/identities/',
)()
const BreadcrumbsLayoutAccountIdExploreIndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/explore/',
)()
const BreadcrumbsLayoutAccountIdDetectionsIndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/detections/',
)()
const BreadcrumbsLayoutAccountIdAssetsIndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/assets/',
)()
const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyImport =
  createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/')()
const BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyImport =
  createFileRoute('/_breadcrumbsLayout/$accountId/incidents/settings/')()
const BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyImport =
  createFileRoute('/_breadcrumbsLayout/$accountId/identities/remediation/')()
const BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyImport =
  createFileRoute('/_breadcrumbsLayout/$accountId/identities/overview/')()
const BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyImport =
  createFileRoute('/_breadcrumbsLayout/$accountId/detections/settings/')()
const BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyImport = createFileRoute(
  '/_breadcrumbsLayout/$accountId/assets/settings/',
)()

// Create/Update Routes

const ErrorProcessRequestRoute = ErrorProcessRequestImport.update({
  id: '/error-process-request',
  path: '/error-process-request',
  getParentRoute: () => rootRoute,
} as any)

const BreadcrumbsLayoutRoute = BreadcrumbsLayoutImport.update({
  id: '/_breadcrumbsLayout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const BreadcrumbsLayoutAccountIdRouteRoute =
  BreadcrumbsLayoutAccountIdRouteImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () => BreadcrumbsLayoutRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformRoute =
  BreadcrumbsLayoutAccountIdPlatformImport.update({
    id: '/platform',
    path: '/platform',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIndexLazyRoute =
  BreadcrumbsLayoutAccountIdIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport.update({
    id: '/vulnerabilities',
    path: '/vulnerabilities',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsRouteImport.update({
    id: '/threats',
    path: '/threats',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360RouteRoute =
  BreadcrumbsLayoutAccountIdRisk360RouteImport.update({
    id: '/risk360',
    path: '/risk360',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesRouteImport.update({
    id: '/identities',
    path: '/identities',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdExploreRouteRoute =
  BreadcrumbsLayoutAccountIdExploreRouteImport.update({
    id: '/explore',
    path: '/explore',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsRouteImport.update({
    id: '/detections',
    path: '/detections',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute =
  BreadcrumbsLayoutAccountIdRisk360IndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRisk360RouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute =
  BreadcrumbsLayoutAccountIdIncidentsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreIndexLazyRoute =
  BreadcrumbsLayoutAccountIdExploreIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdExploreRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute =
  BreadcrumbsLayoutAccountIdDetectionsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute =
  BreadcrumbsLayoutAccountIdAssetsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutImport.update(
    {
      id: '/_externalProjectionsLayout',
      getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdTicketsSplatRoute =
  BreadcrumbsLayoutAccountIdTicketsSplatImport.update({
    id: '/tickets/$',
    path: '/tickets/$',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutImport.update({
    id: '/_externalProjectionsLayout',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutImport.update({
    id: '/_externalProjectionsLayout',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRisk360RouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutImport.update({
    id: '/_externalProjectionsLayout',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutImport.update({
    id: '/_externalProjectionsLayout',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutImport.update({
    id: '/_externalProjectionsLayout',
    getParentRoute: () => BreadcrumbsLayoutAccountIdExploreRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutImport.update({
    id: '/_externalProjectionsLayout',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdCaasmSplatRoute =
  BreadcrumbsLayoutAccountIdCaasmSplatImport.update({
    id: '/caasm/$',
    path: '/caasm/$',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutImport.update({
    id: '/_externalProjectionsLayout',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteImport.update({
    id: '/roi',
    path: '/roi',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteImport.update({
    id: '/risk',
    path: '/risk',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteImport.update({
    id: '/remediation',
    path: '/remediation',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteImport.update({
    id: '/pivot',
    path: '/pivot',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteImport.update({
    id: '/explore',
    path: '/explore',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteImport.update({
    id: '/asset-coverage',
    path: '/asset-coverage',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsUsersRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsDashboardRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementRouteImport.update({
    id: '/settings/user-management',
    path: '/settings/user-management',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteImport.update({
    id: '/settings/risk360-backoffice-actions',
    path: '/settings/risk360-backoffice-actions',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsQueryRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsQueryRouteImport.update({
    id: '/settings/query',
    path: '/settings/query',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteImport.update({
    id: '/settings/profile-settings',
    path: '/settings/profile-settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsIconsRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsIconsRouteImport.update({
    id: '/settings/icons',
    path: '/settings/icons',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteImport.update({
    id: '/settings/global-factor-rules',
    path: '/settings/global-factor-rules',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteImport.update({
    id: '/settings/backoffice-actions',
    path: '/settings/backoffice-actions',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersRouteImport.update({
    id: '/settings/all-users',
    path: '/settings/all-users',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteImport.update({
    id: '/settings/all-accounts',
    path: '/settings/all-accounts',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteImport.update({
    id: '/settings/account-usage',
    path: '/settings/account-usage',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteImport.update({
    id: '/settings/account-settings',
    path: '/settings/account-settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteImport.update({
    id: '/factor-rules',
    path: '/factor-rules',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRisk360RouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteImport.update({
    id: '/platform/workflows',
    path: '/platform/workflows',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport.update({
    id: '/platform/targets',
    path: '/platform/targets',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport.update({
    id: '/platform/sources',
    path: '/platform/sources',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteImport.update({
    id: '/platform/scanner-activation',
    path: '/platform/scanner-activation',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteImport.update({
    id: '/platform/risk-score',
    path: '/platform/risk-score',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteImport.update({
    id: '/platform/easm-settings',
    path: '/platform/easm-settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteImport.update({
    id: '/platform/authentication-sources',
    path: '/platform/authentication-sources',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformAliasesRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformAliasesRouteImport.update({
    id: '/platform/aliases',
    path: '/platform/aliases',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsPivotRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsPivotRouteImport.update({
    id: '/pivot',
    path: '/pivot',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteImport.update({
    id: '/tenants',
    path: '/tenants',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteImport.update({
    id: '/remediation',
    path: '/remediation',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteImport.update({
    id: '/identity-findings',
    path: '/identity-findings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdExploreLogsRouteRoute =
  BreadcrumbsLayoutAccountIdExploreLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => BreadcrumbsLayoutAccountIdExploreRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdExploreEntitiesRouteRoute =
  BreadcrumbsLayoutAccountIdExploreEntitiesRouteImport.update({
    id: '/entities',
    path: '/entities',
    getParentRoute: () => BreadcrumbsLayoutAccountIdExploreRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsPivotRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsPivotRouteImport.update({
    id: '/pivot',
    path: '/pivot',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteImport.update({
    id: '/lookup-tables',
    path: '/lookup-tables',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteImport.update({
    id: '/global-scripts',
    path: '/global-scripts',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsUsersRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteImport.update({
    id: '/tool-coverage-and-gap',
    path: '/tool-coverage-and-gap',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteImport.update({
    id: '/policy-compliance',
    path: '/policy-compliance',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteImport.update({
    id: '/asset-inventory',
    path: '/asset-inventory',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute =
  BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/remediation/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute =
  BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/overview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/roi/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/risk/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/overview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/explore/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsUsersIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsUsersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/users/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsDashboardIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/user-management/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsQueryIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdSettingsQueryRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/query/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/profile-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsIconsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdSettingsIconsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/icons/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/backoffice-actions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-users/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-accounts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/account-usage/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/account-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/workflows/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/risk-score/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/easm-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/authentication-sources/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformAliasesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformAliasesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/aliases/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsPivotIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsPivotRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/pivot/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesUsersIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/users/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/tenants/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/identity-findings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreLogsIndexRoute =
  BreadcrumbsLayoutAccountIdExploreLogsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdExploreLogsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/logs/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute =
  BreadcrumbsLayoutAccountIdExploreEntitiesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdExploreEntitiesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/entities/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/rules/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsPivotIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsPivotRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/pivot/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/global-scripts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsUsersIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsUsersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/users/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policy-compliance/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policies/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/asset-inventory/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteImport.update({
    id: '/tickets/{-$id}',
    path: '/tickets/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteImport.update({
    id: '/tickets/visual',
    path: '/tickets/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteImport.update({
    id: '/ui-config',
    path: '/ui-config',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteImport.update(
    {
      id: '/ticket-lifecycle',
      path: '/ticket-lifecycle',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteImport.update(
    {
      id: '/severity-sla',
      path: '/severity-sla',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteImport.update({
    id: '/score',
    path: '/score',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteImport.update({
    id: '/rule-set',
    path: '/rule-set',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteImport.update(
    {
      id: '/exceptions',
      path: '/exceptions',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteImport.update({
    id: '/findings/{-$id}',
    path: '/findings/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteImport.update({
    id: '/findings/visual',
    path: '/findings/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteImport.update({
    id: '/exceptions/{-$id}',
    path: '/exceptions/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteImport.update({
    id: '/assets/{-$id}',
    path: '/assets/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteImport.update({
    id: '/assets/visual',
    path: '/assets/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/dashboards',
      path: '/dashboards',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteImport.update({
    id: '/visual',
    path: '/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsUsersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteImport.update({
    id: '/settings/ui-config',
    path: '/settings/ui-config',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteImport.update({
    id: '/settings/tickets-statuses',
    path: '/settings/tickets-statuses',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteImport.update({
    id: '/settings/severity',
    path: '/settings/severity',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteImport.update({
    id: '/settings/Incident-rules',
    path: '/settings/Incident-rules',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteImport.update({
    id: '/incidents/{-$id}',
    path: '/incidents/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteImport.update({
    id: '/incidents/visual',
    path: '/incidents/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteImport.update({
    id: '/incidents/overview',
    path: '/incidents/overview',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteImport.update({
    id: '/assets/{-$id}',
    path: '/assets/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteImport.update({
    id: '/assets/visual',
    path: '/assets/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteImport.update({
    id: '/alerts/{-$id}',
    path: '/alerts/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteImport.update({
    id: '/alerts/visual',
    path: '/alerts/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/dashboards',
      path: '/dashboards',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteImport.update({
    id: '/settings/permissions/roles',
    path: '/settings/permissions/roles',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteImport.update(
    {
      id: '/settings/permissions/content-permissions',
      path: '/settings/permissions/content-permissions',
      getParentRoute: () => BreadcrumbsLayoutAccountIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteImport.update({
    id: '/factors/{-$id}',
    path: '/factors/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRisk360RouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteImport.update({
    id: '/factors/visual',
    path: '/factors/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRisk360RouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/dashboards',
      path: '/dashboards',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteImport.update({
    id: '/relations/{-$relationId}',
    path: '/relations/{-$relationId}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteImport.update({
    id: '/overview/health-dashboard',
    path: '/overview/health-dashboard',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteImport.update({
    id: '/model-management/{-$id}',
    path: '/model-management/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteImport.update({
    id: '/model-management/runs',
    path: '/model-management/runs',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteImport.update({
    id: '/data-purge/{-$projId}',
    path: '/data-purge/{-$projId}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteImport.update({
    id: '/data-purge/runs',
    path: '/data-purge/runs',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteImport.update({
    id: '/data-entities/fields',
    path: '/data-entities/fields',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteImport.update({
    id: '/data-entities/data-entities',
    path: '/data-entities/data-entities',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteImport.update(
    {
      id: '/measurements',
      path: '/measurements',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteImport.update({
    id: '/ui-config',
    path: '/ui-config',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteImport.update({
    id: '/tickets-statuses',
    path: '/tickets-statuses',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteImport.update({
    id: '/rule-set',
    path: '/rule-set',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsPivotRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteImport.update({
    id: '/incidents/{-$id}',
    path: '/incidents/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteImport.update({
    id: '/incidents/visual',
    path: '/incidents/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/dashboards',
      path: '/dashboards',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteImport.update({
    id: '/visual',
    path: '/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteImport.update({
    id: '/settings/itdr-config',
    path: '/settings/itdr-config',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteImport.update({
    id: '/incidents/{-$id}',
    path: '/incidents/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteImport.update({
    id: '/incidents/visual',
    path: '/incidents/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteImport.update({
    id: '/visual',
    path: '/visual',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteImport.update({
    id: '/{-$id}',
    path: '/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteImport.update(
    {
      id: '/_externalProjectionsLayout/reports',
      path: '/reports',
      getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/_externalProjectionsLayout/dashboards',
      path: '/dashboards',
      getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/dashboards',
      path: '/dashboards',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteImport.update({
    id: '/ui-config',
    path: '/ui-config',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteImport.update(
    {
      id: '/tickets-statuses',
      path: '/tickets-statuses',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteImport.update({
    id: '/rule-set',
    path: '/rule-set',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsPivotRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteImport.update({
    id: '/incidents/{-$id}',
    path: '/incidents/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteImport.update({
    id: '/incidents/visual',
    path: '/incidents/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteImport.update({
    id: '/alerts/{-$id}',
    path: '/alerts/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteImport.update({
    id: '/alerts/visual',
    path: '/alerts/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/dashboards',
      path: '/dashboards',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteImport.update({
    id: '/violation-tickets/{-$id}',
    path: '/violation-tickets/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteImport.update({
    id: '/violation-tickets/visual',
    path: '/violation-tickets/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteImport.update({
    id: '/visual',
    path: '/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsUsersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteImport.update({
    id: '/ui-config',
    path: '/ui-config',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteImport.update({
    id: '/tickets-statuses',
    path: '/tickets-statuses',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteImport.update({
    id: '/ticket-lifecycle',
    path: '/ticket-lifecycle',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteImport.update({
    id: '/rule-set',
    path: '/rule-set',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteImport.update({
    id: '/easm-settings',
    path: '/easm-settings',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteImport.update({
    id: '/policy-violations/{-$id}',
    path: '/policy-violations/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteImport.update({
    id: '/policy-violations/visual',
    path: '/policy-violations/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteImport.update({
    id: '/assets/{-$id}',
    path: '/assets/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteImport.update({
    id: '/assets/visual',
    path: '/assets/visual',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteImport.update(
    {
      id: '/reports',
      path: '/reports',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteImport.update(
    {
      id: '/dashboards',
      path: '/dashboards',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/users/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsUsersIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/users/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/ui-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/severity/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/incidents/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/incidents/overview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/assets/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/alerts/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/user-management/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-users/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-accounts/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/account-settings/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/factors/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/model-management/runs/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/easm-settings/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/data-purge/runs/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/data-entities/fields/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/pivot/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/incidents/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/users/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/users/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/tenants/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexImport.update({
    id: '/settings/ui-config/',
    path: '/settings/ui-config/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/settings/ui-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/incidents/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/ui-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/rules/logs/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/rules/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/pivot/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/incidents/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/global-scripts/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/alerts/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/users/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsUsersIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/users/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/ui-config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policies/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/assets/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatImport.update(
    {
      id: '/tickets-statuses/$',
      path: '/tickets-statuses/$',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatImport.update(
    {
      id: '/exceptions-settings/$',
      path: '/exceptions-settings/$',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteImport.update(
    {
      id: '/tickets-statuses',
      path: '/tickets-statuses',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteImport.update(
    {
      id: '/severity',
      path: '/severity',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteImport.update(
    {
      id: '/exceptions-statuses',
      path: '/exceptions-statuses',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteImport.update(
    {
      id: '/exceptions-settings',
      path: '/exceptions-settings',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteImport.update({
    id: '/settings/alert-score/audit',
    path: '/settings/alert-score/audit',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteImport.update({
    id: '/incidents/incident-list/{-$id}',
    path: '/incidents/incident-list/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteImport.update(
    {
      id: '/incidents/incident-list/visual',
      path: '/incidents/incident-list/visual',
      getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteImport.update({
    id: '/audit/$id',
    path: '/audit/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteImport.update({
    id: '/mapping/$id',
    path: '/mapping/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteImport.update({
    id: '/$type',
    path: '/$type',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteImport.update({
    id: '/activityLog/$id',
    path: '/activityLog/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteImport.update({
    id: '/runs/$id',
    path: '/runs/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteImport.update(
    {
      id: '/sensors/$id',
      path: '/sensors/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteImport.update({
    id: '/formatting-rules/{-$mode}/{-$id}',
    path: '/formatting-rules/{-$mode}/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteImport.update({
    id: '/asset-aging/{-$mode}/{-$id}',
    path: '/asset-aging/{-$mode}/{-$id}',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteImport.update({
    id: '/runs/$id',
    path: '/runs/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteImport.update(
    {
      id: '/tickets-statuses',
      path: '/tickets-statuses',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteImport.update({
    id: '/runs/$id',
    path: '/runs/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteImport.update({
    id: '/duplicate/$id',
    path: '/duplicate/$id',
    getParentRoute: () => BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/create/$type/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteImport.update(
    {
      id: '/audit/$path',
      path: '/audit/$path',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteImport.update(
    {
      id: '/sla/{-$id}',
      path: '/sla/{-$id}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteImport.update(
    {
      id: '/audit/$path',
      path: '/audit/$path',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteImport.update(
    {
      id: '/create/{-$ruleIndex}',
      path: '/create/{-$ruleIndex}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteImport.update(
    {
      id: '/$id/{-$ruleIndex}',
      path: '/$id/{-$ruleIndex}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteImport.update(
    {
      id: '/$id/audit',
      path: '/$id/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteImport.update({
    id: '/audit/$path',
    path: '/audit/$path',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteImport.update(
    {
      id: '/audit/$automationId',
      path: '/audit/$automationId',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteImport.update(
    {
      id: '/settings/alert-score/{-$projection}/{-$field}',
      path: '/settings/alert-score/{-$projection}/{-$field}',
      getParentRoute: () => BreadcrumbsLayoutAccountIdThreatsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteImport.update({
    id: '/$previewId',
    path: '/$previewId',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteImport.update(
    {
      id: '/$type/{-$previewId}',
      path: '/$type/{-$previewId}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteImport.update({
    id: '/$id/$mappingPath/$type',
    path: '/$id/$mappingPath/$type',
    getParentRoute: () => BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteImport.update(
    {
      id: '/edit/$id/$organizationId',
      path: '/edit/$id/$organizationId',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteImport.update(
    {
      id: '/$projId/{-$ruleId}',
      path: '/$projId/{-$ruleId}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteImport.update(
    {
      id: '/$projId/explore',
      path: '/$projId/explore',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteImport.update(
    {
      id: '/edit/$systemName',
      path: '/edit/$systemName',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteImport.update(
    {
      id: '/audit/$path',
      path: '/audit/$path',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteImport.update(
    {
      id: '/$ruleIndex',
      path: '/$ruleIndex',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteImport.update(
    {
      id: '/$ruleIndex',
      path: '/$ruleIndex',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteImport.update(
    {
      id: '/audit/$path',
      path: '/audit/$path',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteImport.update(
    {
      id: '/$ruleIndex',
      path: '/$ruleIndex',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteImport.update({
    id: '/audit/$id',
    path: '/audit/$id',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteImport.update(
    {
      id: '/$ruleIndex',
      path: '/$ruleIndex',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteImport.update({
    id: '/audit/$path',
    path: '/audit/$path',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteImport.update(
    {
      id: '/create/{-$ruleIndex}',
      path: '/create/{-$ruleIndex}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteImport.update({
    id: '/$id/{-$ruleIndex}',
    path: '/$id/{-$ruleIndex}',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRoute,
  } as any)

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteImport.update(
    {
      id: '/runs/$id',
      path: '/runs/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexImport.update(
    {
      id: '/{-$mode}/{-$id}/',
      path: '/{-$mode}/{-$id}/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id.$organizationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexImport.update(
    {
      id: '/settings/ui-config/audit/$path/',
      path: '/settings/ui-config/audit/$path/',
      getParentRoute: () => BreadcrumbsLayoutAccountIdIdentitiesRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRoute,
  } as any).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport.update(
    {
      id: '/automations/{-$id}/{-$ruleIndex}',
      path: '/automations/{-$id}/{-$ruleIndex}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteImport.update(
    {
      id: '/audit/$automationId',
      path: '/audit/$automationId',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteImport.update(
    {
      id: '/{-$mode}/{-$id}/audit',
      path: '/{-$mode}/{-$id}/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteImport.update(
    {
      id: '/audit/$idMapping',
      path: '/audit/$idMapping',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteImport.update(
    {
      id: '/preview',
      path: '/preview',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport.update(
    {
      id: '/automations/{-$id}/{-$ruleIndex}',
      path: '/automations/{-$id}/{-$ruleIndex}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteImport.update(
    {
      id: '/edit/$id/$organizationId',
      path: '/edit/$id/$organizationId',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport.update(
    {
      id: '/audit',
      path: '/audit',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id.$organizationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteImport.update(
    {
      id: '/audit/$automationId',
      path: '/audit/$automationId',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteImport.update(
    {
      id: '/set/$fieldName/{-$mode}/{-$id}',
      path: '/set/$fieldName/{-$mode}/{-$id}',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteImport.update(
    {
      id: '/set/$fieldName/audit/$id',
      path: '/set/$fieldName/audit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteImport.update(
    {
      id: '/audit/$id',
      path: '/audit/$id',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport.update(
    {
      id: '/audit/$automationId',
      path: '/audit/$automationId',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport.update(
    {
      id: '/audit/$automationId',
      path: '/audit/$automationId',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute,
    } as any,
  )

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute,
    } as any,
  ).lazy(() =>
    import('./routes/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_breadcrumbsLayout': {
      id: '/_breadcrumbsLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BreadcrumbsLayoutImport
      parentRoute: typeof rootRoute
    }
    '/error-process-request': {
      id: '/error-process-request'
      path: '/error-process-request'
      fullPath: '/error-process-request'
      preLoaderRoute: typeof ErrorProcessRequestImport
      parentRoute: typeof rootRoute
    }
    '/_breadcrumbsLayout/$accountId': {
      id: '/_breadcrumbsLayout/$accountId'
      path: '/$accountId'
      fullPath: '/$accountId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/assets': {
      id: '/_breadcrumbsLayout/$accountId/assets'
      path: '/assets'
      fullPath: '/$accountId/assets'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections': {
      id: '/_breadcrumbsLayout/$accountId/detections'
      path: '/detections'
      fullPath: '/$accountId/detections'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore': {
      id: '/_breadcrumbsLayout/$accountId/explore'
      path: '/explore'
      fullPath: '/$accountId/explore'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities': {
      id: '/_breadcrumbsLayout/$accountId/identities'
      path: '/identities'
      fullPath: '/$accountId/identities'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents': {
      id: '/_breadcrumbsLayout/$accountId/incidents'
      path: '/incidents'
      fullPath: '/$accountId/incidents'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360': {
      id: '/_breadcrumbsLayout/$accountId/risk360'
      path: '/risk360'
      fullPath: '/$accountId/risk360'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360RouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats': {
      id: '/_breadcrumbsLayout/$accountId/threats'
      path: '/threats'
      fullPath: '/$accountId/threats'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities'
      path: '/vulnerabilities'
      fullPath: '/$accountId/vulnerabilities'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/': {
      id: '/_breadcrumbsLayout/$accountId/'
      path: '/'
      fullPath: '/$accountId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/asset-inventory': {
      id: '/_breadcrumbsLayout/$accountId/assets/asset-inventory'
      path: '/asset-inventory'
      fullPath: '/$accountId/assets/asset-inventory'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies'
      path: '/policies'
      fullPath: '/$accountId/assets/policies'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policy-compliance': {
      id: '/_breadcrumbsLayout/$accountId/assets/policy-compliance'
      path: '/policy-compliance'
      fullPath: '/$accountId/assets/policy-compliance'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings'
      path: '/settings'
      fullPath: '/$accountId/assets/settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap': {
      id: '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap'
      path: '/tool-coverage-and-gap'
      fullPath: '/$accountId/assets/tool-coverage-and-gap'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/users': {
      id: '/_breadcrumbsLayout/$accountId/assets/users'
      path: '/users'
      fullPath: '/$accountId/assets/users'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts'
      path: '/global-scripts'
      fullPath: '/$accountId/detections/global-scripts'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables'
      path: '/lookup-tables'
      fullPath: '/$accountId/detections/lookup-tables'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/pivot': {
      id: '/_breadcrumbsLayout/$accountId/detections/pivot'
      path: '/pivot'
      fullPath: '/$accountId/detections/pivot'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules'
      path: '/rules'
      fullPath: '/$accountId/detections/rules'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings'
      path: '/settings'
      fullPath: '/$accountId/detections/settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/entities': {
      id: '/_breadcrumbsLayout/$accountId/explore/entities'
      path: '/entities'
      fullPath: '/$accountId/explore/entities'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreEntitiesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/logs': {
      id: '/_breadcrumbsLayout/$accountId/explore/logs'
      path: '/logs'
      fullPath: '/$accountId/explore/logs'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreLogsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/alerts': {
      id: '/_breadcrumbsLayout/$accountId/identities/alerts'
      path: '/alerts'
      fullPath: '/$accountId/identities/alerts'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/identity-findings': {
      id: '/_breadcrumbsLayout/$accountId/identities/identity-findings'
      path: '/identity-findings'
      fullPath: '/$accountId/identities/identity-findings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/overview': {
      id: '/_breadcrumbsLayout/$accountId/identities/overview'
      path: '/overview'
      fullPath: '/$accountId/identities/overview'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/remediation': {
      id: '/_breadcrumbsLayout/$accountId/identities/remediation'
      path: '/remediation'
      fullPath: '/$accountId/identities/remediation'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/tenants': {
      id: '/_breadcrumbsLayout/$accountId/identities/tenants'
      path: '/tenants'
      fullPath: '/$accountId/identities/tenants'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/users': {
      id: '/_breadcrumbsLayout/$accountId/identities/users'
      path: '/users'
      fullPath: '/$accountId/identities/users'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/pivot': {
      id: '/_breadcrumbsLayout/$accountId/incidents/pivot'
      path: '/pivot'
      fullPath: '/$accountId/incidents/pivot'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings'
      path: '/settings'
      fullPath: '/$accountId/incidents/settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/aliases': {
      id: '/_breadcrumbsLayout/$accountId/platform/aliases'
      path: '/platform/aliases'
      fullPath: '/$accountId/platform/aliases'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformAliasesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/authentication-sources': {
      id: '/_breadcrumbsLayout/$accountId/platform/authentication-sources'
      path: '/platform/authentication-sources'
      fullPath: '/$accountId/platform/authentication-sources'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/easm-settings': {
      id: '/_breadcrumbsLayout/$accountId/platform/easm-settings'
      path: '/platform/easm-settings'
      fullPath: '/$accountId/platform/easm-settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/risk-score': {
      id: '/_breadcrumbsLayout/$accountId/platform/risk-score'
      path: '/platform/risk-score'
      fullPath: '/$accountId/platform/risk-score'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation'
      path: '/platform/scanner-activation'
      fullPath: '/$accountId/platform/scanner-activation'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources'
      path: '/platform/sources'
      fullPath: '/$accountId/platform/sources'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets'
      path: '/platform/targets'
      fullPath: '/$accountId/platform/targets'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/workflows': {
      id: '/_breadcrumbsLayout/$accountId/platform/workflows'
      path: '/platform/workflows'
      fullPath: '/$accountId/platform/workflows'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules'
      path: '/factor-rules'
      fullPath: '/$accountId/risk360/factor-rules'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360RouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/account-settings': {
      id: '/_breadcrumbsLayout/$accountId/settings/account-settings'
      path: '/settings/account-settings'
      fullPath: '/$accountId/settings/account-settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/account-usage': {
      id: '/_breadcrumbsLayout/$accountId/settings/account-usage'
      path: '/settings/account-usage'
      fullPath: '/$accountId/settings/account-usage'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts'
      path: '/settings/all-accounts'
      fullPath: '/$accountId/settings/all-accounts'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users'
      path: '/settings/all-users'
      fullPath: '/$accountId/settings/all-users'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/backoffice-actions': {
      id: '/_breadcrumbsLayout/$accountId/settings/backoffice-actions'
      path: '/settings/backoffice-actions'
      fullPath: '/$accountId/settings/backoffice-actions'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules'
      path: '/settings/global-factor-rules'
      fullPath: '/$accountId/settings/global-factor-rules'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/icons': {
      id: '/_breadcrumbsLayout/$accountId/settings/icons'
      path: '/settings/icons'
      fullPath: '/$accountId/settings/icons'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsIconsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/profile-settings': {
      id: '/_breadcrumbsLayout/$accountId/settings/profile-settings'
      path: '/settings/profile-settings'
      fullPath: '/$accountId/settings/profile-settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/query': {
      id: '/_breadcrumbsLayout/$accountId/settings/query'
      path: '/settings/query'
      fullPath: '/$accountId/settings/query'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsQueryRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions': {
      id: '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions'
      path: '/settings/risk360-backoffice-actions'
      fullPath: '/$accountId/settings/risk360-backoffice-actions'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management'
      path: '/settings/user-management'
      fullPath: '/$accountId/settings/user-management'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/dashboard': {
      id: '/_breadcrumbsLayout/$accountId/threats/dashboard'
      path: '/dashboard'
      fullPath: '/$accountId/threats/dashboard'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsDashboardRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/users': {
      id: '/_breadcrumbsLayout/$accountId/threats/users'
      path: '/users'
      fullPath: '/$accountId/threats/users'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage'
      path: '/asset-coverage'
      fullPath: '/$accountId/vulnerabilities/asset-coverage'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/explore': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/explore'
      path: '/explore'
      fullPath: '/$accountId/vulnerabilities/explore'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/overview': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/overview'
      path: '/overview'
      fullPath: '/$accountId/vulnerabilities/overview'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot'
      path: '/pivot'
      fullPath: '/$accountId/vulnerabilities/pivot'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation'
      path: '/remediation'
      fullPath: '/$accountId/vulnerabilities/remediation'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/risk': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/risk'
      path: '/risk'
      fullPath: '/$accountId/vulnerabilities/risk'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/roi': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/roi'
      path: '/roi'
      fullPath: '/$accountId/vulnerabilities/roi'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings'
      path: '/settings'
      fullPath: '/$accountId/vulnerabilities/settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout'
      path: ''
      fullPath: '/$accountId/assets'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/caasm/$': {
      id: '/_breadcrumbsLayout/$accountId/caasm/$'
      path: '/caasm/$'
      fullPath: '/$accountId/caasm/$'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdCaasmSplatImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout'
      path: ''
      fullPath: '/$accountId/detections'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout'
      path: ''
      fullPath: '/$accountId/explore'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout'
      path: ''
      fullPath: '/$accountId/incidents'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform': {
      id: '/_breadcrumbsLayout/$accountId/platform'
      path: '/platform'
      fullPath: '/$accountId/platform'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout'
      path: '/platform'
      fullPath: '/$accountId/platform'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformRoute
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout'
      path: ''
      fullPath: '/$accountId/risk360'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360RouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout'
      path: ''
      fullPath: '/$accountId/threats'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/tickets/$': {
      id: '/_breadcrumbsLayout/$accountId/tickets/$'
      path: '/tickets/$'
      fullPath: '/$accountId/tickets/$'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdTicketsSplatImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout'
      path: ''
      fullPath: '/$accountId/vulnerabilities'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/': {
      id: '/_breadcrumbsLayout/$accountId/threats/'
      path: '/'
      fullPath: '/$accountId/threats/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/': {
      id: '/_breadcrumbsLayout/$accountId/assets/'
      path: '/'
      fullPath: '/$accountId/assets/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/': {
      id: '/_breadcrumbsLayout/$accountId/detections/'
      path: '/'
      fullPath: '/$accountId/detections/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/': {
      id: '/_breadcrumbsLayout/$accountId/explore/'
      path: '/'
      fullPath: '/$accountId/explore/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/': {
      id: '/_breadcrumbsLayout/$accountId/identities/'
      path: '/'
      fullPath: '/$accountId/identities/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/'
      path: '/'
      fullPath: '/$accountId/incidents/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/'
      path: '/'
      fullPath: '/$accountId/risk360/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360IndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360RouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/assets/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports'
      path: '/reports'
      fullPath: '/$accountId/assets/reports'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/assets/assets/visual': {
      id: '/_breadcrumbsLayout/$accountId/assets/assets/visual'
      path: '/assets/visual'
      fullPath: '/$accountId/assets/assets/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}'
      path: '/assets/{-$id}'
      fullPath: '/$accountId/assets/assets/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/create': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/create'
      path: '/create'
      fullPath: '/$accountId/assets/policies/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual': {
      id: '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual'
      path: '/policy-violations/visual'
      fullPath: '/$accountId/assets/policy-violations/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}'
      path: '/policy-violations/{-$id}'
      fullPath: '/$accountId/assets/policy-violations/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings'
      path: '/easm-settings'
      fullPath: '/$accountId/assets/settings/easm-settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set'
      path: '/rule-set'
      fullPath: '/$accountId/assets/settings/rule-set'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle'
      path: '/ticket-lifecycle'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses'
      path: '/tickets-statuses'
      fullPath: '/$accountId/assets/settings/tickets-statuses'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ui-config': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ui-config'
      path: '/ui-config'
      fullPath: '/$accountId/assets/settings/ui-config'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/users/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/users/$id'
      path: '/$id'
      fullPath: '/$accountId/assets/users/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/users/visual': {
      id: '/_breadcrumbsLayout/$accountId/assets/users/visual'
      path: '/visual'
      fullPath: '/$accountId/assets/users/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual': {
      id: '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual'
      path: '/violation-tickets/visual'
      fullPath: '/$accountId/assets/violation-tickets/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}'
      path: '/violation-tickets/{-$id}'
      fullPath: '/$accountId/assets/violation-tickets/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/detections/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports'
      path: '/reports'
      fullPath: '/$accountId/detections/reports'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/detections/alerts/visual': {
      id: '/_breadcrumbsLayout/$accountId/detections/alerts/visual'
      path: '/alerts/visual'
      fullPath: '/$accountId/detections/alerts/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}'
      path: '/alerts/{-$id}'
      fullPath: '/$accountId/detections/alerts/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts/create': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts/create'
      path: '/create'
      fullPath: '/$accountId/detections/global-scripts/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/incidents/visual': {
      id: '/_breadcrumbsLayout/$accountId/detections/incidents/visual'
      path: '/incidents/visual'
      fullPath: '/$accountId/detections/incidents/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}'
      path: '/incidents/{-$id}'
      fullPath: '/$accountId/detections/incidents/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create'
      path: '/create'
      fullPath: '/$accountId/detections/lookup-tables/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/pivot/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/pivot/$id'
      path: '/$id'
      fullPath: '/$accountId/detections/pivot/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/create': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/create'
      path: '/create'
      fullPath: '/$accountId/detections/rules/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/logs': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/logs'
      path: '/logs'
      fullPath: '/$accountId/detections/rules/logs'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set'
      path: '/rule-set'
      fullPath: '/$accountId/detections/settings/rule-set'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses'
      path: '/tickets-statuses'
      fullPath: '/$accountId/detections/settings/tickets-statuses'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/ui-config': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/ui-config'
      path: '/ui-config'
      fullPath: '/$accountId/detections/settings/ui-config'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/explore/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports'
      path: '/reports'
      fullPath: '/$accountId/explore/reports'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/identities/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports'
      path: '/reports'
      fullPath: '/$accountId/identities/reports'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}'
      path: '/{-$id}'
      fullPath: '/$accountId/identities/alerts/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id': {
      id: '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id'
      path: '/$id'
      fullPath: '/$accountId/identities/identity-findings/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual': {
      id: '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual'
      path: '/visual'
      fullPath: '/$accountId/identities/identity-findings/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/incidents/visual': {
      id: '/_breadcrumbsLayout/$accountId/identities/incidents/visual'
      path: '/incidents/visual'
      fullPath: '/$accountId/identities/incidents/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}'
      path: '/incidents/{-$id}'
      fullPath: '/$accountId/identities/incidents/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config': {
      id: '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config'
      path: '/settings/itdr-config'
      fullPath: '/$accountId/identities/settings/itdr-config'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/users/$id': {
      id: '/_breadcrumbsLayout/$accountId/identities/users/$id'
      path: '/$id'
      fullPath: '/$accountId/identities/users/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/users/visual': {
      id: '/_breadcrumbsLayout/$accountId/identities/users/visual'
      path: '/visual'
      fullPath: '/$accountId/identities/users/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/incidents/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports'
      path: '/reports'
      fullPath: '/$accountId/incidents/reports'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/incidents/visual': {
      id: '/_breadcrumbsLayout/$accountId/incidents/incidents/visual'
      path: '/incidents/visual'
      fullPath: '/$accountId/incidents/incidents/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}'
      path: '/incidents/{-$id}'
      fullPath: '/$accountId/incidents/incidents/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/pivot/$id': {
      id: '/_breadcrumbsLayout/$accountId/incidents/pivot/$id'
      path: '/$id'
      fullPath: '/$accountId/incidents/pivot/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set'
      path: '/rule-set'
      fullPath: '/$accountId/incidents/settings/rule-set'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses'
      path: '/tickets-statuses'
      fullPath: '/$accountId/incidents/settings/tickets-statuses'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config'
      path: '/ui-config'
      fullPath: '/$accountId/incidents/settings/ui-config'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements'
      path: '/measurements'
      fullPath: '/$accountId/platform/measurements'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities'
      path: '/data-entities/data-entities'
      fullPath: '/$accountId/platform/data-entities/data-entities'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/fields': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/fields'
      path: '/data-entities/fields'
      fullPath: '/$accountId/platform/data-entities/fields'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-purge/runs': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-purge/runs'
      path: '/data-purge/runs'
      fullPath: '/$accountId/platform/data-purge/runs'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}'
      path: '/data-purge/{-$projId}'
      fullPath: '/$accountId/platform/data-purge/{-$projId}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/easm-settings/create': {
      id: '/_breadcrumbsLayout/$accountId/platform/easm-settings/create'
      path: '/create'
      fullPath: '/$accountId/platform/easm-settings/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/runs': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/runs'
      path: '/model-management/runs'
      fullPath: '/$accountId/platform/model-management/runs'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}'
      path: '/model-management/{-$id}'
      fullPath: '/$accountId/platform/model-management/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard': {
      id: '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard'
      path: '/overview/health-dashboard'
      fullPath: '/$accountId/platform/overview/health-dashboard'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}': {
      id: '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}'
      path: '/relations/{-$relationId}'
      fullPath: '/$accountId/platform/relations/{-$relationId}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create'
      path: '/create'
      fullPath: '/$accountId/platform/scanner-activation/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/create': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/create'
      path: '/create'
      fullPath: '/$accountId/platform/sources/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/create': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/create'
      path: '/create'
      fullPath: '/$accountId/platform/targets/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/risk360/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create'
      path: '/create'
      fullPath: '/$accountId/risk360/factor-rules/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs'
      path: '/runs'
      fullPath: '/$accountId/risk360/factor-rules/runs'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factors/visual': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factors/visual'
      path: '/factors/visual'
      fullPath: '/$accountId/risk360/factors/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360RouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}'
      path: '/factors/{-$id}'
      fullPath: '/$accountId/risk360/factors/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360RouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/account-settings/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/account-settings/audit'
      path: '/audit'
      fullPath: '/$accountId/settings/account-settings/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts/create': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts/create'
      path: '/create'
      fullPath: '/$accountId/settings/all-accounts/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users/create': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users/create'
      path: '/create'
      fullPath: '/$accountId/settings/all-users/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create'
      path: '/create'
      fullPath: '/$accountId/settings/global-factor-rules/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions'
      path: '/settings/permissions/content-permissions'
      fullPath: '/$accountId/settings/permissions/content-permissions'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles'
      path: '/settings/permissions/roles'
      fullPath: '/$accountId/settings/permissions/roles'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit'
      path: '/audit'
      fullPath: '/$accountId/settings/profile-settings/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management/create': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management/create'
      path: '/create'
      fullPath: '/$accountId/settings/user-management/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/threats/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports'
      path: '/reports'
      fullPath: '/$accountId/threats/reports'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/threats/alerts/visual': {
      id: '/_breadcrumbsLayout/$accountId/threats/alerts/visual'
      path: '/alerts/visual'
      fullPath: '/$accountId/threats/alerts/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}'
      path: '/alerts/{-$id}'
      fullPath: '/$accountId/threats/alerts/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/assets/visual': {
      id: '/_breadcrumbsLayout/$accountId/threats/assets/visual'
      path: '/assets/visual'
      fullPath: '/$accountId/threats/assets/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}'
      path: '/assets/{-$id}'
      fullPath: '/$accountId/threats/assets/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/overview': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/overview'
      path: '/incidents/overview'
      fullPath: '/$accountId/threats/incidents/overview'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/visual': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/visual'
      path: '/incidents/visual'
      fullPath: '/$accountId/threats/incidents/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}'
      path: '/incidents/{-$id}'
      fullPath: '/$accountId/threats/incidents/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules'
      path: '/settings/Incident-rules'
      fullPath: '/$accountId/threats/settings/Incident-rules'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/severity': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/severity'
      path: '/settings/severity'
      fullPath: '/$accountId/threats/settings/severity'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses'
      path: '/settings/tickets-statuses'
      fullPath: '/$accountId/threats/settings/tickets-statuses'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/ui-config': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/ui-config'
      path: '/settings/ui-config'
      fullPath: '/$accountId/threats/settings/ui-config'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/users/$id': {
      id: '/_breadcrumbsLayout/$accountId/threats/users/$id'
      path: '/$id'
      fullPath: '/$accountId/threats/users/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/users/visual': {
      id: '/_breadcrumbsLayout/$accountId/threats/users/visual'
      path: '/visual'
      fullPath: '/$accountId/threats/users/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/vulnerabilities/dashboards'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports'
      path: '/reports'
      fullPath: '/$accountId/vulnerabilities/reports'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual'
      path: '/assets/visual'
      fullPath: '/$accountId/vulnerabilities/assets/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}'
      path: '/assets/{-$id}'
      fullPath: '/$accountId/vulnerabilities/assets/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}'
      path: '/exceptions/{-$id}'
      fullPath: '/$accountId/vulnerabilities/exceptions/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual'
      path: '/findings/visual'
      fullPath: '/$accountId/vulnerabilities/findings/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}'
      path: '/findings/{-$id}'
      fullPath: '/$accountId/vulnerabilities/findings/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id'
      path: '/$id'
      fullPath: '/$accountId/vulnerabilities/pivot/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions'
      path: '/exceptions'
      fullPath: '/$accountId/vulnerabilities/settings/exceptions'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set'
      path: '/rule-set'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score'
      path: '/score'
      fullPath: '/$accountId/vulnerabilities/settings/score'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla'
      path: '/severity-sla'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle'
      path: '/ticket-lifecycle'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config'
      path: '/ui-config'
      fullPath: '/$accountId/vulnerabilities/settings/ui-config'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual'
      path: '/tickets/visual'
      fullPath: '/$accountId/vulnerabilities/tickets/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}'
      path: '/tickets/{-$id}'
      fullPath: '/$accountId/vulnerabilities/tickets/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/asset-inventory/': {
      id: '/_breadcrumbsLayout/$accountId/assets/asset-inventory/'
      path: '/'
      fullPath: '/$accountId/assets/asset-inventory/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/'
      path: '/'
      fullPath: '/$accountId/assets/policies/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policy-compliance/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policy-compliance/'
      path: '/'
      fullPath: '/$accountId/assets/policy-compliance/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/': {
      id: '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/'
      path: '/'
      fullPath: '/$accountId/assets/tool-coverage-and-gap/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/users/': {
      id: '/_breadcrumbsLayout/$accountId/assets/users/'
      path: '/'
      fullPath: '/$accountId/assets/users/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts/': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts/'
      path: '/'
      fullPath: '/$accountId/detections/global-scripts/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables/': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables/'
      path: '/'
      fullPath: '/$accountId/detections/lookup-tables/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/pivot/': {
      id: '/_breadcrumbsLayout/$accountId/detections/pivot/'
      path: '/'
      fullPath: '/$accountId/detections/pivot/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/'
      path: '/'
      fullPath: '/$accountId/detections/rules/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/entities/': {
      id: '/_breadcrumbsLayout/$accountId/explore/entities/'
      path: '/'
      fullPath: '/$accountId/explore/entities/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreEntitiesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreEntitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/logs/': {
      id: '/_breadcrumbsLayout/$accountId/explore/logs/'
      path: '/'
      fullPath: '/$accountId/explore/logs/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreLogsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreLogsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/alerts/': {
      id: '/_breadcrumbsLayout/$accountId/identities/alerts/'
      path: '/'
      fullPath: '/$accountId/identities/alerts/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/identity-findings/': {
      id: '/_breadcrumbsLayout/$accountId/identities/identity-findings/'
      path: '/'
      fullPath: '/$accountId/identities/identity-findings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/tenants/': {
      id: '/_breadcrumbsLayout/$accountId/identities/tenants/'
      path: '/'
      fullPath: '/$accountId/identities/tenants/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/users/': {
      id: '/_breadcrumbsLayout/$accountId/identities/users/'
      path: '/'
      fullPath: '/$accountId/identities/users/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/pivot/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/pivot/'
      path: '/'
      fullPath: '/$accountId/incidents/pivot/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/aliases/': {
      id: '/_breadcrumbsLayout/$accountId/platform/aliases/'
      path: '/'
      fullPath: '/$accountId/platform/aliases/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformAliasesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformAliasesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/authentication-sources/': {
      id: '/_breadcrumbsLayout/$accountId/platform/authentication-sources/'
      path: '/'
      fullPath: '/$accountId/platform/authentication-sources/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/easm-settings/': {
      id: '/_breadcrumbsLayout/$accountId/platform/easm-settings/'
      path: '/'
      fullPath: '/$accountId/platform/easm-settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/risk-score/': {
      id: '/_breadcrumbsLayout/$accountId/platform/risk-score/'
      path: '/'
      fullPath: '/$accountId/platform/risk-score/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation/': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation/'
      path: '/'
      fullPath: '/$accountId/platform/scanner-activation/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/'
      path: '/'
      fullPath: '/$accountId/platform/sources/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/'
      path: '/'
      fullPath: '/$accountId/platform/targets/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/workflows/': {
      id: '/_breadcrumbsLayout/$accountId/platform/workflows/'
      path: '/'
      fullPath: '/$accountId/platform/workflows/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/'
      path: '/'
      fullPath: '/$accountId/risk360/factor-rules/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/account-settings/': {
      id: '/_breadcrumbsLayout/$accountId/settings/account-settings/'
      path: '/'
      fullPath: '/$accountId/settings/account-settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/account-usage/': {
      id: '/_breadcrumbsLayout/$accountId/settings/account-usage/'
      path: '/'
      fullPath: '/$accountId/settings/account-usage/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts/'
      path: '/'
      fullPath: '/$accountId/settings/all-accounts/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users/'
      path: '/'
      fullPath: '/$accountId/settings/all-users/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/backoffice-actions/': {
      id: '/_breadcrumbsLayout/$accountId/settings/backoffice-actions/'
      path: '/'
      fullPath: '/$accountId/settings/backoffice-actions/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/'
      path: '/'
      fullPath: '/$accountId/settings/global-factor-rules/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/icons/': {
      id: '/_breadcrumbsLayout/$accountId/settings/icons/'
      path: '/'
      fullPath: '/$accountId/settings/icons/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsIconsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsIconsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/profile-settings/': {
      id: '/_breadcrumbsLayout/$accountId/settings/profile-settings/'
      path: '/'
      fullPath: '/$accountId/settings/profile-settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/query/': {
      id: '/_breadcrumbsLayout/$accountId/settings/query/'
      path: '/'
      fullPath: '/$accountId/settings/query/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsQueryIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsQueryRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/': {
      id: '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/'
      path: '/'
      fullPath: '/$accountId/settings/risk360-backoffice-actions/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management/': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management/'
      path: '/'
      fullPath: '/$accountId/settings/user-management/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/dashboard/': {
      id: '/_breadcrumbsLayout/$accountId/threats/dashboard/'
      path: '/'
      fullPath: '/$accountId/threats/dashboard/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsDashboardIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsDashboardRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/users/': {
      id: '/_breadcrumbsLayout/$accountId/threats/users/'
      path: '/'
      fullPath: '/$accountId/threats/users/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/asset-coverage/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/explore/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/explore/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/explore/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/overview/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/overview/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/overview/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/pivot/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/remediation/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/risk/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/risk/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/risk/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/roi/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/roi/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/roi/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/'
      path: '/'
      fullPath: '/$accountId/assets/settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/'
      path: '/'
      fullPath: '/$accountId/detections/settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/overview/': {
      id: '/_breadcrumbsLayout/$accountId/identities/overview/'
      path: '/'
      fullPath: '/$accountId/identities/overview/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/remediation/': {
      id: '/_breadcrumbsLayout/$accountId/identities/remediation/'
      path: '/'
      fullPath: '/$accountId/identities/remediation/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/assets/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create'
      path: '/create'
      fullPath: '/$accountId/assets/reports/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id'
      path: '/duplicate/$id'
      fullPath: '/$accountId/assets/policies/duplicate/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/assets/policies/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/assets/policies/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create'
      path: '/create'
      fullPath: '/$accountId/assets/settings/easm-settings/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses'
      path: '/tickets-statuses'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/detections/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create'
      path: '/create'
      fullPath: '/$accountId/detections/reports/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/detections/global-scripts/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/detections/lookup-tables/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/detections/rules/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/detections/rules/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id'
      path: '/$id'
      fullPath: '/$accountId/detections/settings/rule-set/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create'
      path: '/create'
      fullPath: '/$accountId/detections/settings/rule-set/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/explore/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create'
      path: '/create'
      fullPath: '/$accountId/explore/reports/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/identities/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create'
      path: '/create'
      fullPath: '/$accountId/identities/reports/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/incidents/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create'
      path: '/create'
      fullPath: '/$accountId/incidents/reports/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id'
      path: '/$id'
      fullPath: '/$accountId/incidents/settings/rule-set/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create'
      path: '/create'
      fullPath: '/$accountId/incidents/settings/rule-set/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create'
      path: '/create'
      fullPath: '/$accountId/platform/measurements/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}'
      path: '/asset-aging/{-$mode}/{-$id}'
      fullPath: '/$accountId/platform/asset-aging/{-$mode}/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}'
      path: '/formatting-rules/{-$mode}/{-$id}'
      fullPath: '/$accountId/platform/formatting-rules/{-$mode}/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit'
      path: '/audit'
      fullPath: '/$accountId/platform/model-management/{-$id}/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview'
      path: '/preview'
      fullPath: '/$accountId/platform/model-management/{-$id}/preview'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/platform/scanner-activation/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id'
      path: '/sensors/$id'
      fullPath: '/$accountId/platform/scanner-activation/sensors/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/platform/sources/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/platform/sources/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id'
      path: '/activityLog/$id'
      fullPath: '/$accountId/platform/targets/activityLog/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/create/$type': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/create/$type'
      path: '/$type'
      fullPath: '/$accountId/platform/targets/create/$type'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/platform/targets/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id'
      path: '/mapping/$id'
      fullPath: '/$accountId/platform/targets/mapping/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id'
      path: '/audit/$id'
      fullPath: '/$accountId/platform/workflows/audit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/risk360/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/risk360/factor-rules/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/settings/all-accounts/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/settings/all-users/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/settings/global-factor-rules/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create'
      path: '/create'
      fullPath: '/$accountId/settings/permissions/roles/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/settings/user-management/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/threats/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create'
      path: '/create'
      fullPath: '/$accountId/threats/reports/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual'
      path: '/incidents/incident-list/visual'
      fullPath: '/$accountId/threats/incidents/incident-list/visual'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}'
      path: '/incidents/incident-list/{-$id}'
      fullPath: '/$accountId/threats/incidents/incident-list/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create'
      path: '/create'
      fullPath: '/$accountId/threats/settings/Incident-rules/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit'
      path: '/settings/alert-score/audit'
      fullPath: '/$accountId/threats/settings/alert-score/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create'
      path: '/create'
      fullPath: '/$accountId/vulnerabilities/dashboards/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create'
      path: '/create'
      fullPath: '/$accountId/vulnerabilities/reports/create'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings'
      path: '/exceptions-settings'
      fullPath: '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses'
      path: '/exceptions-statuses'
      fullPath: '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity'
      path: '/severity'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/severity'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses'
      path: '/tickets-statuses'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$'
      path: '/exceptions-settings/$'
      fullPath: '/$accountId/vulnerabilities/settings/exceptions-settings/$'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$'
      path: '/tickets-statuses/$'
      fullPath: '/$accountId/vulnerabilities/settings/tickets-statuses/$'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/assets/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/'
      path: '/'
      fullPath: '/$accountId/assets/reports/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/assets/visual/': {
      id: '/_breadcrumbsLayout/$accountId/assets/assets/visual/'
      path: '/'
      fullPath: '/$accountId/assets/assets/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/'
      path: '/'
      fullPath: '/$accountId/assets/assets/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/create/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/create/'
      path: '/'
      fullPath: '/$accountId/assets/policies/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/'
      path: '/'
      fullPath: '/$accountId/assets/policy-violations/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/'
      path: '/'
      fullPath: '/$accountId/assets/policy-violations/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/'
      path: '/'
      fullPath: '/$accountId/assets/settings/easm-settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/'
      path: '/'
      fullPath: '/$accountId/assets/settings/rule-set/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/'
      path: '/'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/'
      path: '/'
      fullPath: '/$accountId/assets/settings/tickets-statuses/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/'
      path: '/'
      fullPath: '/$accountId/assets/settings/ui-config/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/users/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/users/$id/'
      path: '/'
      fullPath: '/$accountId/assets/users/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/users/visual/': {
      id: '/_breadcrumbsLayout/$accountId/assets/users/visual/'
      path: '/'
      fullPath: '/$accountId/assets/users/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/': {
      id: '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/'
      path: '/'
      fullPath: '/$accountId/assets/violation-tickets/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/'
      path: '/'
      fullPath: '/$accountId/assets/violation-tickets/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/detections/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/'
      path: '/'
      fullPath: '/$accountId/detections/reports/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/alerts/visual/': {
      id: '/_breadcrumbsLayout/$accountId/detections/alerts/visual/'
      path: '/'
      fullPath: '/$accountId/detections/alerts/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/'
      path: '/'
      fullPath: '/$accountId/detections/alerts/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts/create/': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts/create/'
      path: '/'
      fullPath: '/$accountId/detections/global-scripts/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/incidents/visual/': {
      id: '/_breadcrumbsLayout/$accountId/detections/incidents/visual/'
      path: '/'
      fullPath: '/$accountId/detections/incidents/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/'
      path: '/'
      fullPath: '/$accountId/detections/incidents/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/'
      path: '/'
      fullPath: '/$accountId/detections/lookup-tables/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/pivot/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/pivot/$id/'
      path: '/'
      fullPath: '/$accountId/detections/pivot/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/create/': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/create/'
      path: '/'
      fullPath: '/$accountId/detections/rules/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/logs/': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/logs/'
      path: '/'
      fullPath: '/$accountId/detections/rules/logs/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/'
      path: '/'
      fullPath: '/$accountId/detections/settings/rule-set/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/'
      path: '/'
      fullPath: '/$accountId/detections/settings/tickets-statuses/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/'
      path: '/'
      fullPath: '/$accountId/detections/settings/ui-config/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/explore/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/'
      path: '/'
      fullPath: '/$accountId/explore/reports/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/identities/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/'
      path: '/'
      fullPath: '/$accountId/identities/reports/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/'
      path: '/'
      fullPath: '/$accountId/identities/alerts/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/': {
      id: '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/'
      path: '/'
      fullPath: '/$accountId/identities/identity-findings/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/': {
      id: '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/'
      path: '/'
      fullPath: '/$accountId/identities/identity-findings/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/incidents/visual/': {
      id: '/_breadcrumbsLayout/$accountId/identities/incidents/visual/'
      path: '/'
      fullPath: '/$accountId/identities/incidents/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/'
      path: '/'
      fullPath: '/$accountId/identities/incidents/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/': {
      id: '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/'
      path: '/'
      fullPath: '/$accountId/identities/settings/itdr-config/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/': {
      id: '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/'
      path: '/settings/ui-config'
      fullPath: '/$accountId/identities/settings/ui-config'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/tenants/$id/': {
      id: '/_breadcrumbsLayout/$accountId/identities/tenants/$id/'
      path: '/$id'
      fullPath: '/$accountId/identities/tenants/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/users/$id/': {
      id: '/_breadcrumbsLayout/$accountId/identities/users/$id/'
      path: '/'
      fullPath: '/$accountId/identities/users/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/users/visual/': {
      id: '/_breadcrumbsLayout/$accountId/identities/users/visual/'
      path: '/'
      fullPath: '/$accountId/identities/users/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/incidents/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/'
      path: '/'
      fullPath: '/$accountId/incidents/reports/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/incidents/visual/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/incidents/visual/'
      path: '/'
      fullPath: '/$accountId/incidents/incidents/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/'
      path: '/'
      fullPath: '/$accountId/incidents/incidents/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/pivot/$id/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/pivot/$id/'
      path: '/'
      fullPath: '/$accountId/incidents/pivot/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/rule-set/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/tickets-statuses/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/ui-config/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/'
      path: '/'
      fullPath: '/$accountId/platform/measurements/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/'
      path: '/'
      fullPath: '/$accountId/platform/data-entities/data-entities/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/'
      path: '/'
      fullPath: '/$accountId/platform/data-entities/fields/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-purge/runs/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-purge/runs/'
      path: '/'
      fullPath: '/$accountId/platform/data-purge/runs/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/'
      path: '/'
      fullPath: '/$accountId/platform/data-purge/{-$projId}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/easm-settings/create/': {
      id: '/_breadcrumbsLayout/$accountId/platform/easm-settings/create/'
      path: '/'
      fullPath: '/$accountId/platform/easm-settings/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/runs/': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/runs/'
      path: '/'
      fullPath: '/$accountId/platform/model-management/runs/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/'
      path: '/'
      fullPath: '/$accountId/platform/model-management/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/': {
      id: '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/'
      path: '/'
      fullPath: '/$accountId/platform/overview/health-dashboard/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/'
      path: '/'
      fullPath: '/$accountId/platform/relations/{-$relationId}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/'
      path: '/'
      fullPath: '/$accountId/platform/scanner-activation/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/create/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/create/'
      path: '/'
      fullPath: '/$accountId/platform/sources/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/create/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/create/'
      path: '/'
      fullPath: '/$accountId/platform/targets/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/risk360/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/'
      path: '/'
      fullPath: '/$accountId/risk360/factor-rules/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/'
      path: '/'
      fullPath: '/$accountId/risk360/factor-rules/runs/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factors/visual/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factors/visual/'
      path: '/'
      fullPath: '/$accountId/risk360/factors/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/'
      path: '/'
      fullPath: '/$accountId/risk360/factors/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/account-settings/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/account-settings/audit/'
      path: '/'
      fullPath: '/$accountId/settings/account-settings/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts/create/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts/create/'
      path: '/'
      fullPath: '/$accountId/settings/all-accounts/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users/create/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users/create/'
      path: '/'
      fullPath: '/$accountId/settings/all-users/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/'
      path: '/'
      fullPath: '/$accountId/settings/global-factor-rules/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/'
      path: '/'
      fullPath: '/$accountId/settings/permissions/content-permissions/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles/': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles/'
      path: '/'
      fullPath: '/$accountId/settings/permissions/roles/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/'
      path: '/'
      fullPath: '/$accountId/settings/profile-settings/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management/create/': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management/create/'
      path: '/'
      fullPath: '/$accountId/settings/user-management/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/threats/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/'
      path: '/'
      fullPath: '/$accountId/threats/reports/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/alerts/visual/': {
      id: '/_breadcrumbsLayout/$accountId/threats/alerts/visual/'
      path: '/'
      fullPath: '/$accountId/threats/alerts/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/'
      path: '/'
      fullPath: '/$accountId/threats/alerts/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/assets/visual/': {
      id: '/_breadcrumbsLayout/$accountId/threats/assets/visual/'
      path: '/'
      fullPath: '/$accountId/threats/assets/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/'
      path: '/'
      fullPath: '/$accountId/threats/assets/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/overview/': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/overview/'
      path: '/'
      fullPath: '/$accountId/threats/incidents/overview/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/visual/': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/visual/'
      path: '/'
      fullPath: '/$accountId/threats/incidents/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/'
      path: '/'
      fullPath: '/$accountId/threats/incidents/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/'
      path: '/'
      fullPath: '/$accountId/threats/settings/Incident-rules/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/severity/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/severity/'
      path: '/'
      fullPath: '/$accountId/threats/settings/severity/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/'
      path: '/'
      fullPath: '/$accountId/threats/settings/tickets-statuses/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/'
      path: '/'
      fullPath: '/$accountId/threats/settings/ui-config/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/users/$id/': {
      id: '/_breadcrumbsLayout/$accountId/threats/users/$id/'
      path: '/'
      fullPath: '/$accountId/threats/users/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/users/visual/': {
      id: '/_breadcrumbsLayout/$accountId/threats/users/visual/'
      path: '/'
      fullPath: '/$accountId/threats/users/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/dashboards/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/reports/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/assets/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/assets/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/exceptions/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/findings/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/findings/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/pivot/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/exceptions/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/score/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/ui-config/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/tickets/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/tickets/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/assets/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/assets/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/assets/reports/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/assets/reports/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/assets/policies/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}'
      path: '/$id/{-$ruleIndex}'
      fullPath: '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}'
      path: '/create/{-$ruleIndex}'
      fullPath: '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path'
      path: '/audit/$path'
      fullPath: '/$accountId/assets/settings/ui-config/audit/$path'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/detections/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/detections/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/detections/reports/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/detections/reports/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/detections/global-scripts/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/detections/lookup-tables/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/detections/rules/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex'
      path: '/$ruleIndex'
      fullPath: '/$accountId/detections/settings/rule-set/$id/$ruleIndex'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id'
      path: '/audit/$id'
      fullPath: '/$accountId/detections/settings/rule-set/audit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex'
      path: '/$ruleIndex'
      fullPath: '/$accountId/detections/settings/rule-set/create/$ruleIndex'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path'
      path: '/audit/$path'
      fullPath: '/$accountId/detections/settings/ui-config/audit/$path'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/explore/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/explore/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/explore/reports/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/explore/reports/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/identities/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/identities/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/identities/reports/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/identities/reports/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/incidents/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/incidents/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/incidents/reports/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/incidents/reports/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex'
      path: '/$ruleIndex'
      fullPath: '/$accountId/incidents/settings/rule-set/$id/$ruleIndex'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/incidents/settings/rule-set/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex'
      path: '/$ruleIndex'
      fullPath: '/$accountId/incidents/settings/rule-set/create/$ruleIndex'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path'
      path: '/audit/$path'
      fullPath: '/$accountId/incidents/settings/ui-config/audit/$path'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName'
      path: '/edit/$systemName'
      fullPath: '/$accountId/platform/measurements/edit/$systemName'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore'
      path: '/$projId/explore'
      fullPath: '/$accountId/platform/data-entities/data-entities/$projId/explore'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}'
      path: '/$projId/{-$ruleId}'
      fullPath: '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId': {
      id: '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId'
      path: '/edit/$id/$organizationId'
      fullPath: '/$accountId/platform/easm-settings/edit/$id/$organizationId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type'
      path: '/$id/$mappingPath/$type'
      fullPath: '/$accountId/platform/sources/$id/$mappingPath/$type'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}'
      path: '/$type/{-$previewId}'
      fullPath: '/$accountId/platform/sources/create/$type/{-$previewId}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId'
      path: '/$previewId'
      fullPath: '/$accountId/platform/sources/edit/$id/$previewId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/platform/sources/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/platform/targets/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/risk360/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/risk360/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/risk360/factor-rules/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/settings/all-accounts/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/settings/all-users/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/settings/global-factor-rules/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/settings/permissions/roles/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/settings/user-management/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/threats/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/threats/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/threats/reports/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/threats/reports/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/threats/settings/Incident-rules/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}'
      path: '/settings/alert-score/{-$projection}/{-$field}'
      fullPath: '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId'
      path: '/audit/$automationId'
      fullPath: '/$accountId/threats/settings/severity/audit/$automationId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path'
      path: '/audit/$path'
      fullPath: '/$accountId/threats/settings/ui-config/audit/$path'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/vulnerabilities/dashboards/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/vulnerabilities/dashboards/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id'
      path: '/edit/$id'
      fullPath: '/$accountId/vulnerabilities/reports/edit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id'
      path: '/runs/$id'
      fullPath: '/$accountId/vulnerabilities/reports/runs/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit'
      path: '/$id/audit'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}'
      path: '/$id/{-$ruleIndex}'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}'
      path: '/create/{-$ruleIndex}'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path'
      path: '/audit/$path'
      fullPath: '/$accountId/vulnerabilities/settings/score/audit/$path'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}'
      path: '/sla/{-$id}'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path'
      path: '/audit/$path'
      fullPath: '/$accountId/vulnerabilities/settings/ui-config/audit/$path'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/assets/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/'
      path: '/'
      fullPath: '/$accountId/assets/reports/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/'
      path: '/'
      fullPath: '/$accountId/assets/policies/duplicate/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/'
      path: '/'
      fullPath: '/$accountId/assets/policies/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/'
      path: '/'
      fullPath: '/$accountId/assets/policies/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/'
      path: '/'
      fullPath: '/$accountId/assets/settings/easm-settings/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/'
      path: '/'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/detections/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/'
      path: '/'
      fullPath: '/$accountId/detections/reports/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/'
      path: '/'
      fullPath: '/$accountId/detections/global-scripts/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/'
      path: '/'
      fullPath: '/$accountId/detections/lookup-tables/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/'
      path: '/'
      fullPath: '/$accountId/detections/rules/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/'
      path: '/'
      fullPath: '/$accountId/detections/rules/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/'
      path: '/'
      fullPath: '/$accountId/detections/settings/rule-set/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/'
      path: '/'
      fullPath: '/$accountId/detections/settings/rule-set/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/explore/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/'
      path: '/'
      fullPath: '/$accountId/explore/reports/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/identities/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/'
      path: '/'
      fullPath: '/$accountId/identities/reports/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/incidents/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/'
      path: '/'
      fullPath: '/$accountId/incidents/reports/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/rule-set/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/rule-set/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/'
      path: '/'
      fullPath: '/$accountId/platform/measurements/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/'
      path: '/'
      fullPath: '/$accountId/platform/asset-aging/{-$mode}/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/'
      path: '/'
      fullPath: '/$accountId/platform/formatting-rules/{-$mode}/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/'
      path: '/'
      fullPath: '/$accountId/platform/model-management/{-$id}/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/': {
      id: '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/'
      path: '/'
      fullPath: '/$accountId/platform/model-management/{-$id}/preview/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/'
      path: '/'
      fullPath: '/$accountId/platform/scanner-activation/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/'
      path: '/'
      fullPath: '/$accountId/platform/scanner-activation/sensors/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/'
      path: '/'
      fullPath: '/$accountId/platform/sources/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/'
      path: '/'
      fullPath: '/$accountId/platform/sources/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/'
      path: '/'
      fullPath: '/$accountId/platform/targets/activityLog/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/create/$type/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/create/$type/'
      path: '/'
      fullPath: '/$accountId/platform/targets/create/$type/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/'
      path: '/'
      fullPath: '/$accountId/platform/targets/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/'
      path: '/'
      fullPath: '/$accountId/platform/targets/mapping/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/'
      path: '/'
      fullPath: '/$accountId/platform/workflows/audit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/risk360/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/'
      path: '/'
      fullPath: '/$accountId/risk360/factor-rules/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/'
      path: '/'
      fullPath: '/$accountId/settings/all-accounts/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/'
      path: '/'
      fullPath: '/$accountId/settings/all-users/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/'
      path: '/'
      fullPath: '/$accountId/settings/global-factor-rules/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/'
      path: '/'
      fullPath: '/$accountId/settings/permissions/roles/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/'
      path: '/'
      fullPath: '/$accountId/settings/user-management/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/threats/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/'
      path: '/'
      fullPath: '/$accountId/threats/reports/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/'
      path: '/'
      fullPath: '/$accountId/threats/incidents/incident-list/visual/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/'
      path: '/'
      fullPath: '/$accountId/threats/incidents/incident-list/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/'
      path: '/'
      fullPath: '/$accountId/threats/settings/Incident-rules/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/'
      path: '/'
      fullPath: '/$accountId/threats/settings/alert-score/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/dashboards/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/reports/create/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/severity/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/assets/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/assets/reports/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId'
      path: '/edit/$id/$organizationId'
      fullPath: '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit'
      path: '/audit'
      fullPath: '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
      path: '/automations/{-$id}/{-$ruleIndex}'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/detections/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/detections/reports/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/explore/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/explore/reports/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/identities/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/identities/reports/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/incidents/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/incidents/reports/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit'
      path: '/audit'
      fullPath: '/$accountId/platform/sources/$id/$mappingPath/$type/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview'
      path: '/preview'
      fullPath: '/$accountId/platform/sources/$id/$mappingPath/$type/preview'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping'
      path: '/audit/$idMapping'
      fullPath: '/$accountId/platform/targets/mapping/$id/audit/$idMapping'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/risk360/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit'
      path: '/{-$mode}/{-$id}/audit'
      fullPath: '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/settings/permissions/roles/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/threats/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/threats/reports/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/threats/settings/Incident-rules/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/vulnerabilities/dashboards/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit'
      path: '/audit'
      fullPath: '/$accountId/vulnerabilities/reports/edit/$id/audit'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId'
      path: '/audit/$automationId'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
      path: '/automations/{-$id}/{-$ruleIndex}'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/assets/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/assets/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/'
      path: '/'
      fullPath: '/$accountId/assets/reports/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/'
      path: '/'
      fullPath: '/$accountId/assets/reports/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/assets/policies/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/'
      path: '/'
      fullPath: '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/'
      path: '/'
      fullPath: '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/'
      path: '/'
      fullPath: '/$accountId/assets/settings/ui-config/audit/$path/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/detections/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/detections/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/'
      path: '/'
      fullPath: '/$accountId/detections/reports/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/'
      path: '/'
      fullPath: '/$accountId/detections/reports/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/detections/global-scripts/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/detections/lookup-tables/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/detections/rules/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/'
      path: '/'
      fullPath: '/$accountId/detections/settings/rule-set/$id/$ruleIndex/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/'
      path: '/'
      fullPath: '/$accountId/detections/settings/rule-set/audit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/'
      path: '/'
      fullPath: '/$accountId/detections/settings/rule-set/create/$ruleIndex/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/': {
      id: '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/'
      path: '/'
      fullPath: '/$accountId/detections/settings/ui-config/audit/$path/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/explore/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/explore/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/'
      path: '/'
      fullPath: '/$accountId/explore/reports/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/'
      path: '/'
      fullPath: '/$accountId/explore/reports/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/identities/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/identities/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/'
      path: '/'
      fullPath: '/$accountId/identities/reports/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/'
      path: '/'
      fullPath: '/$accountId/identities/reports/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/': {
      id: '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/'
      path: '/settings/ui-config/audit/$path'
      fullPath: '/$accountId/identities/settings/ui-config/audit/$path'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/incidents/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/incidents/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/'
      path: '/'
      fullPath: '/$accountId/incidents/reports/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/'
      path: '/'
      fullPath: '/$accountId/incidents/reports/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/rule-set/$id/$ruleIndex/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/rule-set/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/rule-set/create/$ruleIndex/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/'
      path: '/'
      fullPath: '/$accountId/incidents/settings/ui-config/audit/$path/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/'
      path: '/'
      fullPath: '/$accountId/platform/measurements/edit/$systemName/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/'
      path: '/'
      fullPath: '/$accountId/platform/data-entities/data-entities/$projId/explore/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/'
      path: '/'
      fullPath: '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId/': {
      id: '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId/'
      path: '/'
      fullPath: '/$accountId/platform/easm-settings/edit/$id/$organizationId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/'
      path: '/'
      fullPath: '/$accountId/platform/sources/$id/$mappingPath/$type/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/'
      path: '/'
      fullPath: '/$accountId/platform/sources/create/$type/{-$previewId}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/'
      path: '/'
      fullPath: '/$accountId/platform/sources/edit/$id/$previewId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/platform/sources/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/platform/targets/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/risk360/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/risk360/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/risk360/factor-rules/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/settings/all-accounts/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/settings/all-users/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/settings/global-factor-rules/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/'
      path: '/{-$mode}/{-$id}'
      fullPath: '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/'
      path: '/'
      fullPath: '/$accountId/settings/permissions/roles/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/settings/user-management/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/threats/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/threats/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/'
      path: '/'
      fullPath: '/$accountId/threats/reports/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/'
      path: '/'
      fullPath: '/$accountId/threats/reports/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/'
      path: '/'
      fullPath: '/$accountId/threats/settings/Incident-rules/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/'
      path: '/'
      fullPath: '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/'
      path: '/'
      fullPath: '/$accountId/threats/settings/severity/audit/$automationId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/'
      path: '/'
      fullPath: '/$accountId/threats/settings/ui-config/audit/$path/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/dashboards/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/dashboards/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/reports/edit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/reports/runs/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/score/audit/$path/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/ui-config/audit/$path/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id'
      path: '/audit/$id'
      fullPath: '/$accountId/platform/measurements/edit/$systemName/audit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id'
      path: '/set/$fieldName/audit/$id'
      fullPath: '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}'
      path: '/set/$fieldName/{-$mode}/{-$id}'
      fullPath: '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId'
      path: '/audit/$automationId'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/assets/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/assets/reports/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/'
      path: '/'
      fullPath: '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/'
      path: '/'
      fullPath: '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
      path: '/'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/detections/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/detections/reports/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/explore/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/explore/reports/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/identities/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/identities/reports/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/incidents/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/incidents/reports/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/'
      path: '/'
      fullPath: '/$accountId/platform/sources/$id/$mappingPath/$type/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/': {
      id: '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/'
      path: '/'
      fullPath: '/$accountId/platform/sources/$id/$mappingPath/$type/preview/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/': {
      id: '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/'
      path: '/'
      fullPath: '/$accountId/platform/targets/mapping/$id/audit/$idMapping/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteImport
    }
    '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/risk360/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/'
      path: '/'
      fullPath: '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/settings/permissions/roles/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/threats/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/threats/reports/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/threats/settings/Incident-rules/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/dashboards/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/reports/edit/$id/audit/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
      path: '/audit/$automationId'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
      path: '/audit/$automationId'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/'
      path: '/'
      fullPath: '/$accountId/platform/measurements/edit/$systemName/audit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/'
      path: '/'
      fullPath: '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/': {
      id: '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/'
      path: '/'
      fullPath: '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/': {
      id: '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
      path: '/'
      fullPath: '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport
    }
    '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/': {
      id: '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
      path: '/'
      fullPath: '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
      preLoaderRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexImport
      parentRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteImport
    }
  }
}

// Create and export the route tree

interface BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute
  BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute
}

const BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsUsersRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute:
      BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdAssetsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsUsersRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute
  BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdAssetsRouteRouteChildren: BreadcrumbsLayoutAccountIdAssetsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsUsersRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute:
      BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute,
    BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdAssetsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdAssetsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdAssetsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute,
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute,
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsPivotRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute
  BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute,
    BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute,
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute,
    BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute
}

const BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute:
      BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdDetectionsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsPivotRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute
  BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdDetectionsRouteRouteChildren: BreadcrumbsLayoutAccountIdDetectionsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsPivotRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsRulesRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute:
      BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute,
    BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdDetectionsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdDetectionsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdDetectionsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute:
      BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreEntitiesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreLogsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreLogsIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreLogsIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreLogsRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreLogsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreLogsIndexRoute:
      BreadcrumbsLayoutAccountIdExploreLogsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreLogsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreLogsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreLogsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdExploreRouteRouteChildren {
  BreadcrumbsLayoutAccountIdExploreEntitiesRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreLogsRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreLogsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdExploreIndexLazyRoute
}

const BreadcrumbsLayoutAccountIdExploreRouteRouteChildren: BreadcrumbsLayoutAccountIdExploreRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdExploreEntitiesRouteRoute:
      BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreLogsRouteRoute:
      BreadcrumbsLayoutAccountIdExploreLogsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreIndexLazyRoute:
      BreadcrumbsLayoutAccountIdExploreIndexLazyRoute,
  }

const BreadcrumbsLayoutAccountIdExploreRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdExploreRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdExploreRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute:
      BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute:
      BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute
  BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute,
    BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIdentitiesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute
  BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute
}

const BreadcrumbsLayoutAccountIdIdentitiesRouteRouteChildren: BreadcrumbsLayoutAccountIdIdentitiesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute,
    BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute:
      BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIdentitiesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIdentitiesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIdentitiesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsPivotRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute,
    BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute
}

const BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute:
      BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdIncidentsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdIncidentsPivotRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute
  BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdIncidentsRouteRouteChildren: BreadcrumbsLayoutAccountIdIncidentsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdIncidentsPivotRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute:
      BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute,
    BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdIncidentsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdIncidentsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdIncidentsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute
  BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute,
    BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRisk360RouteRouteChildren {
  BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute: typeof BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute
  BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdRisk360RouteRouteChildren: BreadcrumbsLayoutAccountIdRisk360RouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute:
      BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute,
    BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRoute:
      BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdRisk360RouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRisk360RouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRisk360RouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsDashboardRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsUsersRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute,
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute,
    BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute,
    BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute
}

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute,
  }

const BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdThreatsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdThreatsDashboardRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsUsersRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsIndexRoute: typeof BreadcrumbsLayoutAccountIdThreatsIndexRoute
  BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdThreatsRouteRouteChildren: BreadcrumbsLayoutAccountIdThreatsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdThreatsDashboardRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsUsersRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsIndexRoute:
      BreadcrumbsLayoutAccountIdThreatsIndexRoute,
    BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdThreatsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdThreatsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdThreatsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteChildren: BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute,
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformAliasesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute
  BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute
  BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute
  BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute
  BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute
  BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute,
    BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute
  BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute,
    BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute,
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsIconsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsQueryRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute
  BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute,
    BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteChildren: BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute,
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute: typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute
}

const BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteChildren: BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute:
      BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdPlatformRouteChildren {
  BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRoute: typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdPlatformRouteChildren: BreadcrumbsLayoutAccountIdPlatformRouteChildren =
  {
    BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRoute:
      BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdPlatformRouteWithChildren =
  BreadcrumbsLayoutAccountIdPlatformRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdPlatformRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute,
    BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute
}

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute,
  }

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteChildren {
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteChildren: BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute,
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteChildren,
  )

interface BreadcrumbsLayoutAccountIdRouteRouteChildren {
  BreadcrumbsLayoutAccountIdAssetsRouteRoute: typeof BreadcrumbsLayoutAccountIdAssetsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdDetectionsRouteRoute: typeof BreadcrumbsLayoutAccountIdDetectionsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdExploreRouteRoute: typeof BreadcrumbsLayoutAccountIdExploreRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIdentitiesRouteRoute: typeof BreadcrumbsLayoutAccountIdIdentitiesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIncidentsRouteRoute: typeof BreadcrumbsLayoutAccountIdIncidentsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdRisk360RouteRoute: typeof BreadcrumbsLayoutAccountIdRisk360RouteRouteWithChildren
  BreadcrumbsLayoutAccountIdThreatsRouteRoute: typeof BreadcrumbsLayoutAccountIdThreatsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute: typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdIndexLazyRoute: typeof BreadcrumbsLayoutAccountIdIndexLazyRoute
  BreadcrumbsLayoutAccountIdPlatformAliasesRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRoute: typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsIconsRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsQueryRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdCaasmSplatRoute: typeof BreadcrumbsLayoutAccountIdCaasmSplatRoute
  BreadcrumbsLayoutAccountIdPlatformRoute: typeof BreadcrumbsLayoutAccountIdPlatformRouteWithChildren
  BreadcrumbsLayoutAccountIdTicketsSplatRoute: typeof BreadcrumbsLayoutAccountIdTicketsSplatRoute
  BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteWithChildren
  BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRoute: typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteWithChildren
}

const BreadcrumbsLayoutAccountIdRouteRouteChildren: BreadcrumbsLayoutAccountIdRouteRouteChildren =
  {
    BreadcrumbsLayoutAccountIdAssetsRouteRoute:
      BreadcrumbsLayoutAccountIdAssetsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdDetectionsRouteRoute:
      BreadcrumbsLayoutAccountIdDetectionsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdExploreRouteRoute:
      BreadcrumbsLayoutAccountIdExploreRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIdentitiesRouteRoute:
      BreadcrumbsLayoutAccountIdIdentitiesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIncidentsRouteRoute:
      BreadcrumbsLayoutAccountIdIncidentsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdRisk360RouteRoute:
      BreadcrumbsLayoutAccountIdRisk360RouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdThreatsRouteRoute:
      BreadcrumbsLayoutAccountIdThreatsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRoute:
      BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdIndexLazyRoute:
      BreadcrumbsLayoutAccountIdIndexLazyRoute,
    BreadcrumbsLayoutAccountIdPlatformAliasesRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformSourcesRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformTargetsRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRoute:
      BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsIconsRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsQueryRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdCaasmSplatRoute:
      BreadcrumbsLayoutAccountIdCaasmSplatRoute,
    BreadcrumbsLayoutAccountIdPlatformRoute:
      BreadcrumbsLayoutAccountIdPlatformRouteWithChildren,
    BreadcrumbsLayoutAccountIdTicketsSplatRoute:
      BreadcrumbsLayoutAccountIdTicketsSplatRoute,
    BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteWithChildren,
    BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRoute:
      BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteWithChildren,
  }

const BreadcrumbsLayoutAccountIdRouteRouteWithChildren =
  BreadcrumbsLayoutAccountIdRouteRoute._addFileChildren(
    BreadcrumbsLayoutAccountIdRouteRouteChildren,
  )

interface BreadcrumbsLayoutRouteChildren {
  BreadcrumbsLayoutAccountIdRouteRoute: typeof BreadcrumbsLayoutAccountIdRouteRouteWithChildren
}

const BreadcrumbsLayoutRouteChildren: BreadcrumbsLayoutRouteChildren = {
  BreadcrumbsLayoutAccountIdRouteRoute:
    BreadcrumbsLayoutAccountIdRouteRouteWithChildren,
}

const BreadcrumbsLayoutRouteWithChildren =
  BreadcrumbsLayoutRoute._addFileChildren(BreadcrumbsLayoutRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof BreadcrumbsLayoutRouteWithChildren
  '/error-process-request': typeof ErrorProcessRequestRoute
  '/$accountId': typeof BreadcrumbsLayoutAccountIdRouteRouteWithChildren
  '/$accountId/assets': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteWithChildren
  '/$accountId/detections': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteWithChildren
  '/$accountId/explore': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteWithChildren
  '/$accountId/identities': typeof BreadcrumbsLayoutAccountIdIdentitiesRouteRouteWithChildren
  '/$accountId/incidents': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteWithChildren
  '/$accountId/risk360': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteWithChildren
  '/$accountId/threats': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteWithChildren
  '/$accountId/vulnerabilities': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteWithChildren
  '/$accountId/': typeof BreadcrumbsLayoutAccountIdIndexLazyRoute
  '/$accountId/assets/asset-inventory': typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteWithChildren
  '/$accountId/assets/policies': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteWithChildren
  '/$accountId/assets/policy-compliance': typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteWithChildren
  '/$accountId/assets/settings': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteWithChildren
  '/$accountId/assets/tool-coverage-and-gap': typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteWithChildren
  '/$accountId/assets/users': typeof BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteWithChildren
  '/$accountId/detections/global-scripts': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteWithChildren
  '/$accountId/detections/lookup-tables': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteWithChildren
  '/$accountId/detections/pivot': typeof BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteWithChildren
  '/$accountId/detections/rules': typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteWithChildren
  '/$accountId/detections/settings': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteWithChildren
  '/$accountId/explore/entities': typeof BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteWithChildren
  '/$accountId/explore/logs': typeof BreadcrumbsLayoutAccountIdExploreLogsRouteRouteWithChildren
  '/$accountId/identities/alerts': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteWithChildren
  '/$accountId/identities/identity-findings': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteWithChildren
  '/$accountId/identities/overview': typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteWithChildren
  '/$accountId/identities/remediation': typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteWithChildren
  '/$accountId/identities/tenants': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteWithChildren
  '/$accountId/identities/users': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteWithChildren
  '/$accountId/incidents/pivot': typeof BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteWithChildren
  '/$accountId/incidents/settings': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteWithChildren
  '/$accountId/platform/aliases': typeof BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteWithChildren
  '/$accountId/platform/authentication-sources': typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteWithChildren
  '/$accountId/platform/easm-settings': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteWithChildren
  '/$accountId/platform/risk-score': typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteWithChildren
  '/$accountId/platform/scanner-activation': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteWithChildren
  '/$accountId/platform/sources': typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteWithChildren
  '/$accountId/platform/targets': typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteWithChildren
  '/$accountId/platform/workflows': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteWithChildren
  '/$accountId/risk360/factor-rules': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteWithChildren
  '/$accountId/settings/account-settings': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteWithChildren
  '/$accountId/settings/account-usage': typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteWithChildren
  '/$accountId/settings/all-accounts': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteWithChildren
  '/$accountId/settings/all-users': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteWithChildren
  '/$accountId/settings/backoffice-actions': typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteWithChildren
  '/$accountId/settings/global-factor-rules': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteWithChildren
  '/$accountId/settings/icons': typeof BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteWithChildren
  '/$accountId/settings/profile-settings': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteWithChildren
  '/$accountId/settings/query': typeof BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteWithChildren
  '/$accountId/settings/risk360-backoffice-actions': typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteWithChildren
  '/$accountId/settings/user-management': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteWithChildren
  '/$accountId/threats/dashboard': typeof BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteWithChildren
  '/$accountId/threats/users': typeof BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteWithChildren
  '/$accountId/vulnerabilities/asset-coverage': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteWithChildren
  '/$accountId/vulnerabilities/explore': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteWithChildren
  '/$accountId/vulnerabilities/overview': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteWithChildren
  '/$accountId/vulnerabilities/pivot': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteWithChildren
  '/$accountId/vulnerabilities/remediation': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteWithChildren
  '/$accountId/vulnerabilities/risk': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteWithChildren
  '/$accountId/vulnerabilities/roi': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteWithChildren
  '/$accountId/caasm/$': typeof BreadcrumbsLayoutAccountIdCaasmSplatRoute
  '/$accountId/platform': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteWithChildren
  '/$accountId/tickets/$': typeof BreadcrumbsLayoutAccountIdTicketsSplatRoute
  '/$accountId/threats/': typeof BreadcrumbsLayoutAccountIdThreatsIndexRoute
  '/$accountId/assets/': typeof BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute
  '/$accountId/detections/': typeof BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute
  '/$accountId/explore/': typeof BreadcrumbsLayoutAccountIdExploreIndexLazyRoute
  '/$accountId/identities/': typeof BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute
  '/$accountId/incidents/': typeof BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute
  '/$accountId/risk360/': typeof BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute
  '/$accountId/vulnerabilities/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute
  '/$accountId/assets/dashboards': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/assets/reports': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/$accountId/assets/assets/visual': typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteWithChildren
  '/$accountId/assets/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteWithChildren
  '/$accountId/assets/policies/create': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteWithChildren
  '/$accountId/assets/policy-violations/visual': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteWithChildren
  '/$accountId/assets/policy-violations/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteWithChildren
  '/$accountId/assets/settings/easm-settings': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteWithChildren
  '/$accountId/assets/settings/rule-set': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteWithChildren
  '/$accountId/assets/settings/ticket-lifecycle': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteWithChildren
  '/$accountId/assets/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteWithChildren
  '/$accountId/assets/settings/ui-config': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteWithChildren
  '/$accountId/assets/users/$id': typeof BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteWithChildren
  '/$accountId/assets/users/visual': typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteWithChildren
  '/$accountId/assets/violation-tickets/visual': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteWithChildren
  '/$accountId/assets/violation-tickets/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteWithChildren
  '/$accountId/detections/dashboards': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/detections/reports': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/$accountId/detections/alerts/visual': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteWithChildren
  '/$accountId/detections/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteWithChildren
  '/$accountId/detections/global-scripts/create': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteWithChildren
  '/$accountId/detections/incidents/visual': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteWithChildren
  '/$accountId/detections/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteWithChildren
  '/$accountId/detections/lookup-tables/create': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteWithChildren
  '/$accountId/detections/pivot/$id': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteWithChildren
  '/$accountId/detections/rules/create': typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteWithChildren
  '/$accountId/detections/rules/logs': typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteWithChildren
  '/$accountId/detections/settings/rule-set': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteWithChildren
  '/$accountId/detections/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteWithChildren
  '/$accountId/detections/settings/ui-config': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteWithChildren
  '/$accountId/explore/dashboards': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/explore/reports': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/$accountId/identities/dashboards': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/identities/reports': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/$accountId/identities/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteWithChildren
  '/$accountId/identities/identity-findings/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteWithChildren
  '/$accountId/identities/identity-findings/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteWithChildren
  '/$accountId/identities/incidents/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteWithChildren
  '/$accountId/identities/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteWithChildren
  '/$accountId/identities/settings/itdr-config': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteWithChildren
  '/$accountId/identities/users/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteWithChildren
  '/$accountId/identities/users/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteWithChildren
  '/$accountId/incidents/dashboards': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/incidents/reports': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/$accountId/incidents/incidents/visual': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteWithChildren
  '/$accountId/incidents/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteWithChildren
  '/$accountId/incidents/pivot/$id': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteWithChildren
  '/$accountId/incidents/settings/rule-set': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteWithChildren
  '/$accountId/incidents/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteWithChildren
  '/$accountId/incidents/settings/ui-config': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteWithChildren
  '/$accountId/platform/measurements': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteWithChildren
  '/$accountId/platform/data-entities/data-entities': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteWithChildren
  '/$accountId/platform/data-entities/fields': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteWithChildren
  '/$accountId/platform/data-purge/runs': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteWithChildren
  '/$accountId/platform/data-purge/{-$projId}': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteWithChildren
  '/$accountId/platform/easm-settings/create': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteWithChildren
  '/$accountId/platform/model-management/runs': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteWithChildren
  '/$accountId/platform/model-management/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteWithChildren
  '/$accountId/platform/overview/health-dashboard': typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteWithChildren
  '/$accountId/platform/relations/{-$relationId}': typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteWithChildren
  '/$accountId/platform/scanner-activation/create': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteWithChildren
  '/$accountId/platform/sources/create': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteWithChildren
  '/$accountId/platform/targets/create': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteWithChildren
  '/$accountId/risk360/dashboards': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/risk360/factor-rules/create': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteWithChildren
  '/$accountId/risk360/factor-rules/runs': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteWithChildren
  '/$accountId/risk360/factors/visual': typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteWithChildren
  '/$accountId/risk360/factors/{-$id}': typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteWithChildren
  '/$accountId/settings/account-settings/audit': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteWithChildren
  '/$accountId/settings/all-accounts/create': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteWithChildren
  '/$accountId/settings/all-users/create': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteWithChildren
  '/$accountId/settings/global-factor-rules/create': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteWithChildren
  '/$accountId/settings/permissions/content-permissions': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteWithChildren
  '/$accountId/settings/permissions/roles': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteWithChildren
  '/$accountId/settings/profile-settings/audit': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteWithChildren
  '/$accountId/settings/user-management/create': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteWithChildren
  '/$accountId/threats/dashboards': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/threats/reports': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/$accountId/threats/alerts/visual': typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteWithChildren
  '/$accountId/threats/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteWithChildren
  '/$accountId/threats/assets/visual': typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteWithChildren
  '/$accountId/threats/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteWithChildren
  '/$accountId/threats/incidents/overview': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteWithChildren
  '/$accountId/threats/incidents/visual': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteWithChildren
  '/$accountId/threats/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteWithChildren
  '/$accountId/threats/settings/Incident-rules': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteWithChildren
  '/$accountId/threats/settings/severity': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteWithChildren
  '/$accountId/threats/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteWithChildren
  '/$accountId/threats/settings/ui-config': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteWithChildren
  '/$accountId/threats/users/$id': typeof BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteWithChildren
  '/$accountId/threats/users/visual': typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteWithChildren
  '/$accountId/vulnerabilities/dashboards': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/$accountId/vulnerabilities/reports': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/$accountId/vulnerabilities/assets/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteWithChildren
  '/$accountId/vulnerabilities/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/exceptions/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/findings/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteWithChildren
  '/$accountId/vulnerabilities/findings/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/pivot/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/exceptions': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/rule-set': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/score': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/severity-sla': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/ticket-lifecycle': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/ui-config': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteWithChildren
  '/$accountId/vulnerabilities/tickets/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteWithChildren
  '/$accountId/vulnerabilities/tickets/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteWithChildren
  '/$accountId/assets/asset-inventory/': typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute
  '/$accountId/assets/policies/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute
  '/$accountId/assets/policy-compliance/': typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute
  '/$accountId/assets/tool-coverage-and-gap/': typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute
  '/$accountId/assets/users/': typeof BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute
  '/$accountId/detections/global-scripts/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute
  '/$accountId/detections/lookup-tables/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute
  '/$accountId/detections/pivot/': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute
  '/$accountId/detections/rules/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute
  '/$accountId/explore/entities/': typeof BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute
  '/$accountId/explore/logs/': typeof BreadcrumbsLayoutAccountIdExploreLogsIndexRoute
  '/$accountId/identities/alerts/': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute
  '/$accountId/identities/identity-findings/': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute
  '/$accountId/identities/tenants/': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute
  '/$accountId/identities/users/': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute
  '/$accountId/incidents/pivot/': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute
  '/$accountId/platform/aliases/': typeof BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute
  '/$accountId/platform/authentication-sources/': typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute
  '/$accountId/platform/easm-settings/': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute
  '/$accountId/platform/risk-score/': typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute
  '/$accountId/platform/scanner-activation/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute
  '/$accountId/platform/sources/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute
  '/$accountId/platform/targets/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute
  '/$accountId/platform/workflows/': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute
  '/$accountId/risk360/factor-rules/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute
  '/$accountId/settings/account-settings/': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute
  '/$accountId/settings/account-usage/': typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute
  '/$accountId/settings/all-accounts/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute
  '/$accountId/settings/all-users/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute
  '/$accountId/settings/backoffice-actions/': typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute
  '/$accountId/settings/global-factor-rules/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute
  '/$accountId/settings/icons/': typeof BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute
  '/$accountId/settings/profile-settings/': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute
  '/$accountId/settings/query/': typeof BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute
  '/$accountId/settings/risk360-backoffice-actions/': typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute
  '/$accountId/settings/user-management/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute
  '/$accountId/threats/dashboard/': typeof BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute
  '/$accountId/threats/users/': typeof BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute
  '/$accountId/vulnerabilities/asset-coverage/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute
  '/$accountId/vulnerabilities/explore/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute
  '/$accountId/vulnerabilities/overview/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute
  '/$accountId/vulnerabilities/pivot/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute
  '/$accountId/vulnerabilities/remediation/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute
  '/$accountId/vulnerabilities/risk/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute
  '/$accountId/vulnerabilities/roi/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute
  '/$accountId/assets/settings/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute
  '/$accountId/detections/settings/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute
  '/$accountId/identities/overview/': typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute
  '/$accountId/identities/remediation/': typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute
  '/$accountId/incidents/settings/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute
  '/$accountId/vulnerabilities/settings/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute
  '/$accountId/assets/dashboards/create': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/assets/reports/create': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/$accountId/assets/policies/duplicate/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteWithChildren
  '/$accountId/assets/policies/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteWithChildren
  '/$accountId/assets/policies/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteWithChildren
  '/$accountId/assets/settings/easm-settings/create': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteWithChildren
  '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren
  '/$accountId/detections/dashboards/create': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/detections/reports/create': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/$accountId/detections/global-scripts/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteWithChildren
  '/$accountId/detections/lookup-tables/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteWithChildren
  '/$accountId/detections/rules/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteWithChildren
  '/$accountId/detections/rules/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteWithChildren
  '/$accountId/detections/settings/rule-set/$id': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteWithChildren
  '/$accountId/detections/settings/rule-set/create': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteWithChildren
  '/$accountId/explore/dashboards/create': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/explore/reports/create': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/$accountId/identities/dashboards/create': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/identities/reports/create': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/$accountId/incidents/dashboards/create': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/incidents/reports/create': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/$accountId/incidents/settings/rule-set/$id': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteWithChildren
  '/$accountId/incidents/settings/rule-set/create': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteWithChildren
  '/$accountId/platform/measurements/create': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteWithChildren
  '/$accountId/platform/asset-aging/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteWithChildren
  '/$accountId/platform/formatting-rules/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteWithChildren
  '/$accountId/platform/model-management/{-$id}/audit': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteWithChildren
  '/$accountId/platform/model-management/{-$id}/preview': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteWithChildren
  '/$accountId/platform/scanner-activation/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteWithChildren
  '/$accountId/platform/scanner-activation/sensors/$id': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteWithChildren
  '/$accountId/platform/sources/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteWithChildren
  '/$accountId/platform/sources/runs/$id': typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteWithChildren
  '/$accountId/platform/targets/activityLog/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteWithChildren
  '/$accountId/platform/targets/create/$type': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteWithChildren
  '/$accountId/platform/targets/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteWithChildren
  '/$accountId/platform/targets/mapping/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteWithChildren
  '/$accountId/platform/workflows/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteWithChildren
  '/$accountId/risk360/dashboards/create': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/risk360/factor-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteWithChildren
  '/$accountId/settings/all-accounts/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteWithChildren
  '/$accountId/settings/all-users/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteWithChildren
  '/$accountId/settings/global-factor-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteWithChildren
  '/$accountId/settings/permissions/roles/create': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteWithChildren
  '/$accountId/settings/user-management/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteWithChildren
  '/$accountId/threats/dashboards/create': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/threats/reports/create': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/$accountId/threats/incidents/incident-list/visual': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteWithChildren
  '/$accountId/threats/incidents/incident-list/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteWithChildren
  '/$accountId/threats/settings/Incident-rules/create': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteWithChildren
  '/$accountId/threats/settings/alert-score/audit': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteWithChildren
  '/$accountId/vulnerabilities/dashboards/create': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/$accountId/vulnerabilities/reports/create': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/severity-sla/severity': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/exceptions-settings/$': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute
  '/$accountId/vulnerabilities/settings/tickets-statuses/$': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute
  '/$accountId/assets/dashboards/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/assets/reports/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/assets/assets/visual/': typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute
  '/$accountId/assets/assets/{-$id}/': typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute
  '/$accountId/assets/policies/create/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute
  '/$accountId/assets/policy-violations/visual/': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute
  '/$accountId/assets/policy-violations/{-$id}/': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute
  '/$accountId/assets/settings/easm-settings/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute
  '/$accountId/assets/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute
  '/$accountId/assets/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute
  '/$accountId/assets/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute
  '/$accountId/assets/users/$id/': typeof BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute
  '/$accountId/assets/users/visual/': typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute
  '/$accountId/assets/violation-tickets/visual/': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute
  '/$accountId/assets/violation-tickets/{-$id}/': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute
  '/$accountId/detections/dashboards/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/detections/reports/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/detections/alerts/visual/': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute
  '/$accountId/detections/alerts/{-$id}/': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute
  '/$accountId/detections/global-scripts/create/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute
  '/$accountId/detections/incidents/visual/': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute
  '/$accountId/detections/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute
  '/$accountId/detections/lookup-tables/create/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute
  '/$accountId/detections/pivot/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute
  '/$accountId/detections/rules/create/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute
  '/$accountId/detections/rules/logs/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute
  '/$accountId/detections/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute
  '/$accountId/detections/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute
  '/$accountId/detections/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute
  '/$accountId/explore/dashboards/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/explore/reports/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/identities/dashboards/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/identities/reports/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/identities/alerts/{-$id}/': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute
  '/$accountId/identities/identity-findings/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute
  '/$accountId/identities/identity-findings/visual/': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute
  '/$accountId/identities/incidents/visual/': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute
  '/$accountId/identities/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute
  '/$accountId/identities/settings/itdr-config/': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute
  '/$accountId/identities/settings/ui-config': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute
  '/$accountId/identities/tenants/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute
  '/$accountId/identities/users/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute
  '/$accountId/identities/users/visual/': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute
  '/$accountId/incidents/dashboards/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/incidents/reports/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/incidents/incidents/visual/': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute
  '/$accountId/incidents/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute
  '/$accountId/incidents/pivot/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute
  '/$accountId/incidents/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute
  '/$accountId/incidents/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute
  '/$accountId/incidents/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute
  '/$accountId/platform/measurements/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute
  '/$accountId/platform/data-entities/data-entities/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute
  '/$accountId/platform/data-entities/fields/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute
  '/$accountId/platform/data-purge/runs/': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute
  '/$accountId/platform/data-purge/{-$projId}/': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute
  '/$accountId/platform/easm-settings/create/': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute
  '/$accountId/platform/model-management/runs/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute
  '/$accountId/platform/model-management/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute
  '/$accountId/platform/overview/health-dashboard/': typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute
  '/$accountId/platform/relations/{-$relationId}/': typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute
  '/$accountId/platform/scanner-activation/create/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute
  '/$accountId/platform/sources/create/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute
  '/$accountId/platform/targets/create/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute
  '/$accountId/risk360/dashboards/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/risk360/factor-rules/create/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute
  '/$accountId/risk360/factor-rules/runs/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute
  '/$accountId/risk360/factors/visual/': typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute
  '/$accountId/risk360/factors/{-$id}/': typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute
  '/$accountId/settings/account-settings/audit/': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute
  '/$accountId/settings/all-accounts/create/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute
  '/$accountId/settings/all-users/create/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute
  '/$accountId/settings/global-factor-rules/create/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute
  '/$accountId/settings/permissions/content-permissions/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute
  '/$accountId/settings/permissions/roles/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute
  '/$accountId/settings/profile-settings/audit/': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute
  '/$accountId/settings/user-management/create/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute
  '/$accountId/threats/dashboards/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/threats/reports/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/threats/alerts/visual/': typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute
  '/$accountId/threats/alerts/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute
  '/$accountId/threats/assets/visual/': typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute
  '/$accountId/threats/assets/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute
  '/$accountId/threats/incidents/overview/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute
  '/$accountId/threats/incidents/visual/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute
  '/$accountId/threats/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute
  '/$accountId/threats/settings/Incident-rules/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute
  '/$accountId/threats/settings/severity/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute
  '/$accountId/threats/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute
  '/$accountId/threats/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute
  '/$accountId/threats/users/$id/': typeof BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute
  '/$accountId/threats/users/visual/': typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute
  '/$accountId/vulnerabilities/dashboards/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/vulnerabilities/reports/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/vulnerabilities/assets/visual/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute
  '/$accountId/vulnerabilities/assets/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute
  '/$accountId/vulnerabilities/exceptions/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute
  '/$accountId/vulnerabilities/findings/visual/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute
  '/$accountId/vulnerabilities/findings/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute
  '/$accountId/vulnerabilities/pivot/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute
  '/$accountId/vulnerabilities/settings/exceptions/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute
  '/$accountId/vulnerabilities/settings/score/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute
  '/$accountId/vulnerabilities/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute
  '/$accountId/vulnerabilities/tickets/visual/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute
  '/$accountId/vulnerabilities/tickets/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute
  '/$accountId/assets/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/assets/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/assets/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/$accountId/assets/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/$accountId/assets/policies/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteWithChildren
  '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/$accountId/assets/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/$accountId/detections/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/detections/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/detections/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/$accountId/detections/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/$accountId/detections/global-scripts/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteWithChildren
  '/$accountId/detections/lookup-tables/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteWithChildren
  '/$accountId/detections/rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteWithChildren
  '/$accountId/detections/settings/rule-set/$id/$ruleIndex': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/$accountId/detections/settings/rule-set/audit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteWithChildren
  '/$accountId/detections/settings/rule-set/create/$ruleIndex': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/$accountId/detections/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/$accountId/explore/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/explore/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/explore/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/$accountId/explore/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/$accountId/identities/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/identities/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/identities/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/$accountId/identities/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/$accountId/incidents/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/incidents/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/incidents/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/$accountId/incidents/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/$accountId/incidents/settings/rule-set/$id/$ruleIndex': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/$accountId/incidents/settings/rule-set/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteWithChildren
  '/$accountId/incidents/settings/rule-set/create/$ruleIndex': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/$accountId/incidents/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/$accountId/platform/measurements/edit/$systemName': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteWithChildren
  '/$accountId/platform/data-entities/data-entities/$projId/explore': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteWithChildren
  '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteWithChildren
  '/$accountId/platform/easm-settings/edit/$id/$organizationId': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteWithChildren
  '/$accountId/platform/sources/$id/$mappingPath/$type': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteWithChildren
  '/$accountId/platform/sources/create/$type/{-$previewId}': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteWithChildren
  '/$accountId/platform/sources/edit/$id/$previewId': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteWithChildren
  '/$accountId/platform/sources/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteWithChildren
  '/$accountId/platform/targets/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteWithChildren
  '/$accountId/risk360/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/risk360/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/risk360/factor-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteWithChildren
  '/$accountId/settings/all-accounts/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteWithChildren
  '/$accountId/settings/all-users/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteWithChildren
  '/$accountId/settings/global-factor-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteWithChildren
  '/$accountId/settings/permissions/roles/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteWithChildren
  '/$accountId/settings/user-management/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteWithChildren
  '/$accountId/threats/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/threats/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/threats/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/$accountId/threats/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/$accountId/threats/settings/Incident-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteWithChildren
  '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteWithChildren
  '/$accountId/threats/settings/severity/audit/$automationId': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteWithChildren
  '/$accountId/threats/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/$accountId/vulnerabilities/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/rule-set/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/score/audit/$path': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteWithChildren
  '/$accountId/assets/dashboards/create/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/assets/reports/create/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/assets/policies/duplicate/$id/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute
  '/$accountId/assets/policies/edit/$id/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute
  '/$accountId/assets/policies/runs/$id/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute
  '/$accountId/assets/settings/easm-settings/create/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute
  '/$accountId/detections/dashboards/create/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/detections/reports/create/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/detections/global-scripts/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute
  '/$accountId/detections/lookup-tables/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute
  '/$accountId/detections/rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute
  '/$accountId/detections/rules/runs/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute
  '/$accountId/detections/settings/rule-set/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute
  '/$accountId/detections/settings/rule-set/create/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute
  '/$accountId/explore/dashboards/create/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/explore/reports/create/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/identities/dashboards/create/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/identities/reports/create/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/incidents/dashboards/create/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/incidents/reports/create/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/incidents/settings/rule-set/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute
  '/$accountId/incidents/settings/rule-set/create/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute
  '/$accountId/platform/measurements/create/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute
  '/$accountId/platform/asset-aging/{-$mode}/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute
  '/$accountId/platform/formatting-rules/{-$mode}/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute
  '/$accountId/platform/model-management/{-$id}/audit/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute
  '/$accountId/platform/model-management/{-$id}/preview/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute
  '/$accountId/platform/scanner-activation/edit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute
  '/$accountId/platform/scanner-activation/sensors/$id/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute
  '/$accountId/platform/sources/edit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute
  '/$accountId/platform/sources/runs/$id/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute
  '/$accountId/platform/targets/activityLog/$id/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute
  '/$accountId/platform/targets/create/$type/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute
  '/$accountId/platform/targets/edit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute
  '/$accountId/platform/targets/mapping/$id/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute
  '/$accountId/platform/workflows/audit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute
  '/$accountId/risk360/dashboards/create/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/risk360/factor-rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute
  '/$accountId/settings/all-accounts/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute
  '/$accountId/settings/all-users/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute
  '/$accountId/settings/global-factor-rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute
  '/$accountId/settings/permissions/roles/create/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute
  '/$accountId/settings/user-management/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute
  '/$accountId/threats/dashboards/create/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/threats/reports/create/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/threats/incidents/incident-list/visual/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute
  '/$accountId/threats/incidents/incident-list/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute
  '/$accountId/threats/settings/Incident-rules/create/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute
  '/$accountId/threats/settings/alert-score/audit/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute
  '/$accountId/vulnerabilities/dashboards/create/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/vulnerabilities/reports/create/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute
  '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/severity/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute
  '/$accountId/assets/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/assets/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteWithChildren
  '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteWithChildren
  '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren
  '/$accountId/detections/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/detections/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/$accountId/explore/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/explore/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/$accountId/identities/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/identities/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/$accountId/incidents/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/incidents/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/$accountId/platform/sources/$id/$mappingPath/$type/audit': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteWithChildren
  '/$accountId/platform/sources/$id/$mappingPath/$type/preview': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteWithChildren
  '/$accountId/platform/targets/mapping/$id/audit/$idMapping': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteWithChildren
  '/$accountId/risk360/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteWithChildren
  '/$accountId/settings/permissions/roles/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteWithChildren
  '/$accountId/threats/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/threats/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/$accountId/threats/settings/Incident-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteWithChildren
  '/$accountId/vulnerabilities/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/$accountId/vulnerabilities/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren
  '/$accountId/assets/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/assets/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/assets/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/assets/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/assets/policies/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute
  '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/assets/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/detections/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/detections/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/detections/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/detections/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/detections/global-scripts/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute
  '/$accountId/detections/lookup-tables/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute
  '/$accountId/detections/rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute
  '/$accountId/detections/settings/rule-set/$id/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/detections/settings/rule-set/audit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute
  '/$accountId/detections/settings/rule-set/create/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/detections/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/explore/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/explore/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/explore/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/explore/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/identities/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/identities/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/identities/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/identities/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/identities/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute
  '/$accountId/incidents/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/incidents/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/incidents/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/incidents/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/incidents/settings/rule-set/$id/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/incidents/settings/rule-set/$id/audit/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute
  '/$accountId/incidents/settings/rule-set/create/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/incidents/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/platform/measurements/edit/$systemName/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute
  '/$accountId/platform/data-entities/data-entities/$projId/explore/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute
  '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute
  '/$accountId/platform/easm-settings/edit/$id/$organizationId/': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute
  '/$accountId/platform/sources/$id/$mappingPath/$type/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute
  '/$accountId/platform/sources/create/$type/{-$previewId}/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute
  '/$accountId/platform/sources/edit/$id/$previewId/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute
  '/$accountId/platform/sources/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute
  '/$accountId/platform/targets/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute
  '/$accountId/risk360/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/risk360/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/risk360/factor-rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute
  '/$accountId/settings/all-accounts/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute
  '/$accountId/settings/all-users/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute
  '/$accountId/settings/global-factor-rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute
  '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute
  '/$accountId/settings/permissions/roles/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute
  '/$accountId/settings/user-management/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute
  '/$accountId/threats/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/threats/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/threats/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/threats/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/threats/settings/Incident-rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute
  '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute
  '/$accountId/threats/settings/severity/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute
  '/$accountId/threats/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/vulnerabilities/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/vulnerabilities/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/vulnerabilities/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/vulnerabilities/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set/$id/audit/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/vulnerabilities/settings/score/audit/$path/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute
  '/$accountId/vulnerabilities/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute
  '/$accountId/platform/measurements/edit/$systemName/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteWithChildren
  '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteWithChildren
  '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteWithChildren
  '/$accountId/assets/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/assets/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute
  '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  '/$accountId/detections/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/detections/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/explore/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/explore/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/identities/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/identities/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/incidents/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/incidents/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/platform/sources/$id/$mappingPath/$type/audit/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute
  '/$accountId/platform/sources/$id/$mappingPath/$type/preview/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute
  '/$accountId/platform/targets/mapping/$id/audit/$idMapping/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute
  '/$accountId/risk360/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute
  '/$accountId/settings/permissions/roles/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute
  '/$accountId/threats/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/threats/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/threats/settings/Incident-rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute
  '/$accountId/vulnerabilities/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/vulnerabilities/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren
  '/$accountId/platform/measurements/edit/$systemName/audit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute
  '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute
  '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof BreadcrumbsLayoutRouteWithChildren
  '/error-process-request': typeof ErrorProcessRequestRoute
  '/$accountId': typeof BreadcrumbsLayoutAccountIdIndexLazyRoute
  '/$accountId/assets': typeof BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute
  '/$accountId/caasm/$': typeof BreadcrumbsLayoutAccountIdCaasmSplatRoute
  '/$accountId/detections': typeof BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute
  '/$accountId/explore': typeof BreadcrumbsLayoutAccountIdExploreIndexLazyRoute
  '/$accountId/incidents': typeof BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute
  '/$accountId/platform': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteWithChildren
  '/$accountId/risk360': typeof BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute
  '/$accountId/threats': typeof BreadcrumbsLayoutAccountIdThreatsIndexRoute
  '/$accountId/tickets/$': typeof BreadcrumbsLayoutAccountIdTicketsSplatRoute
  '/$accountId/vulnerabilities': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute
  '/$accountId/identities': typeof BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute
  '/$accountId/assets/asset-inventory': typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute
  '/$accountId/assets/policies': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute
  '/$accountId/assets/policy-compliance': typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute
  '/$accountId/assets/tool-coverage-and-gap': typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute
  '/$accountId/assets/users': typeof BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute
  '/$accountId/detections/global-scripts': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute
  '/$accountId/detections/lookup-tables': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute
  '/$accountId/detections/pivot': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute
  '/$accountId/detections/rules': typeof BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute
  '/$accountId/explore/entities': typeof BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute
  '/$accountId/explore/logs': typeof BreadcrumbsLayoutAccountIdExploreLogsIndexRoute
  '/$accountId/identities/alerts': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute
  '/$accountId/identities/identity-findings': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute
  '/$accountId/identities/tenants': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute
  '/$accountId/identities/users': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute
  '/$accountId/incidents/pivot': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute
  '/$accountId/platform/aliases': typeof BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute
  '/$accountId/platform/authentication-sources': typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute
  '/$accountId/platform/easm-settings': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute
  '/$accountId/platform/risk-score': typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute
  '/$accountId/platform/scanner-activation': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute
  '/$accountId/platform/sources': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute
  '/$accountId/platform/targets': typeof BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute
  '/$accountId/platform/workflows': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute
  '/$accountId/risk360/factor-rules': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute
  '/$accountId/settings/account-settings': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute
  '/$accountId/settings/account-usage': typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute
  '/$accountId/settings/all-accounts': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute
  '/$accountId/settings/all-users': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute
  '/$accountId/settings/backoffice-actions': typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute
  '/$accountId/settings/global-factor-rules': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute
  '/$accountId/settings/icons': typeof BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute
  '/$accountId/settings/profile-settings': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute
  '/$accountId/settings/query': typeof BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute
  '/$accountId/settings/risk360-backoffice-actions': typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute
  '/$accountId/settings/user-management': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute
  '/$accountId/threats/dashboard': typeof BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute
  '/$accountId/threats/users': typeof BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute
  '/$accountId/vulnerabilities/asset-coverage': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute
  '/$accountId/vulnerabilities/explore': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute
  '/$accountId/vulnerabilities/overview': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute
  '/$accountId/vulnerabilities/pivot': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute
  '/$accountId/vulnerabilities/remediation': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute
  '/$accountId/vulnerabilities/risk': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute
  '/$accountId/vulnerabilities/roi': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute
  '/$accountId/assets/settings': typeof BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute
  '/$accountId/detections/settings': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute
  '/$accountId/identities/overview': typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute
  '/$accountId/identities/remediation': typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute
  '/$accountId/incidents/settings': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute
  '/$accountId/vulnerabilities/settings': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute
  '/$accountId/vulnerabilities/settings/exceptions-settings/$': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute
  '/$accountId/vulnerabilities/settings/tickets-statuses/$': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute
  '/$accountId/assets/dashboards': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/assets/reports': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/assets/assets/visual': typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute
  '/$accountId/assets/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute
  '/$accountId/assets/policies/create': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute
  '/$accountId/assets/policy-violations/visual': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute
  '/$accountId/assets/policy-violations/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute
  '/$accountId/assets/settings/easm-settings': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute
  '/$accountId/assets/settings/rule-set': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute
  '/$accountId/assets/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute
  '/$accountId/assets/settings/ui-config': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute
  '/$accountId/assets/users/$id': typeof BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute
  '/$accountId/assets/users/visual': typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute
  '/$accountId/assets/violation-tickets/visual': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute
  '/$accountId/assets/violation-tickets/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute
  '/$accountId/detections/dashboards': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/detections/reports': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/detections/alerts/visual': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute
  '/$accountId/detections/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute
  '/$accountId/detections/global-scripts/create': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute
  '/$accountId/detections/incidents/visual': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute
  '/$accountId/detections/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute
  '/$accountId/detections/lookup-tables/create': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute
  '/$accountId/detections/pivot/$id': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute
  '/$accountId/detections/rules/create': typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute
  '/$accountId/detections/rules/logs': typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute
  '/$accountId/detections/settings/rule-set': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute
  '/$accountId/detections/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute
  '/$accountId/detections/settings/ui-config': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute
  '/$accountId/explore/dashboards': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/explore/reports': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/identities/dashboards': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/identities/reports': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/identities/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute
  '/$accountId/identities/identity-findings/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute
  '/$accountId/identities/identity-findings/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute
  '/$accountId/identities/incidents/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute
  '/$accountId/identities/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute
  '/$accountId/identities/settings/itdr-config': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute
  '/$accountId/identities/settings/ui-config': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute
  '/$accountId/identities/tenants/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute
  '/$accountId/identities/users/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute
  '/$accountId/identities/users/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute
  '/$accountId/incidents/dashboards': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/incidents/reports': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/incidents/incidents/visual': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute
  '/$accountId/incidents/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute
  '/$accountId/incidents/pivot/$id': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute
  '/$accountId/incidents/settings/rule-set': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute
  '/$accountId/incidents/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute
  '/$accountId/incidents/settings/ui-config': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute
  '/$accountId/platform/measurements': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute
  '/$accountId/platform/data-entities/data-entities': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute
  '/$accountId/platform/data-entities/fields': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute
  '/$accountId/platform/data-purge/runs': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute
  '/$accountId/platform/data-purge/{-$projId}': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute
  '/$accountId/platform/easm-settings/create': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute
  '/$accountId/platform/model-management/runs': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute
  '/$accountId/platform/model-management/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute
  '/$accountId/platform/overview/health-dashboard': typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute
  '/$accountId/platform/relations/{-$relationId}': typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute
  '/$accountId/platform/scanner-activation/create': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute
  '/$accountId/platform/sources/create': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute
  '/$accountId/platform/targets/create': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute
  '/$accountId/risk360/dashboards': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/risk360/factor-rules/create': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute
  '/$accountId/risk360/factor-rules/runs': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute
  '/$accountId/risk360/factors/visual': typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute
  '/$accountId/risk360/factors/{-$id}': typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute
  '/$accountId/settings/account-settings/audit': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute
  '/$accountId/settings/all-accounts/create': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute
  '/$accountId/settings/all-users/create': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute
  '/$accountId/settings/global-factor-rules/create': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute
  '/$accountId/settings/permissions/content-permissions': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute
  '/$accountId/settings/permissions/roles': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute
  '/$accountId/settings/profile-settings/audit': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute
  '/$accountId/settings/user-management/create': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute
  '/$accountId/threats/dashboards': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/threats/reports': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/threats/alerts/visual': typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute
  '/$accountId/threats/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute
  '/$accountId/threats/assets/visual': typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute
  '/$accountId/threats/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute
  '/$accountId/threats/incidents/overview': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute
  '/$accountId/threats/incidents/visual': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute
  '/$accountId/threats/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute
  '/$accountId/threats/settings/Incident-rules': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute
  '/$accountId/threats/settings/severity': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute
  '/$accountId/threats/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute
  '/$accountId/threats/settings/ui-config': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute
  '/$accountId/threats/users/$id': typeof BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute
  '/$accountId/threats/users/visual': typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute
  '/$accountId/vulnerabilities/dashboards': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute
  '/$accountId/vulnerabilities/reports': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute
  '/$accountId/vulnerabilities/assets/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute
  '/$accountId/vulnerabilities/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute
  '/$accountId/vulnerabilities/exceptions/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute
  '/$accountId/vulnerabilities/findings/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute
  '/$accountId/vulnerabilities/findings/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute
  '/$accountId/vulnerabilities/pivot/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute
  '/$accountId/vulnerabilities/settings/exceptions': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute
  '/$accountId/vulnerabilities/settings/score': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute
  '/$accountId/vulnerabilities/settings/ui-config': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute
  '/$accountId/vulnerabilities/tickets/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute
  '/$accountId/vulnerabilities/tickets/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute
  '/$accountId/assets/dashboards/create': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/assets/reports/create': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/assets/policies/duplicate/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute
  '/$accountId/assets/policies/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute
  '/$accountId/assets/policies/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute
  '/$accountId/assets/settings/easm-settings/create': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute
  '/$accountId/detections/dashboards/create': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/detections/reports/create': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/detections/global-scripts/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute
  '/$accountId/detections/lookup-tables/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute
  '/$accountId/detections/rules/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute
  '/$accountId/detections/rules/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute
  '/$accountId/detections/settings/rule-set/$id': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute
  '/$accountId/detections/settings/rule-set/create': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute
  '/$accountId/explore/dashboards/create': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/explore/reports/create': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/identities/dashboards/create': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/identities/reports/create': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/incidents/dashboards/create': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/incidents/reports/create': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/incidents/settings/rule-set/$id': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute
  '/$accountId/incidents/settings/rule-set/create': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute
  '/$accountId/platform/measurements/create': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute
  '/$accountId/platform/asset-aging/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute
  '/$accountId/platform/formatting-rules/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute
  '/$accountId/platform/model-management/{-$id}/audit': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute
  '/$accountId/platform/model-management/{-$id}/preview': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute
  '/$accountId/platform/scanner-activation/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute
  '/$accountId/platform/scanner-activation/sensors/$id': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute
  '/$accountId/platform/sources/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute
  '/$accountId/platform/sources/runs/$id': typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute
  '/$accountId/platform/targets/activityLog/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute
  '/$accountId/platform/targets/create/$type': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute
  '/$accountId/platform/targets/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute
  '/$accountId/platform/targets/mapping/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute
  '/$accountId/platform/workflows/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute
  '/$accountId/risk360/dashboards/create': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/risk360/factor-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute
  '/$accountId/settings/all-accounts/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute
  '/$accountId/settings/all-users/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute
  '/$accountId/settings/global-factor-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute
  '/$accountId/settings/permissions/roles/create': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute
  '/$accountId/settings/user-management/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute
  '/$accountId/threats/dashboards/create': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/threats/reports/create': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/threats/incidents/incident-list/visual': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute
  '/$accountId/threats/incidents/incident-list/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute
  '/$accountId/threats/settings/Incident-rules/create': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute
  '/$accountId/threats/settings/alert-score/audit': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute
  '/$accountId/vulnerabilities/dashboards/create': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/$accountId/vulnerabilities/reports/create': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute
  '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute
  '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/severity': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute
  '/$accountId/assets/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/assets/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/assets/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/assets/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/assets/policies/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute
  '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/assets/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/detections/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/detections/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/detections/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/detections/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/detections/global-scripts/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute
  '/$accountId/detections/lookup-tables/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute
  '/$accountId/detections/rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute
  '/$accountId/detections/settings/rule-set/$id/$ruleIndex': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/detections/settings/rule-set/audit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute
  '/$accountId/detections/settings/rule-set/create/$ruleIndex': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/detections/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/explore/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/explore/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/explore/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/explore/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/identities/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/identities/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/identities/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/identities/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/identities/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute
  '/$accountId/incidents/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/incidents/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/incidents/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/incidents/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/incidents/settings/rule-set/$id/$ruleIndex': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/incidents/settings/rule-set/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute
  '/$accountId/incidents/settings/rule-set/create/$ruleIndex': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/incidents/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/platform/measurements/edit/$systemName': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute
  '/$accountId/platform/data-entities/data-entities/$projId/explore': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute
  '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute
  '/$accountId/platform/easm-settings/edit/$id/$organizationId': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute
  '/$accountId/platform/sources/$id/$mappingPath/$type': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute
  '/$accountId/platform/sources/create/$type/{-$previewId}': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute
  '/$accountId/platform/sources/edit/$id/$previewId': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute
  '/$accountId/platform/sources/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute
  '/$accountId/platform/targets/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute
  '/$accountId/risk360/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/risk360/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/risk360/factor-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute
  '/$accountId/settings/all-accounts/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute
  '/$accountId/settings/all-users/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute
  '/$accountId/settings/global-factor-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute
  '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute
  '/$accountId/settings/permissions/roles/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute
  '/$accountId/settings/user-management/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute
  '/$accountId/threats/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/threats/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/threats/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/threats/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/threats/settings/Incident-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute
  '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute
  '/$accountId/threats/settings/severity/audit/$automationId': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute
  '/$accountId/threats/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute
  '/$accountId/vulnerabilities/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/$accountId/vulnerabilities/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/$accountId/vulnerabilities/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute
  '/$accountId/vulnerabilities/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute
  '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute
  '/$accountId/vulnerabilities/settings/score/audit/$path': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute
  '/$accountId/vulnerabilities/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute
  '/$accountId/assets/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/assets/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute
  '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  '/$accountId/detections/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/detections/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/explore/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/explore/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/identities/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/identities/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/incidents/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/incidents/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/platform/sources/$id/$mappingPath/$type/audit': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute
  '/$accountId/platform/sources/$id/$mappingPath/$type/preview': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute
  '/$accountId/platform/targets/mapping/$id/audit/$idMapping': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute
  '/$accountId/risk360/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute
  '/$accountId/settings/permissions/roles/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute
  '/$accountId/threats/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/threats/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/threats/settings/Incident-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute
  '/$accountId/vulnerabilities/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/$accountId/vulnerabilities/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  '/$accountId/platform/measurements/edit/$systemName/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute
  '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute
  '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute
  '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute
  '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
  '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_breadcrumbsLayout': typeof BreadcrumbsLayoutRouteWithChildren
  '/error-process-request': typeof ErrorProcessRequestRoute
  '/_breadcrumbsLayout/$accountId': typeof BreadcrumbsLayoutAccountIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets': typeof BreadcrumbsLayoutAccountIdAssetsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections': typeof BreadcrumbsLayoutAccountIdDetectionsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore': typeof BreadcrumbsLayoutAccountIdExploreRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities': typeof BreadcrumbsLayoutAccountIdIdentitiesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents': typeof BreadcrumbsLayoutAccountIdIncidentsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360': typeof BreadcrumbsLayoutAccountIdRisk360RouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats': typeof BreadcrumbsLayoutAccountIdThreatsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/': typeof BreadcrumbsLayoutAccountIdIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/assets/asset-inventory': typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policies': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policy-compliance': typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap': typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/users': typeof BreadcrumbsLayoutAccountIdAssetsUsersRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/global-scripts': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/pivot': typeof BreadcrumbsLayoutAccountIdDetectionsPivotRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/rules': typeof BreadcrumbsLayoutAccountIdDetectionsRulesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/entities': typeof BreadcrumbsLayoutAccountIdExploreEntitiesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/logs': typeof BreadcrumbsLayoutAccountIdExploreLogsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/alerts': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/identity-findings': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/overview': typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/remediation': typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/tenants': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/users': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/pivot': typeof BreadcrumbsLayoutAccountIdIncidentsPivotRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/aliases': typeof BreadcrumbsLayoutAccountIdPlatformAliasesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/authentication-sources': typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/easm-settings': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/risk-score': typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources': typeof BreadcrumbsLayoutAccountIdPlatformSourcesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets': typeof BreadcrumbsLayoutAccountIdPlatformTargetsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/workflows': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/account-settings': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/account-usage': typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-accounts': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-users': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/backoffice-actions': typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/icons': typeof BreadcrumbsLayoutAccountIdSettingsIconsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/profile-settings': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/query': typeof BreadcrumbsLayoutAccountIdSettingsQueryRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions': typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/user-management': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/dashboard': typeof BreadcrumbsLayoutAccountIdThreatsDashboardRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/users': typeof BreadcrumbsLayoutAccountIdThreatsUsersRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/explore': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/overview': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/risk': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/roi': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/caasm/$': typeof BreadcrumbsLayoutAccountIdCaasmSplatRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform': typeof BreadcrumbsLayoutAccountIdPlatformRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/tickets/$': typeof BreadcrumbsLayoutAccountIdTicketsSplatRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/': typeof BreadcrumbsLayoutAccountIdThreatsIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/': typeof BreadcrumbsLayoutAccountIdAssetsIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/detections/': typeof BreadcrumbsLayoutAccountIdDetectionsIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/explore/': typeof BreadcrumbsLayoutAccountIdExploreIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/identities/': typeof BreadcrumbsLayoutAccountIdIdentitiesIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/incidents/': typeof BreadcrumbsLayoutAccountIdIncidentsIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/risk360/': typeof BreadcrumbsLayoutAccountIdRisk360IndexLazyRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/assets/visual': typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policies/create': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/ui-config': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/users/$id': typeof BreadcrumbsLayoutAccountIdAssetsUsersIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/users/visual': typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/alerts/visual': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/global-scripts/create': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/incidents/visual': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/pivot/$id': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/rules/create': typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/rules/logs': typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/ui-config': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/incidents/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/users/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/users/visual': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/incidents/visual': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/pivot/$id': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-entities/fields': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-purge/runs': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/easm-settings/create': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/model-management/runs': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard': typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}': typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/create': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets/create': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/factors/visual': typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}': typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/account-settings/audit': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-accounts/create': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-users/create': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/user-management/create': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/alerts/visual': typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/assets/visual': typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/incidents/overview': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/incidents/visual': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/severity': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses': typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/ui-config': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/users/$id': typeof BreadcrumbsLayoutAccountIdThreatsUsersIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/users/visual': typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/asset-inventory/': typeof BreadcrumbsLayoutAccountIdAssetsAssetInventoryIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policies/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policy-compliance/': typeof BreadcrumbsLayoutAccountIdAssetsPolicyComplianceIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/': typeof BreadcrumbsLayoutAccountIdAssetsToolCoverageAndGapIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/users/': typeof BreadcrumbsLayoutAccountIdAssetsUsersIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/global-scripts/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/pivot/': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/rules/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/entities/': typeof BreadcrumbsLayoutAccountIdExploreEntitiesIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/logs/': typeof BreadcrumbsLayoutAccountIdExploreLogsIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/alerts/': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/identity-findings/': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/tenants/': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/users/': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/pivot/': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/aliases/': typeof BreadcrumbsLayoutAccountIdPlatformAliasesIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/authentication-sources/': typeof BreadcrumbsLayoutAccountIdPlatformAuthenticationSourcesIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/easm-settings/': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/risk-score/': typeof BreadcrumbsLayoutAccountIdPlatformRiskScoreIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/workflows/': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/account-settings/': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/account-usage/': typeof BreadcrumbsLayoutAccountIdSettingsAccountUsageIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-accounts/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-users/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/backoffice-actions/': typeof BreadcrumbsLayoutAccountIdSettingsBackofficeActionsIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/icons/': typeof BreadcrumbsLayoutAccountIdSettingsIconsIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/profile-settings/': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/query/': typeof BreadcrumbsLayoutAccountIdSettingsQueryIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/': typeof BreadcrumbsLayoutAccountIdSettingsRisk360BackofficeActionsIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/user-management/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/dashboard/': typeof BreadcrumbsLayoutAccountIdThreatsDashboardIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/users/': typeof BreadcrumbsLayoutAccountIdThreatsUsersIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetCoverageIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/explore/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExploreIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/overview/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesOverviewIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRemediationIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/risk/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRiskIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/roi/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesRoiIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/identities/overview/': typeof BreadcrumbsLayoutAccountIdIdentitiesOverviewIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/identities/remediation/': typeof BreadcrumbsLayoutAccountIdIdentitiesRemediationIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsIndexLazyRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id': typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets/create/$type': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsSettingsSplatRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketsStatusesSplatRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/assets/visual/': typeof BreadcrumbsLayoutAccountIdAssetsAssetsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/': typeof BreadcrumbsLayoutAccountIdAssetsAssetsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policies/create/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/': typeof BreadcrumbsLayoutAccountIdAssetsPolicyViolationsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketsStatusesIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/users/$id/': typeof BreadcrumbsLayoutAccountIdAssetsUsersIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/users/visual/': typeof BreadcrumbsLayoutAccountIdAssetsUsersVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/': typeof BreadcrumbsLayoutAccountIdAssetsViolationTicketsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/alerts/visual/': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/': typeof BreadcrumbsLayoutAccountIdDetectionsAlertsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/global-scripts/create/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/incidents/visual/': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdDetectionsIncidentsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/pivot/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsPivotIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/rules/create/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/rules/logs/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesLogsIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsTicketsStatusesIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/': typeof BreadcrumbsLayoutAccountIdIdentitiesAlertsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/': typeof BreadcrumbsLayoutAccountIdIdentitiesIdentityFindingsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/incidents/visual/': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdIdentitiesIncidentsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsItdrConfigIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/tenants/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesTenantsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/users/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/users/visual/': typeof BreadcrumbsLayoutAccountIdIdentitiesUsersVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/incidents/visual/': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdIncidentsIncidentsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/pivot/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsPivotIdIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsTicketsStatusesIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-purge/runs/': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeRunsIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/': typeof BreadcrumbsLayoutAccountIdPlatformDataPurgeProjIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/easm-settings/create/': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/model-management/runs/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementRunsIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/': typeof BreadcrumbsLayoutAccountIdPlatformOverviewHealthDashboardIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/': typeof BreadcrumbsLayoutAccountIdPlatformRelationsRelationIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/create/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/create/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesRunsIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/factors/visual/': typeof BreadcrumbsLayoutAccountIdRisk360FactorsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/': typeof BreadcrumbsLayoutAccountIdRisk360FactorsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/account-settings/audit/': typeof BreadcrumbsLayoutAccountIdSettingsAccountSettingsAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-accounts/create/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-users/create/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/': typeof BreadcrumbsLayoutAccountIdSettingsProfileSettingsAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/user-management/create/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/alerts/visual/': typeof BreadcrumbsLayoutAccountIdThreatsAlertsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsAlertsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/assets/visual/': typeof BreadcrumbsLayoutAccountIdThreatsAssetsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsAssetsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/incidents/overview/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsOverviewIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/incidents/visual/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/severity/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsTicketsStatusesIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/users/$id/': typeof BreadcrumbsLayoutAccountIdThreatsUsersIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/users/visual/': typeof BreadcrumbsLayoutAccountIdThreatsUsersVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesAssetsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExceptionsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesFindingsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesPivotIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesTicketsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesDuplicateIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleTicketsStatusesIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformAssetAgingModeIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformFormattingRulesModeIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/': typeof BreadcrumbsLayoutAccountIdPlatformModelManagementIdPreviewIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/': typeof BreadcrumbsLayoutAccountIdPlatformScannerActivationSensorsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsActivityLogIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/create/$type/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsCreateTypeIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformWorkflowsAuditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListVisualIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/': typeof BreadcrumbsLayoutAccountIdThreatsIncidentsIncidentListIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsCreateIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsSettingsIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsExceptionsExceptionsStatusesIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleTicketsStatusesIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdAssetsPoliciesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetCreateRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsUiConfigAuditPathIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsGlobalScriptsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsLookupTablesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsRulesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetIdRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetAuditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsRuleSetCreateRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdDetectionsSettingsUiConfigAuditPathIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdIdentitiesSettingsUiConfigAuditPathIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsRuleSetCreateRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdIncidentsSettingsUiConfigAuditPathIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdExploreIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesDataEntitiesProjIdRuleIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId/': typeof BreadcrumbsLayoutAccountIdPlatformEasmSettingsEditIdOrganizationIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesCreateTypePreviewIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdPreviewIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdRisk360FactorRulesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsAllAccountsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsAllUsersEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsGlobalFactorRulesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsUserManagementEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsAlertScoreProjectionFieldIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsSeverityAuditAutomationIdIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsUiConfigAuditPathIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsRunsIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetIdRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsRuleSetCreateRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsScoreAuditPathIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsUiConfigAuditPathIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdAssetsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsEasmSettingsEditIdOrganizationIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsRuleSetIdRuleIndexAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdDetectionsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdExploreExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIdentitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdIncidentsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypeAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/': typeof BreadcrumbsLayoutAccountIdPlatformSourcesIdMappingPathTypePreviewIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/': typeof BreadcrumbsLayoutAccountIdPlatformTargetsMappingIdAuditIdMappingIndexRoute
  '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdRisk360ExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsContentPermissionsModeIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdSettingsPermissionsRolesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdThreatsExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdThreatsSettingsIncidentRulesEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutDashboardsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesExternalProjectionsLayoutReportsEditIdAuditIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSeverityAuditAutomationIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdRouteRouteWithChildren
  '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformExternalProjectionsLayoutMeasurementsEditSystemNameAuditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameAuditIdIndexRoute
  '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/': typeof BreadcrumbsLayoutAccountIdPlatformDataEntitiesFieldsSetFieldNameModeIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsSeveritySlaSlaIdAuditAutomationIdIndexRoute
  '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdAssetsSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
  '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/': typeof BreadcrumbsLayoutAccountIdVulnerabilitiesSettingsTicketLifecycleAutomationsIdRuleIndexAuditAutomationIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/error-process-request'
    | '/$accountId'
    | '/$accountId/assets'
    | '/$accountId/detections'
    | '/$accountId/explore'
    | '/$accountId/identities'
    | '/$accountId/incidents'
    | '/$accountId/risk360'
    | '/$accountId/threats'
    | '/$accountId/vulnerabilities'
    | '/$accountId/'
    | '/$accountId/assets/asset-inventory'
    | '/$accountId/assets/policies'
    | '/$accountId/assets/policy-compliance'
    | '/$accountId/assets/settings'
    | '/$accountId/assets/tool-coverage-and-gap'
    | '/$accountId/assets/users'
    | '/$accountId/detections/global-scripts'
    | '/$accountId/detections/lookup-tables'
    | '/$accountId/detections/pivot'
    | '/$accountId/detections/rules'
    | '/$accountId/detections/settings'
    | '/$accountId/explore/entities'
    | '/$accountId/explore/logs'
    | '/$accountId/identities/alerts'
    | '/$accountId/identities/identity-findings'
    | '/$accountId/identities/overview'
    | '/$accountId/identities/remediation'
    | '/$accountId/identities/tenants'
    | '/$accountId/identities/users'
    | '/$accountId/incidents/pivot'
    | '/$accountId/incidents/settings'
    | '/$accountId/platform/aliases'
    | '/$accountId/platform/authentication-sources'
    | '/$accountId/platform/easm-settings'
    | '/$accountId/platform/risk-score'
    | '/$accountId/platform/scanner-activation'
    | '/$accountId/platform/sources'
    | '/$accountId/platform/targets'
    | '/$accountId/platform/workflows'
    | '/$accountId/risk360/factor-rules'
    | '/$accountId/settings/account-settings'
    | '/$accountId/settings/account-usage'
    | '/$accountId/settings/all-accounts'
    | '/$accountId/settings/all-users'
    | '/$accountId/settings/backoffice-actions'
    | '/$accountId/settings/global-factor-rules'
    | '/$accountId/settings/icons'
    | '/$accountId/settings/profile-settings'
    | '/$accountId/settings/query'
    | '/$accountId/settings/risk360-backoffice-actions'
    | '/$accountId/settings/user-management'
    | '/$accountId/threats/dashboard'
    | '/$accountId/threats/users'
    | '/$accountId/vulnerabilities/asset-coverage'
    | '/$accountId/vulnerabilities/explore'
    | '/$accountId/vulnerabilities/overview'
    | '/$accountId/vulnerabilities/pivot'
    | '/$accountId/vulnerabilities/remediation'
    | '/$accountId/vulnerabilities/risk'
    | '/$accountId/vulnerabilities/roi'
    | '/$accountId/vulnerabilities/settings'
    | '/$accountId/caasm/$'
    | '/$accountId/platform'
    | '/$accountId/tickets/$'
    | '/$accountId/threats/'
    | '/$accountId/assets/'
    | '/$accountId/detections/'
    | '/$accountId/explore/'
    | '/$accountId/identities/'
    | '/$accountId/incidents/'
    | '/$accountId/risk360/'
    | '/$accountId/vulnerabilities/'
    | '/$accountId/assets/dashboards'
    | '/$accountId/assets/reports'
    | '/$accountId/assets/assets/visual'
    | '/$accountId/assets/assets/{-$id}'
    | '/$accountId/assets/policies/create'
    | '/$accountId/assets/policy-violations/visual'
    | '/$accountId/assets/policy-violations/{-$id}'
    | '/$accountId/assets/settings/easm-settings'
    | '/$accountId/assets/settings/rule-set'
    | '/$accountId/assets/settings/ticket-lifecycle'
    | '/$accountId/assets/settings/tickets-statuses'
    | '/$accountId/assets/settings/ui-config'
    | '/$accountId/assets/users/$id'
    | '/$accountId/assets/users/visual'
    | '/$accountId/assets/violation-tickets/visual'
    | '/$accountId/assets/violation-tickets/{-$id}'
    | '/$accountId/detections/dashboards'
    | '/$accountId/detections/reports'
    | '/$accountId/detections/alerts/visual'
    | '/$accountId/detections/alerts/{-$id}'
    | '/$accountId/detections/global-scripts/create'
    | '/$accountId/detections/incidents/visual'
    | '/$accountId/detections/incidents/{-$id}'
    | '/$accountId/detections/lookup-tables/create'
    | '/$accountId/detections/pivot/$id'
    | '/$accountId/detections/rules/create'
    | '/$accountId/detections/rules/logs'
    | '/$accountId/detections/settings/rule-set'
    | '/$accountId/detections/settings/tickets-statuses'
    | '/$accountId/detections/settings/ui-config'
    | '/$accountId/explore/dashboards'
    | '/$accountId/explore/reports'
    | '/$accountId/identities/dashboards'
    | '/$accountId/identities/reports'
    | '/$accountId/identities/alerts/{-$id}'
    | '/$accountId/identities/identity-findings/$id'
    | '/$accountId/identities/identity-findings/visual'
    | '/$accountId/identities/incidents/visual'
    | '/$accountId/identities/incidents/{-$id}'
    | '/$accountId/identities/settings/itdr-config'
    | '/$accountId/identities/users/$id'
    | '/$accountId/identities/users/visual'
    | '/$accountId/incidents/dashboards'
    | '/$accountId/incidents/reports'
    | '/$accountId/incidents/incidents/visual'
    | '/$accountId/incidents/incidents/{-$id}'
    | '/$accountId/incidents/pivot/$id'
    | '/$accountId/incidents/settings/rule-set'
    | '/$accountId/incidents/settings/tickets-statuses'
    | '/$accountId/incidents/settings/ui-config'
    | '/$accountId/platform/measurements'
    | '/$accountId/platform/data-entities/data-entities'
    | '/$accountId/platform/data-entities/fields'
    | '/$accountId/platform/data-purge/runs'
    | '/$accountId/platform/data-purge/{-$projId}'
    | '/$accountId/platform/easm-settings/create'
    | '/$accountId/platform/model-management/runs'
    | '/$accountId/platform/model-management/{-$id}'
    | '/$accountId/platform/overview/health-dashboard'
    | '/$accountId/platform/relations/{-$relationId}'
    | '/$accountId/platform/scanner-activation/create'
    | '/$accountId/platform/sources/create'
    | '/$accountId/platform/targets/create'
    | '/$accountId/risk360/dashboards'
    | '/$accountId/risk360/factor-rules/create'
    | '/$accountId/risk360/factor-rules/runs'
    | '/$accountId/risk360/factors/visual'
    | '/$accountId/risk360/factors/{-$id}'
    | '/$accountId/settings/account-settings/audit'
    | '/$accountId/settings/all-accounts/create'
    | '/$accountId/settings/all-users/create'
    | '/$accountId/settings/global-factor-rules/create'
    | '/$accountId/settings/permissions/content-permissions'
    | '/$accountId/settings/permissions/roles'
    | '/$accountId/settings/profile-settings/audit'
    | '/$accountId/settings/user-management/create'
    | '/$accountId/threats/dashboards'
    | '/$accountId/threats/reports'
    | '/$accountId/threats/alerts/visual'
    | '/$accountId/threats/alerts/{-$id}'
    | '/$accountId/threats/assets/visual'
    | '/$accountId/threats/assets/{-$id}'
    | '/$accountId/threats/incidents/overview'
    | '/$accountId/threats/incidents/visual'
    | '/$accountId/threats/incidents/{-$id}'
    | '/$accountId/threats/settings/Incident-rules'
    | '/$accountId/threats/settings/severity'
    | '/$accountId/threats/settings/tickets-statuses'
    | '/$accountId/threats/settings/ui-config'
    | '/$accountId/threats/users/$id'
    | '/$accountId/threats/users/visual'
    | '/$accountId/vulnerabilities/dashboards'
    | '/$accountId/vulnerabilities/reports'
    | '/$accountId/vulnerabilities/assets/visual'
    | '/$accountId/vulnerabilities/assets/{-$id}'
    | '/$accountId/vulnerabilities/exceptions/{-$id}'
    | '/$accountId/vulnerabilities/findings/visual'
    | '/$accountId/vulnerabilities/findings/{-$id}'
    | '/$accountId/vulnerabilities/pivot/$id'
    | '/$accountId/vulnerabilities/settings/exceptions'
    | '/$accountId/vulnerabilities/settings/rule-set'
    | '/$accountId/vulnerabilities/settings/score'
    | '/$accountId/vulnerabilities/settings/severity-sla'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle'
    | '/$accountId/vulnerabilities/settings/ui-config'
    | '/$accountId/vulnerabilities/tickets/visual'
    | '/$accountId/vulnerabilities/tickets/{-$id}'
    | '/$accountId/assets/asset-inventory/'
    | '/$accountId/assets/policies/'
    | '/$accountId/assets/policy-compliance/'
    | '/$accountId/assets/tool-coverage-and-gap/'
    | '/$accountId/assets/users/'
    | '/$accountId/detections/global-scripts/'
    | '/$accountId/detections/lookup-tables/'
    | '/$accountId/detections/pivot/'
    | '/$accountId/detections/rules/'
    | '/$accountId/explore/entities/'
    | '/$accountId/explore/logs/'
    | '/$accountId/identities/alerts/'
    | '/$accountId/identities/identity-findings/'
    | '/$accountId/identities/tenants/'
    | '/$accountId/identities/users/'
    | '/$accountId/incidents/pivot/'
    | '/$accountId/platform/aliases/'
    | '/$accountId/platform/authentication-sources/'
    | '/$accountId/platform/easm-settings/'
    | '/$accountId/platform/risk-score/'
    | '/$accountId/platform/scanner-activation/'
    | '/$accountId/platform/sources/'
    | '/$accountId/platform/targets/'
    | '/$accountId/platform/workflows/'
    | '/$accountId/risk360/factor-rules/'
    | '/$accountId/settings/account-settings/'
    | '/$accountId/settings/account-usage/'
    | '/$accountId/settings/all-accounts/'
    | '/$accountId/settings/all-users/'
    | '/$accountId/settings/backoffice-actions/'
    | '/$accountId/settings/global-factor-rules/'
    | '/$accountId/settings/icons/'
    | '/$accountId/settings/profile-settings/'
    | '/$accountId/settings/query/'
    | '/$accountId/settings/risk360-backoffice-actions/'
    | '/$accountId/settings/user-management/'
    | '/$accountId/threats/dashboard/'
    | '/$accountId/threats/users/'
    | '/$accountId/vulnerabilities/asset-coverage/'
    | '/$accountId/vulnerabilities/explore/'
    | '/$accountId/vulnerabilities/overview/'
    | '/$accountId/vulnerabilities/pivot/'
    | '/$accountId/vulnerabilities/remediation/'
    | '/$accountId/vulnerabilities/risk/'
    | '/$accountId/vulnerabilities/roi/'
    | '/$accountId/assets/settings/'
    | '/$accountId/detections/settings/'
    | '/$accountId/identities/overview/'
    | '/$accountId/identities/remediation/'
    | '/$accountId/incidents/settings/'
    | '/$accountId/vulnerabilities/settings/'
    | '/$accountId/assets/dashboards/create'
    | '/$accountId/assets/reports/create'
    | '/$accountId/assets/policies/duplicate/$id'
    | '/$accountId/assets/policies/edit/$id'
    | '/$accountId/assets/policies/runs/$id'
    | '/$accountId/assets/settings/easm-settings/create'
    | '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses'
    | '/$accountId/detections/dashboards/create'
    | '/$accountId/detections/reports/create'
    | '/$accountId/detections/global-scripts/edit/$id'
    | '/$accountId/detections/lookup-tables/edit/$id'
    | '/$accountId/detections/rules/edit/$id'
    | '/$accountId/detections/rules/runs/$id'
    | '/$accountId/detections/settings/rule-set/$id'
    | '/$accountId/detections/settings/rule-set/create'
    | '/$accountId/explore/dashboards/create'
    | '/$accountId/explore/reports/create'
    | '/$accountId/identities/dashboards/create'
    | '/$accountId/identities/reports/create'
    | '/$accountId/incidents/dashboards/create'
    | '/$accountId/incidents/reports/create'
    | '/$accountId/incidents/settings/rule-set/$id'
    | '/$accountId/incidents/settings/rule-set/create'
    | '/$accountId/platform/measurements/create'
    | '/$accountId/platform/asset-aging/{-$mode}/{-$id}'
    | '/$accountId/platform/formatting-rules/{-$mode}/{-$id}'
    | '/$accountId/platform/model-management/{-$id}/audit'
    | '/$accountId/platform/model-management/{-$id}/preview'
    | '/$accountId/platform/scanner-activation/edit/$id'
    | '/$accountId/platform/scanner-activation/sensors/$id'
    | '/$accountId/platform/sources/edit/$id'
    | '/$accountId/platform/sources/runs/$id'
    | '/$accountId/platform/targets/activityLog/$id'
    | '/$accountId/platform/targets/create/$type'
    | '/$accountId/platform/targets/edit/$id'
    | '/$accountId/platform/targets/mapping/$id'
    | '/$accountId/platform/workflows/audit/$id'
    | '/$accountId/risk360/dashboards/create'
    | '/$accountId/risk360/factor-rules/edit/$id'
    | '/$accountId/settings/all-accounts/edit/$id'
    | '/$accountId/settings/all-users/edit/$id'
    | '/$accountId/settings/global-factor-rules/edit/$id'
    | '/$accountId/settings/permissions/roles/create'
    | '/$accountId/settings/user-management/edit/$id'
    | '/$accountId/threats/dashboards/create'
    | '/$accountId/threats/reports/create'
    | '/$accountId/threats/incidents/incident-list/visual'
    | '/$accountId/threats/incidents/incident-list/{-$id}'
    | '/$accountId/threats/settings/Incident-rules/create'
    | '/$accountId/threats/settings/alert-score/audit'
    | '/$accountId/vulnerabilities/dashboards/create'
    | '/$accountId/vulnerabilities/reports/create'
    | '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings'
    | '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses'
    | '/$accountId/vulnerabilities/settings/severity-sla/severity'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses'
    | '/$accountId/vulnerabilities/settings/exceptions-settings/$'
    | '/$accountId/vulnerabilities/settings/tickets-statuses/$'
    | '/$accountId/assets/dashboards/'
    | '/$accountId/assets/reports/'
    | '/$accountId/assets/assets/visual/'
    | '/$accountId/assets/assets/{-$id}/'
    | '/$accountId/assets/policies/create/'
    | '/$accountId/assets/policy-violations/visual/'
    | '/$accountId/assets/policy-violations/{-$id}/'
    | '/$accountId/assets/settings/easm-settings/'
    | '/$accountId/assets/settings/rule-set/'
    | '/$accountId/assets/settings/ticket-lifecycle/'
    | '/$accountId/assets/settings/tickets-statuses/'
    | '/$accountId/assets/settings/ui-config/'
    | '/$accountId/assets/users/$id/'
    | '/$accountId/assets/users/visual/'
    | '/$accountId/assets/violation-tickets/visual/'
    | '/$accountId/assets/violation-tickets/{-$id}/'
    | '/$accountId/detections/dashboards/'
    | '/$accountId/detections/reports/'
    | '/$accountId/detections/alerts/visual/'
    | '/$accountId/detections/alerts/{-$id}/'
    | '/$accountId/detections/global-scripts/create/'
    | '/$accountId/detections/incidents/visual/'
    | '/$accountId/detections/incidents/{-$id}/'
    | '/$accountId/detections/lookup-tables/create/'
    | '/$accountId/detections/pivot/$id/'
    | '/$accountId/detections/rules/create/'
    | '/$accountId/detections/rules/logs/'
    | '/$accountId/detections/settings/rule-set/'
    | '/$accountId/detections/settings/tickets-statuses/'
    | '/$accountId/detections/settings/ui-config/'
    | '/$accountId/explore/dashboards/'
    | '/$accountId/explore/reports/'
    | '/$accountId/identities/dashboards/'
    | '/$accountId/identities/reports/'
    | '/$accountId/identities/alerts/{-$id}/'
    | '/$accountId/identities/identity-findings/$id/'
    | '/$accountId/identities/identity-findings/visual/'
    | '/$accountId/identities/incidents/visual/'
    | '/$accountId/identities/incidents/{-$id}/'
    | '/$accountId/identities/settings/itdr-config/'
    | '/$accountId/identities/settings/ui-config'
    | '/$accountId/identities/tenants/$id'
    | '/$accountId/identities/users/$id/'
    | '/$accountId/identities/users/visual/'
    | '/$accountId/incidents/dashboards/'
    | '/$accountId/incidents/reports/'
    | '/$accountId/incidents/incidents/visual/'
    | '/$accountId/incidents/incidents/{-$id}/'
    | '/$accountId/incidents/pivot/$id/'
    | '/$accountId/incidents/settings/rule-set/'
    | '/$accountId/incidents/settings/tickets-statuses/'
    | '/$accountId/incidents/settings/ui-config/'
    | '/$accountId/platform/measurements/'
    | '/$accountId/platform/data-entities/data-entities/'
    | '/$accountId/platform/data-entities/fields/'
    | '/$accountId/platform/data-purge/runs/'
    | '/$accountId/platform/data-purge/{-$projId}/'
    | '/$accountId/platform/easm-settings/create/'
    | '/$accountId/platform/model-management/runs/'
    | '/$accountId/platform/model-management/{-$id}/'
    | '/$accountId/platform/overview/health-dashboard/'
    | '/$accountId/platform/relations/{-$relationId}/'
    | '/$accountId/platform/scanner-activation/create/'
    | '/$accountId/platform/sources/create/'
    | '/$accountId/platform/targets/create/'
    | '/$accountId/risk360/dashboards/'
    | '/$accountId/risk360/factor-rules/create/'
    | '/$accountId/risk360/factor-rules/runs/'
    | '/$accountId/risk360/factors/visual/'
    | '/$accountId/risk360/factors/{-$id}/'
    | '/$accountId/settings/account-settings/audit/'
    | '/$accountId/settings/all-accounts/create/'
    | '/$accountId/settings/all-users/create/'
    | '/$accountId/settings/global-factor-rules/create/'
    | '/$accountId/settings/permissions/content-permissions/'
    | '/$accountId/settings/permissions/roles/'
    | '/$accountId/settings/profile-settings/audit/'
    | '/$accountId/settings/user-management/create/'
    | '/$accountId/threats/dashboards/'
    | '/$accountId/threats/reports/'
    | '/$accountId/threats/alerts/visual/'
    | '/$accountId/threats/alerts/{-$id}/'
    | '/$accountId/threats/assets/visual/'
    | '/$accountId/threats/assets/{-$id}/'
    | '/$accountId/threats/incidents/overview/'
    | '/$accountId/threats/incidents/visual/'
    | '/$accountId/threats/incidents/{-$id}/'
    | '/$accountId/threats/settings/Incident-rules/'
    | '/$accountId/threats/settings/severity/'
    | '/$accountId/threats/settings/tickets-statuses/'
    | '/$accountId/threats/settings/ui-config/'
    | '/$accountId/threats/users/$id/'
    | '/$accountId/threats/users/visual/'
    | '/$accountId/vulnerabilities/dashboards/'
    | '/$accountId/vulnerabilities/reports/'
    | '/$accountId/vulnerabilities/assets/visual/'
    | '/$accountId/vulnerabilities/assets/{-$id}/'
    | '/$accountId/vulnerabilities/exceptions/{-$id}/'
    | '/$accountId/vulnerabilities/findings/visual/'
    | '/$accountId/vulnerabilities/findings/{-$id}/'
    | '/$accountId/vulnerabilities/pivot/$id/'
    | '/$accountId/vulnerabilities/settings/exceptions/'
    | '/$accountId/vulnerabilities/settings/rule-set/'
    | '/$accountId/vulnerabilities/settings/score/'
    | '/$accountId/vulnerabilities/settings/severity-sla/'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/'
    | '/$accountId/vulnerabilities/settings/ui-config/'
    | '/$accountId/vulnerabilities/tickets/visual/'
    | '/$accountId/vulnerabilities/tickets/{-$id}/'
    | '/$accountId/assets/dashboards/edit/$id'
    | '/$accountId/assets/dashboards/runs/$id'
    | '/$accountId/assets/reports/edit/$id'
    | '/$accountId/assets/reports/runs/$id'
    | '/$accountId/assets/policies/edit/$id/audit'
    | '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}'
    | '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}'
    | '/$accountId/assets/settings/ui-config/audit/$path'
    | '/$accountId/detections/dashboards/edit/$id'
    | '/$accountId/detections/dashboards/runs/$id'
    | '/$accountId/detections/reports/edit/$id'
    | '/$accountId/detections/reports/runs/$id'
    | '/$accountId/detections/global-scripts/edit/$id/audit'
    | '/$accountId/detections/lookup-tables/edit/$id/audit'
    | '/$accountId/detections/rules/edit/$id/audit'
    | '/$accountId/detections/settings/rule-set/$id/$ruleIndex'
    | '/$accountId/detections/settings/rule-set/audit/$id'
    | '/$accountId/detections/settings/rule-set/create/$ruleIndex'
    | '/$accountId/detections/settings/ui-config/audit/$path'
    | '/$accountId/explore/dashboards/edit/$id'
    | '/$accountId/explore/dashboards/runs/$id'
    | '/$accountId/explore/reports/edit/$id'
    | '/$accountId/explore/reports/runs/$id'
    | '/$accountId/identities/dashboards/edit/$id'
    | '/$accountId/identities/dashboards/runs/$id'
    | '/$accountId/identities/reports/edit/$id'
    | '/$accountId/identities/reports/runs/$id'
    | '/$accountId/incidents/dashboards/edit/$id'
    | '/$accountId/incidents/dashboards/runs/$id'
    | '/$accountId/incidents/reports/edit/$id'
    | '/$accountId/incidents/reports/runs/$id'
    | '/$accountId/incidents/settings/rule-set/$id/$ruleIndex'
    | '/$accountId/incidents/settings/rule-set/$id/audit'
    | '/$accountId/incidents/settings/rule-set/create/$ruleIndex'
    | '/$accountId/incidents/settings/ui-config/audit/$path'
    | '/$accountId/platform/measurements/edit/$systemName'
    | '/$accountId/platform/data-entities/data-entities/$projId/explore'
    | '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}'
    | '/$accountId/platform/easm-settings/edit/$id/$organizationId'
    | '/$accountId/platform/sources/$id/$mappingPath/$type'
    | '/$accountId/platform/sources/create/$type/{-$previewId}'
    | '/$accountId/platform/sources/edit/$id/$previewId'
    | '/$accountId/platform/sources/edit/$id/audit'
    | '/$accountId/platform/targets/edit/$id/audit'
    | '/$accountId/risk360/dashboards/edit/$id'
    | '/$accountId/risk360/dashboards/runs/$id'
    | '/$accountId/risk360/factor-rules/edit/$id/audit'
    | '/$accountId/settings/all-accounts/edit/$id/audit'
    | '/$accountId/settings/all-users/edit/$id/audit'
    | '/$accountId/settings/global-factor-rules/edit/$id/audit'
    | '/$accountId/settings/permissions/roles/edit/$id'
    | '/$accountId/settings/user-management/edit/$id/audit'
    | '/$accountId/threats/dashboards/edit/$id'
    | '/$accountId/threats/dashboards/runs/$id'
    | '/$accountId/threats/reports/edit/$id'
    | '/$accountId/threats/reports/runs/$id'
    | '/$accountId/threats/settings/Incident-rules/edit/$id'
    | '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}'
    | '/$accountId/threats/settings/severity/audit/$automationId'
    | '/$accountId/threats/settings/ui-config/audit/$path'
    | '/$accountId/vulnerabilities/dashboards/edit/$id'
    | '/$accountId/vulnerabilities/dashboards/runs/$id'
    | '/$accountId/vulnerabilities/reports/edit/$id'
    | '/$accountId/vulnerabilities/reports/runs/$id'
    | '/$accountId/vulnerabilities/settings/rule-set/$id/audit'
    | '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}'
    | '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}'
    | '/$accountId/vulnerabilities/settings/score/audit/$path'
    | '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}'
    | '/$accountId/vulnerabilities/settings/ui-config/audit/$path'
    | '/$accountId/assets/dashboards/create/'
    | '/$accountId/assets/reports/create/'
    | '/$accountId/assets/policies/duplicate/$id/'
    | '/$accountId/assets/policies/edit/$id/'
    | '/$accountId/assets/policies/runs/$id/'
    | '/$accountId/assets/settings/easm-settings/create/'
    | '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/'
    | '/$accountId/detections/dashboards/create/'
    | '/$accountId/detections/reports/create/'
    | '/$accountId/detections/global-scripts/edit/$id/'
    | '/$accountId/detections/lookup-tables/edit/$id/'
    | '/$accountId/detections/rules/edit/$id/'
    | '/$accountId/detections/rules/runs/$id/'
    | '/$accountId/detections/settings/rule-set/$id/'
    | '/$accountId/detections/settings/rule-set/create/'
    | '/$accountId/explore/dashboards/create/'
    | '/$accountId/explore/reports/create/'
    | '/$accountId/identities/dashboards/create/'
    | '/$accountId/identities/reports/create/'
    | '/$accountId/incidents/dashboards/create/'
    | '/$accountId/incidents/reports/create/'
    | '/$accountId/incidents/settings/rule-set/$id/'
    | '/$accountId/incidents/settings/rule-set/create/'
    | '/$accountId/platform/measurements/create/'
    | '/$accountId/platform/asset-aging/{-$mode}/{-$id}/'
    | '/$accountId/platform/formatting-rules/{-$mode}/{-$id}/'
    | '/$accountId/platform/model-management/{-$id}/audit/'
    | '/$accountId/platform/model-management/{-$id}/preview/'
    | '/$accountId/platform/scanner-activation/edit/$id/'
    | '/$accountId/platform/scanner-activation/sensors/$id/'
    | '/$accountId/platform/sources/edit/$id/'
    | '/$accountId/platform/sources/runs/$id/'
    | '/$accountId/platform/targets/activityLog/$id/'
    | '/$accountId/platform/targets/create/$type/'
    | '/$accountId/platform/targets/edit/$id/'
    | '/$accountId/platform/targets/mapping/$id/'
    | '/$accountId/platform/workflows/audit/$id/'
    | '/$accountId/risk360/dashboards/create/'
    | '/$accountId/risk360/factor-rules/edit/$id/'
    | '/$accountId/settings/all-accounts/edit/$id/'
    | '/$accountId/settings/all-users/edit/$id/'
    | '/$accountId/settings/global-factor-rules/edit/$id/'
    | '/$accountId/settings/permissions/roles/create/'
    | '/$accountId/settings/user-management/edit/$id/'
    | '/$accountId/threats/dashboards/create/'
    | '/$accountId/threats/reports/create/'
    | '/$accountId/threats/incidents/incident-list/visual/'
    | '/$accountId/threats/incidents/incident-list/{-$id}/'
    | '/$accountId/threats/settings/Incident-rules/create/'
    | '/$accountId/threats/settings/alert-score/audit/'
    | '/$accountId/vulnerabilities/dashboards/create/'
    | '/$accountId/vulnerabilities/reports/create/'
    | '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/'
    | '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/'
    | '/$accountId/vulnerabilities/settings/severity-sla/severity/'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/'
    | '/$accountId/assets/dashboards/edit/$id/audit'
    | '/$accountId/assets/reports/edit/$id/audit'
    | '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId'
    | '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit'
    | '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
    | '/$accountId/detections/dashboards/edit/$id/audit'
    | '/$accountId/detections/reports/edit/$id/audit'
    | '/$accountId/explore/dashboards/edit/$id/audit'
    | '/$accountId/explore/reports/edit/$id/audit'
    | '/$accountId/identities/dashboards/edit/$id/audit'
    | '/$accountId/identities/reports/edit/$id/audit'
    | '/$accountId/incidents/dashboards/edit/$id/audit'
    | '/$accountId/incidents/reports/edit/$id/audit'
    | '/$accountId/platform/sources/$id/$mappingPath/$type/audit'
    | '/$accountId/platform/sources/$id/$mappingPath/$type/preview'
    | '/$accountId/platform/targets/mapping/$id/audit/$idMapping'
    | '/$accountId/risk360/dashboards/edit/$id/audit'
    | '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit'
    | '/$accountId/settings/permissions/roles/edit/$id/audit'
    | '/$accountId/threats/dashboards/edit/$id/audit'
    | '/$accountId/threats/reports/edit/$id/audit'
    | '/$accountId/threats/settings/Incident-rules/edit/$id/audit'
    | '/$accountId/vulnerabilities/dashboards/edit/$id/audit'
    | '/$accountId/vulnerabilities/reports/edit/$id/audit'
    | '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
    | '/$accountId/assets/dashboards/edit/$id/'
    | '/$accountId/assets/dashboards/runs/$id/'
    | '/$accountId/assets/reports/edit/$id/'
    | '/$accountId/assets/reports/runs/$id/'
    | '/$accountId/assets/policies/edit/$id/audit/'
    | '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/'
    | '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/'
    | '/$accountId/assets/settings/ui-config/audit/$path/'
    | '/$accountId/detections/dashboards/edit/$id/'
    | '/$accountId/detections/dashboards/runs/$id/'
    | '/$accountId/detections/reports/edit/$id/'
    | '/$accountId/detections/reports/runs/$id/'
    | '/$accountId/detections/global-scripts/edit/$id/audit/'
    | '/$accountId/detections/lookup-tables/edit/$id/audit/'
    | '/$accountId/detections/rules/edit/$id/audit/'
    | '/$accountId/detections/settings/rule-set/$id/$ruleIndex/'
    | '/$accountId/detections/settings/rule-set/audit/$id/'
    | '/$accountId/detections/settings/rule-set/create/$ruleIndex/'
    | '/$accountId/detections/settings/ui-config/audit/$path/'
    | '/$accountId/explore/dashboards/edit/$id/'
    | '/$accountId/explore/dashboards/runs/$id/'
    | '/$accountId/explore/reports/edit/$id/'
    | '/$accountId/explore/reports/runs/$id/'
    | '/$accountId/identities/dashboards/edit/$id/'
    | '/$accountId/identities/dashboards/runs/$id/'
    | '/$accountId/identities/reports/edit/$id/'
    | '/$accountId/identities/reports/runs/$id/'
    | '/$accountId/identities/settings/ui-config/audit/$path'
    | '/$accountId/incidents/dashboards/edit/$id/'
    | '/$accountId/incidents/dashboards/runs/$id/'
    | '/$accountId/incidents/reports/edit/$id/'
    | '/$accountId/incidents/reports/runs/$id/'
    | '/$accountId/incidents/settings/rule-set/$id/$ruleIndex/'
    | '/$accountId/incidents/settings/rule-set/$id/audit/'
    | '/$accountId/incidents/settings/rule-set/create/$ruleIndex/'
    | '/$accountId/incidents/settings/ui-config/audit/$path/'
    | '/$accountId/platform/measurements/edit/$systemName/'
    | '/$accountId/platform/data-entities/data-entities/$projId/explore/'
    | '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/'
    | '/$accountId/platform/easm-settings/edit/$id/$organizationId/'
    | '/$accountId/platform/sources/$id/$mappingPath/$type/'
    | '/$accountId/platform/sources/create/$type/{-$previewId}/'
    | '/$accountId/platform/sources/edit/$id/$previewId/'
    | '/$accountId/platform/sources/edit/$id/audit/'
    | '/$accountId/platform/targets/edit/$id/audit/'
    | '/$accountId/risk360/dashboards/edit/$id/'
    | '/$accountId/risk360/dashboards/runs/$id/'
    | '/$accountId/risk360/factor-rules/edit/$id/audit/'
    | '/$accountId/settings/all-accounts/edit/$id/audit/'
    | '/$accountId/settings/all-users/edit/$id/audit/'
    | '/$accountId/settings/global-factor-rules/edit/$id/audit/'
    | '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}'
    | '/$accountId/settings/permissions/roles/edit/$id/'
    | '/$accountId/settings/user-management/edit/$id/audit/'
    | '/$accountId/threats/dashboards/edit/$id/'
    | '/$accountId/threats/dashboards/runs/$id/'
    | '/$accountId/threats/reports/edit/$id/'
    | '/$accountId/threats/reports/runs/$id/'
    | '/$accountId/threats/settings/Incident-rules/edit/$id/'
    | '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/'
    | '/$accountId/threats/settings/severity/audit/$automationId/'
    | '/$accountId/threats/settings/ui-config/audit/$path/'
    | '/$accountId/vulnerabilities/dashboards/edit/$id/'
    | '/$accountId/vulnerabilities/dashboards/runs/$id/'
    | '/$accountId/vulnerabilities/reports/edit/$id/'
    | '/$accountId/vulnerabilities/reports/runs/$id/'
    | '/$accountId/vulnerabilities/settings/rule-set/$id/audit/'
    | '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/'
    | '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/'
    | '/$accountId/vulnerabilities/settings/score/audit/$path/'
    | '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/'
    | '/$accountId/vulnerabilities/settings/ui-config/audit/$path/'
    | '/$accountId/platform/measurements/edit/$systemName/audit/$id'
    | '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id'
    | '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}'
    | '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId'
    | '/$accountId/assets/dashboards/edit/$id/audit/'
    | '/$accountId/assets/reports/edit/$id/audit/'
    | '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/'
    | '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/'
    | '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
    | '/$accountId/detections/dashboards/edit/$id/audit/'
    | '/$accountId/detections/reports/edit/$id/audit/'
    | '/$accountId/explore/dashboards/edit/$id/audit/'
    | '/$accountId/explore/reports/edit/$id/audit/'
    | '/$accountId/identities/dashboards/edit/$id/audit/'
    | '/$accountId/identities/reports/edit/$id/audit/'
    | '/$accountId/incidents/dashboards/edit/$id/audit/'
    | '/$accountId/incidents/reports/edit/$id/audit/'
    | '/$accountId/platform/sources/$id/$mappingPath/$type/audit/'
    | '/$accountId/platform/sources/$id/$mappingPath/$type/preview/'
    | '/$accountId/platform/targets/mapping/$id/audit/$idMapping/'
    | '/$accountId/risk360/dashboards/edit/$id/audit/'
    | '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/'
    | '/$accountId/settings/permissions/roles/edit/$id/audit/'
    | '/$accountId/threats/dashboards/edit/$id/audit/'
    | '/$accountId/threats/reports/edit/$id/audit/'
    | '/$accountId/threats/settings/Incident-rules/edit/$id/audit/'
    | '/$accountId/vulnerabilities/dashboards/edit/$id/audit/'
    | '/$accountId/vulnerabilities/reports/edit/$id/audit/'
    | '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
    | '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
    | '/$accountId/platform/measurements/edit/$systemName/audit/$id/'
    | '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/'
    | '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/'
    | '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/'
    | '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/error-process-request'
    | '/$accountId'
    | '/$accountId/assets'
    | '/$accountId/caasm/$'
    | '/$accountId/detections'
    | '/$accountId/explore'
    | '/$accountId/incidents'
    | '/$accountId/platform'
    | '/$accountId/risk360'
    | '/$accountId/threats'
    | '/$accountId/tickets/$'
    | '/$accountId/vulnerabilities'
    | '/$accountId/identities'
    | '/$accountId/assets/asset-inventory'
    | '/$accountId/assets/policies'
    | '/$accountId/assets/policy-compliance'
    | '/$accountId/assets/tool-coverage-and-gap'
    | '/$accountId/assets/users'
    | '/$accountId/detections/global-scripts'
    | '/$accountId/detections/lookup-tables'
    | '/$accountId/detections/pivot'
    | '/$accountId/detections/rules'
    | '/$accountId/explore/entities'
    | '/$accountId/explore/logs'
    | '/$accountId/identities/alerts'
    | '/$accountId/identities/identity-findings'
    | '/$accountId/identities/tenants'
    | '/$accountId/identities/users'
    | '/$accountId/incidents/pivot'
    | '/$accountId/platform/aliases'
    | '/$accountId/platform/authentication-sources'
    | '/$accountId/platform/easm-settings'
    | '/$accountId/platform/risk-score'
    | '/$accountId/platform/scanner-activation'
    | '/$accountId/platform/sources'
    | '/$accountId/platform/targets'
    | '/$accountId/platform/workflows'
    | '/$accountId/risk360/factor-rules'
    | '/$accountId/settings/account-settings'
    | '/$accountId/settings/account-usage'
    | '/$accountId/settings/all-accounts'
    | '/$accountId/settings/all-users'
    | '/$accountId/settings/backoffice-actions'
    | '/$accountId/settings/global-factor-rules'
    | '/$accountId/settings/icons'
    | '/$accountId/settings/profile-settings'
    | '/$accountId/settings/query'
    | '/$accountId/settings/risk360-backoffice-actions'
    | '/$accountId/settings/user-management'
    | '/$accountId/threats/dashboard'
    | '/$accountId/threats/users'
    | '/$accountId/vulnerabilities/asset-coverage'
    | '/$accountId/vulnerabilities/explore'
    | '/$accountId/vulnerabilities/overview'
    | '/$accountId/vulnerabilities/pivot'
    | '/$accountId/vulnerabilities/remediation'
    | '/$accountId/vulnerabilities/risk'
    | '/$accountId/vulnerabilities/roi'
    | '/$accountId/assets/settings'
    | '/$accountId/detections/settings'
    | '/$accountId/identities/overview'
    | '/$accountId/identities/remediation'
    | '/$accountId/incidents/settings'
    | '/$accountId/vulnerabilities/settings'
    | '/$accountId/vulnerabilities/settings/exceptions-settings/$'
    | '/$accountId/vulnerabilities/settings/tickets-statuses/$'
    | '/$accountId/assets/dashboards'
    | '/$accountId/assets/reports'
    | '/$accountId/assets/assets/visual'
    | '/$accountId/assets/assets/{-$id}'
    | '/$accountId/assets/policies/create'
    | '/$accountId/assets/policy-violations/visual'
    | '/$accountId/assets/policy-violations/{-$id}'
    | '/$accountId/assets/settings/easm-settings'
    | '/$accountId/assets/settings/rule-set'
    | '/$accountId/assets/settings/ticket-lifecycle'
    | '/$accountId/assets/settings/tickets-statuses'
    | '/$accountId/assets/settings/ui-config'
    | '/$accountId/assets/users/$id'
    | '/$accountId/assets/users/visual'
    | '/$accountId/assets/violation-tickets/visual'
    | '/$accountId/assets/violation-tickets/{-$id}'
    | '/$accountId/detections/dashboards'
    | '/$accountId/detections/reports'
    | '/$accountId/detections/alerts/visual'
    | '/$accountId/detections/alerts/{-$id}'
    | '/$accountId/detections/global-scripts/create'
    | '/$accountId/detections/incidents/visual'
    | '/$accountId/detections/incidents/{-$id}'
    | '/$accountId/detections/lookup-tables/create'
    | '/$accountId/detections/pivot/$id'
    | '/$accountId/detections/rules/create'
    | '/$accountId/detections/rules/logs'
    | '/$accountId/detections/settings/rule-set'
    | '/$accountId/detections/settings/tickets-statuses'
    | '/$accountId/detections/settings/ui-config'
    | '/$accountId/explore/dashboards'
    | '/$accountId/explore/reports'
    | '/$accountId/identities/dashboards'
    | '/$accountId/identities/reports'
    | '/$accountId/identities/alerts/{-$id}'
    | '/$accountId/identities/identity-findings/$id'
    | '/$accountId/identities/identity-findings/visual'
    | '/$accountId/identities/incidents/visual'
    | '/$accountId/identities/incidents/{-$id}'
    | '/$accountId/identities/settings/itdr-config'
    | '/$accountId/identities/settings/ui-config'
    | '/$accountId/identities/tenants/$id'
    | '/$accountId/identities/users/$id'
    | '/$accountId/identities/users/visual'
    | '/$accountId/incidents/dashboards'
    | '/$accountId/incidents/reports'
    | '/$accountId/incidents/incidents/visual'
    | '/$accountId/incidents/incidents/{-$id}'
    | '/$accountId/incidents/pivot/$id'
    | '/$accountId/incidents/settings/rule-set'
    | '/$accountId/incidents/settings/tickets-statuses'
    | '/$accountId/incidents/settings/ui-config'
    | '/$accountId/platform/measurements'
    | '/$accountId/platform/data-entities/data-entities'
    | '/$accountId/platform/data-entities/fields'
    | '/$accountId/platform/data-purge/runs'
    | '/$accountId/platform/data-purge/{-$projId}'
    | '/$accountId/platform/easm-settings/create'
    | '/$accountId/platform/model-management/runs'
    | '/$accountId/platform/model-management/{-$id}'
    | '/$accountId/platform/overview/health-dashboard'
    | '/$accountId/platform/relations/{-$relationId}'
    | '/$accountId/platform/scanner-activation/create'
    | '/$accountId/platform/sources/create'
    | '/$accountId/platform/targets/create'
    | '/$accountId/risk360/dashboards'
    | '/$accountId/risk360/factor-rules/create'
    | '/$accountId/risk360/factor-rules/runs'
    | '/$accountId/risk360/factors/visual'
    | '/$accountId/risk360/factors/{-$id}'
    | '/$accountId/settings/account-settings/audit'
    | '/$accountId/settings/all-accounts/create'
    | '/$accountId/settings/all-users/create'
    | '/$accountId/settings/global-factor-rules/create'
    | '/$accountId/settings/permissions/content-permissions'
    | '/$accountId/settings/permissions/roles'
    | '/$accountId/settings/profile-settings/audit'
    | '/$accountId/settings/user-management/create'
    | '/$accountId/threats/dashboards'
    | '/$accountId/threats/reports'
    | '/$accountId/threats/alerts/visual'
    | '/$accountId/threats/alerts/{-$id}'
    | '/$accountId/threats/assets/visual'
    | '/$accountId/threats/assets/{-$id}'
    | '/$accountId/threats/incidents/overview'
    | '/$accountId/threats/incidents/visual'
    | '/$accountId/threats/incidents/{-$id}'
    | '/$accountId/threats/settings/Incident-rules'
    | '/$accountId/threats/settings/severity'
    | '/$accountId/threats/settings/tickets-statuses'
    | '/$accountId/threats/settings/ui-config'
    | '/$accountId/threats/users/$id'
    | '/$accountId/threats/users/visual'
    | '/$accountId/vulnerabilities/dashboards'
    | '/$accountId/vulnerabilities/reports'
    | '/$accountId/vulnerabilities/assets/visual'
    | '/$accountId/vulnerabilities/assets/{-$id}'
    | '/$accountId/vulnerabilities/exceptions/{-$id}'
    | '/$accountId/vulnerabilities/findings/visual'
    | '/$accountId/vulnerabilities/findings/{-$id}'
    | '/$accountId/vulnerabilities/pivot/$id'
    | '/$accountId/vulnerabilities/settings/exceptions'
    | '/$accountId/vulnerabilities/settings/rule-set'
    | '/$accountId/vulnerabilities/settings/score'
    | '/$accountId/vulnerabilities/settings/severity-sla'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle'
    | '/$accountId/vulnerabilities/settings/ui-config'
    | '/$accountId/vulnerabilities/tickets/visual'
    | '/$accountId/vulnerabilities/tickets/{-$id}'
    | '/$accountId/assets/dashboards/create'
    | '/$accountId/assets/reports/create'
    | '/$accountId/assets/policies/duplicate/$id'
    | '/$accountId/assets/policies/edit/$id'
    | '/$accountId/assets/policies/runs/$id'
    | '/$accountId/assets/settings/easm-settings/create'
    | '/$accountId/assets/settings/ticket-lifecycle/tickets-statuses'
    | '/$accountId/detections/dashboards/create'
    | '/$accountId/detections/reports/create'
    | '/$accountId/detections/global-scripts/edit/$id'
    | '/$accountId/detections/lookup-tables/edit/$id'
    | '/$accountId/detections/rules/edit/$id'
    | '/$accountId/detections/rules/runs/$id'
    | '/$accountId/detections/settings/rule-set/$id'
    | '/$accountId/detections/settings/rule-set/create'
    | '/$accountId/explore/dashboards/create'
    | '/$accountId/explore/reports/create'
    | '/$accountId/identities/dashboards/create'
    | '/$accountId/identities/reports/create'
    | '/$accountId/incidents/dashboards/create'
    | '/$accountId/incidents/reports/create'
    | '/$accountId/incidents/settings/rule-set/$id'
    | '/$accountId/incidents/settings/rule-set/create'
    | '/$accountId/platform/measurements/create'
    | '/$accountId/platform/asset-aging/{-$mode}/{-$id}'
    | '/$accountId/platform/formatting-rules/{-$mode}/{-$id}'
    | '/$accountId/platform/model-management/{-$id}/audit'
    | '/$accountId/platform/model-management/{-$id}/preview'
    | '/$accountId/platform/scanner-activation/edit/$id'
    | '/$accountId/platform/scanner-activation/sensors/$id'
    | '/$accountId/platform/sources/edit/$id'
    | '/$accountId/platform/sources/runs/$id'
    | '/$accountId/platform/targets/activityLog/$id'
    | '/$accountId/platform/targets/create/$type'
    | '/$accountId/platform/targets/edit/$id'
    | '/$accountId/platform/targets/mapping/$id'
    | '/$accountId/platform/workflows/audit/$id'
    | '/$accountId/risk360/dashboards/create'
    | '/$accountId/risk360/factor-rules/edit/$id'
    | '/$accountId/settings/all-accounts/edit/$id'
    | '/$accountId/settings/all-users/edit/$id'
    | '/$accountId/settings/global-factor-rules/edit/$id'
    | '/$accountId/settings/permissions/roles/create'
    | '/$accountId/settings/user-management/edit/$id'
    | '/$accountId/threats/dashboards/create'
    | '/$accountId/threats/reports/create'
    | '/$accountId/threats/incidents/incident-list/visual'
    | '/$accountId/threats/incidents/incident-list/{-$id}'
    | '/$accountId/threats/settings/Incident-rules/create'
    | '/$accountId/threats/settings/alert-score/audit'
    | '/$accountId/vulnerabilities/dashboards/create'
    | '/$accountId/vulnerabilities/reports/create'
    | '/$accountId/vulnerabilities/settings/exceptions/exceptions-settings'
    | '/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses'
    | '/$accountId/vulnerabilities/settings/severity-sla/severity'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses'
    | '/$accountId/assets/dashboards/edit/$id'
    | '/$accountId/assets/dashboards/runs/$id'
    | '/$accountId/assets/reports/edit/$id'
    | '/$accountId/assets/reports/runs/$id'
    | '/$accountId/assets/policies/edit/$id/audit'
    | '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}'
    | '/$accountId/assets/settings/rule-set/create/{-$ruleIndex}'
    | '/$accountId/assets/settings/ui-config/audit/$path'
    | '/$accountId/detections/dashboards/edit/$id'
    | '/$accountId/detections/dashboards/runs/$id'
    | '/$accountId/detections/reports/edit/$id'
    | '/$accountId/detections/reports/runs/$id'
    | '/$accountId/detections/global-scripts/edit/$id/audit'
    | '/$accountId/detections/lookup-tables/edit/$id/audit'
    | '/$accountId/detections/rules/edit/$id/audit'
    | '/$accountId/detections/settings/rule-set/$id/$ruleIndex'
    | '/$accountId/detections/settings/rule-set/audit/$id'
    | '/$accountId/detections/settings/rule-set/create/$ruleIndex'
    | '/$accountId/detections/settings/ui-config/audit/$path'
    | '/$accountId/explore/dashboards/edit/$id'
    | '/$accountId/explore/dashboards/runs/$id'
    | '/$accountId/explore/reports/edit/$id'
    | '/$accountId/explore/reports/runs/$id'
    | '/$accountId/identities/dashboards/edit/$id'
    | '/$accountId/identities/dashboards/runs/$id'
    | '/$accountId/identities/reports/edit/$id'
    | '/$accountId/identities/reports/runs/$id'
    | '/$accountId/identities/settings/ui-config/audit/$path'
    | '/$accountId/incidents/dashboards/edit/$id'
    | '/$accountId/incidents/dashboards/runs/$id'
    | '/$accountId/incidents/reports/edit/$id'
    | '/$accountId/incidents/reports/runs/$id'
    | '/$accountId/incidents/settings/rule-set/$id/$ruleIndex'
    | '/$accountId/incidents/settings/rule-set/$id/audit'
    | '/$accountId/incidents/settings/rule-set/create/$ruleIndex'
    | '/$accountId/incidents/settings/ui-config/audit/$path'
    | '/$accountId/platform/measurements/edit/$systemName'
    | '/$accountId/platform/data-entities/data-entities/$projId/explore'
    | '/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}'
    | '/$accountId/platform/easm-settings/edit/$id/$organizationId'
    | '/$accountId/platform/sources/$id/$mappingPath/$type'
    | '/$accountId/platform/sources/create/$type/{-$previewId}'
    | '/$accountId/platform/sources/edit/$id/$previewId'
    | '/$accountId/platform/sources/edit/$id/audit'
    | '/$accountId/platform/targets/edit/$id/audit'
    | '/$accountId/risk360/dashboards/edit/$id'
    | '/$accountId/risk360/dashboards/runs/$id'
    | '/$accountId/risk360/factor-rules/edit/$id/audit'
    | '/$accountId/settings/all-accounts/edit/$id/audit'
    | '/$accountId/settings/all-users/edit/$id/audit'
    | '/$accountId/settings/global-factor-rules/edit/$id/audit'
    | '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}'
    | '/$accountId/settings/permissions/roles/edit/$id'
    | '/$accountId/settings/user-management/edit/$id/audit'
    | '/$accountId/threats/dashboards/edit/$id'
    | '/$accountId/threats/dashboards/runs/$id'
    | '/$accountId/threats/reports/edit/$id'
    | '/$accountId/threats/reports/runs/$id'
    | '/$accountId/threats/settings/Incident-rules/edit/$id'
    | '/$accountId/threats/settings/alert-score/{-$projection}/{-$field}'
    | '/$accountId/threats/settings/severity/audit/$automationId'
    | '/$accountId/threats/settings/ui-config/audit/$path'
    | '/$accountId/vulnerabilities/dashboards/edit/$id'
    | '/$accountId/vulnerabilities/dashboards/runs/$id'
    | '/$accountId/vulnerabilities/reports/edit/$id'
    | '/$accountId/vulnerabilities/reports/runs/$id'
    | '/$accountId/vulnerabilities/settings/rule-set/$id/audit'
    | '/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}'
    | '/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}'
    | '/$accountId/vulnerabilities/settings/score/audit/$path'
    | '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}'
    | '/$accountId/vulnerabilities/settings/ui-config/audit/$path'
    | '/$accountId/assets/dashboards/edit/$id/audit'
    | '/$accountId/assets/reports/edit/$id/audit'
    | '/$accountId/assets/settings/easm-settings/edit/$id/$organizationId'
    | '/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit'
    | '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
    | '/$accountId/detections/dashboards/edit/$id/audit'
    | '/$accountId/detections/reports/edit/$id/audit'
    | '/$accountId/explore/dashboards/edit/$id/audit'
    | '/$accountId/explore/reports/edit/$id/audit'
    | '/$accountId/identities/dashboards/edit/$id/audit'
    | '/$accountId/identities/reports/edit/$id/audit'
    | '/$accountId/incidents/dashboards/edit/$id/audit'
    | '/$accountId/incidents/reports/edit/$id/audit'
    | '/$accountId/platform/sources/$id/$mappingPath/$type/audit'
    | '/$accountId/platform/sources/$id/$mappingPath/$type/preview'
    | '/$accountId/platform/targets/mapping/$id/audit/$idMapping'
    | '/$accountId/risk360/dashboards/edit/$id/audit'
    | '/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit'
    | '/$accountId/settings/permissions/roles/edit/$id/audit'
    | '/$accountId/threats/dashboards/edit/$id/audit'
    | '/$accountId/threats/reports/edit/$id/audit'
    | '/$accountId/threats/settings/Incident-rules/edit/$id/audit'
    | '/$accountId/vulnerabilities/dashboards/edit/$id/audit'
    | '/$accountId/vulnerabilities/reports/edit/$id/audit'
    | '/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
    | '/$accountId/platform/measurements/edit/$systemName/audit/$id'
    | '/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id'
    | '/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}'
    | '/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId'
    | '/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
    | '/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
  id:
    | '__root__'
    | '/'
    | '/_breadcrumbsLayout'
    | '/error-process-request'
    | '/_breadcrumbsLayout/$accountId'
    | '/_breadcrumbsLayout/$accountId/assets'
    | '/_breadcrumbsLayout/$accountId/detections'
    | '/_breadcrumbsLayout/$accountId/explore'
    | '/_breadcrumbsLayout/$accountId/identities'
    | '/_breadcrumbsLayout/$accountId/incidents'
    | '/_breadcrumbsLayout/$accountId/risk360'
    | '/_breadcrumbsLayout/$accountId/threats'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities'
    | '/_breadcrumbsLayout/$accountId/'
    | '/_breadcrumbsLayout/$accountId/assets/asset-inventory'
    | '/_breadcrumbsLayout/$accountId/assets/policies'
    | '/_breadcrumbsLayout/$accountId/assets/policy-compliance'
    | '/_breadcrumbsLayout/$accountId/assets/settings'
    | '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap'
    | '/_breadcrumbsLayout/$accountId/assets/users'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables'
    | '/_breadcrumbsLayout/$accountId/detections/pivot'
    | '/_breadcrumbsLayout/$accountId/detections/rules'
    | '/_breadcrumbsLayout/$accountId/detections/settings'
    | '/_breadcrumbsLayout/$accountId/explore/entities'
    | '/_breadcrumbsLayout/$accountId/explore/logs'
    | '/_breadcrumbsLayout/$accountId/identities/alerts'
    | '/_breadcrumbsLayout/$accountId/identities/identity-findings'
    | '/_breadcrumbsLayout/$accountId/identities/overview'
    | '/_breadcrumbsLayout/$accountId/identities/remediation'
    | '/_breadcrumbsLayout/$accountId/identities/tenants'
    | '/_breadcrumbsLayout/$accountId/identities/users'
    | '/_breadcrumbsLayout/$accountId/incidents/pivot'
    | '/_breadcrumbsLayout/$accountId/incidents/settings'
    | '/_breadcrumbsLayout/$accountId/platform/aliases'
    | '/_breadcrumbsLayout/$accountId/platform/authentication-sources'
    | '/_breadcrumbsLayout/$accountId/platform/easm-settings'
    | '/_breadcrumbsLayout/$accountId/platform/risk-score'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation'
    | '/_breadcrumbsLayout/$accountId/platform/sources'
    | '/_breadcrumbsLayout/$accountId/platform/targets'
    | '/_breadcrumbsLayout/$accountId/platform/workflows'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules'
    | '/_breadcrumbsLayout/$accountId/settings/account-settings'
    | '/_breadcrumbsLayout/$accountId/settings/account-usage'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts'
    | '/_breadcrumbsLayout/$accountId/settings/all-users'
    | '/_breadcrumbsLayout/$accountId/settings/backoffice-actions'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules'
    | '/_breadcrumbsLayout/$accountId/settings/icons'
    | '/_breadcrumbsLayout/$accountId/settings/profile-settings'
    | '/_breadcrumbsLayout/$accountId/settings/query'
    | '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions'
    | '/_breadcrumbsLayout/$accountId/settings/user-management'
    | '/_breadcrumbsLayout/$accountId/threats/dashboard'
    | '/_breadcrumbsLayout/$accountId/threats/users'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/explore'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/overview'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/risk'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/roi'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/caasm/$'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/platform'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/tickets/$'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout'
    | '/_breadcrumbsLayout/$accountId/threats/'
    | '/_breadcrumbsLayout/$accountId/assets/'
    | '/_breadcrumbsLayout/$accountId/detections/'
    | '/_breadcrumbsLayout/$accountId/explore/'
    | '/_breadcrumbsLayout/$accountId/identities/'
    | '/_breadcrumbsLayout/$accountId/incidents/'
    | '/_breadcrumbsLayout/$accountId/risk360/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports'
    | '/_breadcrumbsLayout/$accountId/assets/assets/visual'
    | '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}'
    | '/_breadcrumbsLayout/$accountId/assets/policies/create'
    | '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual'
    | '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}'
    | '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle'
    | '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ui-config'
    | '/_breadcrumbsLayout/$accountId/assets/users/$id'
    | '/_breadcrumbsLayout/$accountId/assets/users/visual'
    | '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual'
    | '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports'
    | '/_breadcrumbsLayout/$accountId/detections/alerts/visual'
    | '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts/create'
    | '/_breadcrumbsLayout/$accountId/detections/incidents/visual'
    | '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create'
    | '/_breadcrumbsLayout/$accountId/detections/pivot/$id'
    | '/_breadcrumbsLayout/$accountId/detections/rules/create'
    | '/_breadcrumbsLayout/$accountId/detections/rules/logs'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set'
    | '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses'
    | '/_breadcrumbsLayout/$accountId/detections/settings/ui-config'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports'
    | '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}'
    | '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id'
    | '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual'
    | '/_breadcrumbsLayout/$accountId/identities/incidents/visual'
    | '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}'
    | '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config'
    | '/_breadcrumbsLayout/$accountId/identities/users/$id'
    | '/_breadcrumbsLayout/$accountId/identities/users/visual'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports'
    | '/_breadcrumbsLayout/$accountId/incidents/incidents/visual'
    | '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}'
    | '/_breadcrumbsLayout/$accountId/incidents/pivot/$id'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/fields'
    | '/_breadcrumbsLayout/$accountId/platform/data-purge/runs'
    | '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}'
    | '/_breadcrumbsLayout/$accountId/platform/easm-settings/create'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/runs'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}'
    | '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard'
    | '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create'
    | '/_breadcrumbsLayout/$accountId/platform/sources/create'
    | '/_breadcrumbsLayout/$accountId/platform/targets/create'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs'
    | '/_breadcrumbsLayout/$accountId/risk360/factors/visual'
    | '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}'
    | '/_breadcrumbsLayout/$accountId/settings/account-settings/audit'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts/create'
    | '/_breadcrumbsLayout/$accountId/settings/all-users/create'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles'
    | '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit'
    | '/_breadcrumbsLayout/$accountId/settings/user-management/create'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports'
    | '/_breadcrumbsLayout/$accountId/threats/alerts/visual'
    | '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}'
    | '/_breadcrumbsLayout/$accountId/threats/assets/visual'
    | '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/overview'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/visual'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules'
    | '/_breadcrumbsLayout/$accountId/threats/settings/severity'
    | '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses'
    | '/_breadcrumbsLayout/$accountId/threats/settings/ui-config'
    | '/_breadcrumbsLayout/$accountId/threats/users/$id'
    | '/_breadcrumbsLayout/$accountId/threats/users/visual'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}'
    | '/_breadcrumbsLayout/$accountId/assets/asset-inventory/'
    | '/_breadcrumbsLayout/$accountId/assets/policies/'
    | '/_breadcrumbsLayout/$accountId/assets/policy-compliance/'
    | '/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/'
    | '/_breadcrumbsLayout/$accountId/assets/users/'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts/'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables/'
    | '/_breadcrumbsLayout/$accountId/detections/pivot/'
    | '/_breadcrumbsLayout/$accountId/detections/rules/'
    | '/_breadcrumbsLayout/$accountId/explore/entities/'
    | '/_breadcrumbsLayout/$accountId/explore/logs/'
    | '/_breadcrumbsLayout/$accountId/identities/alerts/'
    | '/_breadcrumbsLayout/$accountId/identities/identity-findings/'
    | '/_breadcrumbsLayout/$accountId/identities/tenants/'
    | '/_breadcrumbsLayout/$accountId/identities/users/'
    | '/_breadcrumbsLayout/$accountId/incidents/pivot/'
    | '/_breadcrumbsLayout/$accountId/platform/aliases/'
    | '/_breadcrumbsLayout/$accountId/platform/authentication-sources/'
    | '/_breadcrumbsLayout/$accountId/platform/easm-settings/'
    | '/_breadcrumbsLayout/$accountId/platform/risk-score/'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/'
    | '/_breadcrumbsLayout/$accountId/platform/workflows/'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/'
    | '/_breadcrumbsLayout/$accountId/settings/account-settings/'
    | '/_breadcrumbsLayout/$accountId/settings/account-usage/'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts/'
    | '/_breadcrumbsLayout/$accountId/settings/all-users/'
    | '/_breadcrumbsLayout/$accountId/settings/backoffice-actions/'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/'
    | '/_breadcrumbsLayout/$accountId/settings/icons/'
    | '/_breadcrumbsLayout/$accountId/settings/profile-settings/'
    | '/_breadcrumbsLayout/$accountId/settings/query/'
    | '/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/'
    | '/_breadcrumbsLayout/$accountId/settings/user-management/'
    | '/_breadcrumbsLayout/$accountId/threats/dashboard/'
    | '/_breadcrumbsLayout/$accountId/threats/users/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/explore/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/overview/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/risk/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/roi/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/'
    | '/_breadcrumbsLayout/$accountId/identities/overview/'
    | '/_breadcrumbsLayout/$accountId/identities/remediation/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create'
    | '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id'
    | '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id'
    | '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id'
    | '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id'
    | '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id'
    | '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create'
    | '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}'
    | '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id'
    | '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id'
    | '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id'
    | '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id'
    | '/_breadcrumbsLayout/$accountId/platform/targets/create/$type'
    | '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id'
    | '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id'
    | '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id'
    | '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create'
    | '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create'
    | '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/'
    | '/_breadcrumbsLayout/$accountId/assets/assets/visual/'
    | '/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/assets/policies/create/'
    | '/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/'
    | '/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/'
    | '/_breadcrumbsLayout/$accountId/assets/users/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/users/visual/'
    | '/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/'
    | '/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/'
    | '/_breadcrumbsLayout/$accountId/detections/alerts/visual/'
    | '/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts/create/'
    | '/_breadcrumbsLayout/$accountId/detections/incidents/visual/'
    | '/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/'
    | '/_breadcrumbsLayout/$accountId/detections/pivot/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/rules/create/'
    | '/_breadcrumbsLayout/$accountId/detections/rules/logs/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/'
    | '/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/'
    | '/_breadcrumbsLayout/$accountId/identities/incidents/visual/'
    | '/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/'
    | '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/'
    | '/_breadcrumbsLayout/$accountId/identities/tenants/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/users/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/users/visual/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/'
    | '/_breadcrumbsLayout/$accountId/incidents/incidents/visual/'
    | '/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/incidents/pivot/$id/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/'
    | '/_breadcrumbsLayout/$accountId/platform/data-purge/runs/'
    | '/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/'
    | '/_breadcrumbsLayout/$accountId/platform/easm-settings/create/'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/runs/'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/'
    | '/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/create/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/create/'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/'
    | '/_breadcrumbsLayout/$accountId/risk360/factors/visual/'
    | '/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/settings/account-settings/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts/create/'
    | '/_breadcrumbsLayout/$accountId/settings/all-users/create/'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles/'
    | '/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/user-management/create/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/'
    | '/_breadcrumbsLayout/$accountId/threats/alerts/visual/'
    | '/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/threats/assets/visual/'
    | '/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/overview/'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/visual/'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/severity/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/'
    | '/_breadcrumbsLayout/$accountId/threats/users/$id/'
    | '/_breadcrumbsLayout/$accountId/threats/users/visual/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id'
    | '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex'
    | '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}'
    | '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId'
    | '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type'
    | '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}'
    | '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId'
    | '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id'
    | '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id'
    | '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}'
    | '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId'
    | '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/'
    | '/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/'
    | '/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/'
    | '/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/create/$type/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/'
    | '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/'
    | '/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit'
    | '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview'
    | '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/'
    | '/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/'
    | '/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/'
    | '/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/'
    | '/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/'
    | '/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/'
    | '/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/'
    | '/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId'
    | '/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/'
    | '/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/'
    | '/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
    | '/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BreadcrumbsLayoutRoute: typeof BreadcrumbsLayoutRouteWithChildren
  ErrorProcessRequestRoute: typeof ErrorProcessRequestRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BreadcrumbsLayoutRoute: BreadcrumbsLayoutRouteWithChildren,
  ErrorProcessRequestRoute: ErrorProcessRequestRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_breadcrumbsLayout",
        "/error-process-request"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_breadcrumbsLayout": {
      "filePath": "_breadcrumbsLayout.tsx",
      "children": [
        "/_breadcrumbsLayout/$accountId"
      ]
    },
    "/error-process-request": {
      "filePath": "error-process-request.tsx"
    },
    "/_breadcrumbsLayout/$accountId": {
      "filePath": "_breadcrumbsLayout/$accountId/route.tsx",
      "parent": "/_breadcrumbsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets",
        "/_breadcrumbsLayout/$accountId/detections",
        "/_breadcrumbsLayout/$accountId/explore",
        "/_breadcrumbsLayout/$accountId/identities",
        "/_breadcrumbsLayout/$accountId/incidents",
        "/_breadcrumbsLayout/$accountId/risk360",
        "/_breadcrumbsLayout/$accountId/threats",
        "/_breadcrumbsLayout/$accountId/vulnerabilities",
        "/_breadcrumbsLayout/$accountId/",
        "/_breadcrumbsLayout/$accountId/platform/aliases",
        "/_breadcrumbsLayout/$accountId/platform/authentication-sources",
        "/_breadcrumbsLayout/$accountId/platform/easm-settings",
        "/_breadcrumbsLayout/$accountId/platform/risk-score",
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation",
        "/_breadcrumbsLayout/$accountId/platform/sources",
        "/_breadcrumbsLayout/$accountId/platform/targets",
        "/_breadcrumbsLayout/$accountId/platform/workflows",
        "/_breadcrumbsLayout/$accountId/settings/account-settings",
        "/_breadcrumbsLayout/$accountId/settings/account-usage",
        "/_breadcrumbsLayout/$accountId/settings/all-accounts",
        "/_breadcrumbsLayout/$accountId/settings/all-users",
        "/_breadcrumbsLayout/$accountId/settings/backoffice-actions",
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules",
        "/_breadcrumbsLayout/$accountId/settings/icons",
        "/_breadcrumbsLayout/$accountId/settings/profile-settings",
        "/_breadcrumbsLayout/$accountId/settings/query",
        "/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions",
        "/_breadcrumbsLayout/$accountId/settings/user-management",
        "/_breadcrumbsLayout/$accountId/caasm/$",
        "/_breadcrumbsLayout/$accountId/platform",
        "/_breadcrumbsLayout/$accountId/tickets/$",
        "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions",
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/asset-inventory",
        "/_breadcrumbsLayout/$accountId/assets/policies",
        "/_breadcrumbsLayout/$accountId/assets/policy-compliance",
        "/_breadcrumbsLayout/$accountId/assets/settings",
        "/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap",
        "/_breadcrumbsLayout/$accountId/assets/users",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/assets/",
        "/_breadcrumbsLayout/$accountId/assets/assets/visual",
        "/_breadcrumbsLayout/$accountId/assets/assets/{-$id}",
        "/_breadcrumbsLayout/$accountId/assets/policy-violations/visual",
        "/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}",
        "/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual",
        "/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/global-scripts",
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables",
        "/_breadcrumbsLayout/$accountId/detections/pivot",
        "/_breadcrumbsLayout/$accountId/detections/rules",
        "/_breadcrumbsLayout/$accountId/detections/settings",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/detections/",
        "/_breadcrumbsLayout/$accountId/detections/alerts/visual",
        "/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}",
        "/_breadcrumbsLayout/$accountId/detections/incidents/visual",
        "/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/entities",
        "/_breadcrumbsLayout/$accountId/explore/logs",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/explore/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/alerts",
        "/_breadcrumbsLayout/$accountId/identities/identity-findings",
        "/_breadcrumbsLayout/$accountId/identities/overview",
        "/_breadcrumbsLayout/$accountId/identities/remediation",
        "/_breadcrumbsLayout/$accountId/identities/tenants",
        "/_breadcrumbsLayout/$accountId/identities/users",
        "/_breadcrumbsLayout/$accountId/identities/",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports",
        "/_breadcrumbsLayout/$accountId/identities/incidents/visual",
        "/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}",
        "/_breadcrumbsLayout/$accountId/identities/settings/itdr-config",
        "/_breadcrumbsLayout/$accountId/identities/settings/ui-config/",
        "/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/pivot",
        "/_breadcrumbsLayout/$accountId/incidents/settings",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/incidents/",
        "/_breadcrumbsLayout/$accountId/incidents/incidents/visual",
        "/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules",
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/risk360/",
        "/_breadcrumbsLayout/$accountId/risk360/factors/visual",
        "/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/dashboard",
        "/_breadcrumbsLayout/$accountId/threats/users",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/threats/",
        "/_breadcrumbsLayout/$accountId/threats/alerts/visual",
        "/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}",
        "/_breadcrumbsLayout/$accountId/threats/assets/visual",
        "/_breadcrumbsLayout/$accountId/threats/assets/{-$id}",
        "/_breadcrumbsLayout/$accountId/threats/incidents/overview",
        "/_breadcrumbsLayout/$accountId/threats/incidents/visual",
        "/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}",
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules",
        "/_breadcrumbsLayout/$accountId/threats/settings/severity",
        "/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses",
        "/_breadcrumbsLayout/$accountId/threats/settings/ui-config",
        "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual",
        "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}",
        "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit",
        "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/explore",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/overview",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/remediation",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/risk",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/roi",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/": {
      "filePath": "_breadcrumbsLayout/$accountId/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId"
    },
    "/_breadcrumbsLayout/$accountId/assets/asset-inventory": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/asset-inventory/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/asset-inventory/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policies": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policies/create",
        "/_breadcrumbsLayout/$accountId/assets/policies/",
        "/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id",
        "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id",
        "/_breadcrumbsLayout/$accountId/assets/policies/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policy-compliance": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policy-compliance/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policy-compliance/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings",
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set",
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle",
        "/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses",
        "/_breadcrumbsLayout/$accountId/assets/settings/ui-config",
        "/_breadcrumbsLayout/$accountId/assets/settings/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/users": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/users/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/users/$id",
        "/_breadcrumbsLayout/$accountId/assets/users/visual",
        "/_breadcrumbsLayout/$accountId/assets/users/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/global-scripts/create",
        "/_breadcrumbsLayout/$accountId/detections/global-scripts/",
        "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables/create",
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables/",
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/pivot": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/pivot/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/pivot/$id",
        "/_breadcrumbsLayout/$accountId/detections/pivot/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/rules": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/rules/create",
        "/_breadcrumbsLayout/$accountId/detections/rules/logs",
        "/_breadcrumbsLayout/$accountId/detections/rules/",
        "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id",
        "/_breadcrumbsLayout/$accountId/detections/rules/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set",
        "/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses",
        "/_breadcrumbsLayout/$accountId/detections/settings/ui-config",
        "/_breadcrumbsLayout/$accountId/detections/settings/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/entities": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/entities/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/entities/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/logs": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/logs/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/logs/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/alerts": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/alerts/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}",
        "/_breadcrumbsLayout/$accountId/identities/alerts/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/identity-findings": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/identity-findings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/identity-findings/$id",
        "/_breadcrumbsLayout/$accountId/identities/identity-findings/visual",
        "/_breadcrumbsLayout/$accountId/identities/identity-findings/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/overview": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/overview/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/overview/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/remediation": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/remediation/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/remediation/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/tenants": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/tenants/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/tenants/",
        "/_breadcrumbsLayout/$accountId/identities/tenants/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/users": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/users/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/users/$id",
        "/_breadcrumbsLayout/$accountId/identities/users/visual",
        "/_breadcrumbsLayout/$accountId/identities/users/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/pivot": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/pivot/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/pivot/$id",
        "/_breadcrumbsLayout/$accountId/incidents/pivot/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set",
        "/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses",
        "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config",
        "/_breadcrumbsLayout/$accountId/incidents/settings/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/aliases": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/aliases/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/aliases/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/authentication-sources": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/authentication-sources/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/authentication-sources/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/easm-settings": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/easm-settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/easm-settings/create",
        "/_breadcrumbsLayout/$accountId/platform/easm-settings/",
        "/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/risk-score": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/risk-score/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/risk-score/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation/create",
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation/",
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id",
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/create",
        "/_breadcrumbsLayout/$accountId/platform/sources/",
        "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id",
        "/_breadcrumbsLayout/$accountId/platform/sources/runs/$id",
        "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/create",
        "/_breadcrumbsLayout/$accountId/platform/targets/",
        "/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id",
        "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id",
        "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/workflows": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/workflows/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/workflows/",
        "/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/create",
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs",
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/",
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/account-settings": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/account-settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/account-settings/audit",
        "/_breadcrumbsLayout/$accountId/settings/account-settings/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/account-usage": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/account-usage/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/account-usage/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-accounts/create",
        "/_breadcrumbsLayout/$accountId/settings/all-accounts/",
        "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-users/create",
        "/_breadcrumbsLayout/$accountId/settings/all-users/",
        "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/backoffice-actions": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/backoffice-actions/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/backoffice-actions/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create",
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/",
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/icons": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/icons/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/icons/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/profile-settings": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/profile-settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/profile-settings/audit",
        "/_breadcrumbsLayout/$accountId/settings/profile-settings/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/query": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/query/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/query/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/user-management/create",
        "/_breadcrumbsLayout/$accountId/settings/user-management/",
        "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/dashboard": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/dashboard/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/dashboard/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/users": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/users/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/users/$id",
        "/_breadcrumbsLayout/$accountId/threats/users/visual",
        "/_breadcrumbsLayout/$accountId/threats/users/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/explore": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/explore/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/explore/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/overview": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/overview/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/overview/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/pivot/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/remediation": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/remediation/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/risk": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/risk/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/risk/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/roi": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/roi/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/roi/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports"
      ]
    },
    "/_breadcrumbsLayout/$accountId/caasm/$": {
      "filePath": "_breadcrumbsLayout/$accountId/caasm/$.tsx",
      "parent": "/_breadcrumbsLayout/$accountId"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform": {
      "filePath": "_breadcrumbsLayout/$accountId/platform",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout",
        "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities",
        "/_breadcrumbsLayout/$accountId/platform/data-entities/fields",
        "/_breadcrumbsLayout/$accountId/platform/data-purge/runs",
        "/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}",
        "/_breadcrumbsLayout/$accountId/platform/model-management/runs",
        "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}",
        "/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard",
        "/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}",
        "/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}",
        "/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports"
      ]
    },
    "/_breadcrumbsLayout/$accountId/tickets/$": {
      "filePath": "_breadcrumbsLayout/$accountId/tickets/$.tsx",
      "parent": "/_breadcrumbsLayout/$accountId"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats"
    },
    "/_breadcrumbsLayout/$accountId/assets/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets"
    },
    "/_breadcrumbsLayout/$accountId/detections/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections"
    },
    "/_breadcrumbsLayout/$accountId/explore/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore"
    },
    "/_breadcrumbsLayout/$accountId/identities/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities"
    },
    "/_breadcrumbsLayout/$accountId/incidents/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents"
    },
    "/_breadcrumbsLayout/$accountId/risk360/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/assets/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/assets/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/assets/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/assets/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/assets/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/create": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policies/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policy-violations/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policy-violations/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/easm-settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create",
        "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/",
        "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/",
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}",
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses",
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/",
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ui-config": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ui-config/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/ui-config/",
        "/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/users/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/users/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/users",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/users/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/users/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/users/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/users",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/users/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/alerts/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/alerts/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/alerts/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts/create": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/global-scripts",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/global-scripts/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/incidents/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/incidents/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/incidents/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables/create": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/lookup-tables",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/pivot/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/pivot/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/pivot",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/pivot/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/create": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/rules/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/logs": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/logs/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/rules/logs/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id",
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create",
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/",
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/ui-config": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/ui-config/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/ui-config/",
        "/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/alerts",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/identity-findings/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/identity-findings/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/identity-findings",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/identity-findings/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/identity-findings/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/identity-findings",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/incidents/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/incidents/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/incidents/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/settings/itdr-config": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/settings/itdr-config/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/users/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/users/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/users",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/users/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/users/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/users/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/users",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/users/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/incidents/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/incidents/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/incidents/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/pivot/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/pivot/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/pivot",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/pivot/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id",
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create",
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/ui-config/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/",
        "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create",
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/",
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/",
        "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore",
        "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/fields": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/fields/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/",
        "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id",
        "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-purge/runs": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-purge/runs/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-purge/runs/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/easm-settings/create": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/easm-settings/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/easm-settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/easm-settings/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/runs": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/runs/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/model-management/runs/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit",
        "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview",
        "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation/create": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/scanner-activation",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/create": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/create/",
        "/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/create": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/create/$type",
        "/_breadcrumbsLayout/$accountId/platform/targets/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/create": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/factors/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factors/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factors/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/account-settings/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/account-settings/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/account-settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/account-settings/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts/create": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-accounts",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-accounts/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users/create": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-users",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-users/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/global-factor-rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/",
        "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit",
        "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles/create",
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles/",
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/profile-settings/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/profile-settings/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/profile-settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management/create": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/user-management",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/user-management/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/alerts/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/alerts/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/alerts/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/assets/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/assets/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/assets/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/assets/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/assets/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/overview": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/overview/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/incidents/overview/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/incidents/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create",
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/",
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/severity": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/severity/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/severity/",
        "/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/ui-config": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/ui-config/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/ui-config/",
        "/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/users/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/users/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/users",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/users/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/users/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/users/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/users",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/users/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/asset-inventory/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/asset-inventory/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/asset-inventory"
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies"
    },
    "/_breadcrumbsLayout/$accountId/assets/policy-compliance/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policy-compliance/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policy-compliance"
    },
    "/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap"
    },
    "/_breadcrumbsLayout/$accountId/assets/users/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/users/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/users"
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/global-scripts"
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/lookup-tables"
    },
    "/_breadcrumbsLayout/$accountId/detections/pivot/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/pivot/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/pivot"
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules"
    },
    "/_breadcrumbsLayout/$accountId/explore/entities/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/entities/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/entities"
    },
    "/_breadcrumbsLayout/$accountId/explore/logs/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/logs/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/logs"
    },
    "/_breadcrumbsLayout/$accountId/identities/alerts/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/alerts/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/alerts"
    },
    "/_breadcrumbsLayout/$accountId/identities/identity-findings/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/identity-findings/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/identity-findings"
    },
    "/_breadcrumbsLayout/$accountId/identities/tenants/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/tenants/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/tenants"
    },
    "/_breadcrumbsLayout/$accountId/identities/users/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/users/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/users"
    },
    "/_breadcrumbsLayout/$accountId/incidents/pivot/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/pivot/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/pivot"
    },
    "/_breadcrumbsLayout/$accountId/platform/aliases/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/aliases/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/aliases"
    },
    "/_breadcrumbsLayout/$accountId/platform/authentication-sources/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/authentication-sources/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/authentication-sources"
    },
    "/_breadcrumbsLayout/$accountId/platform/easm-settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/easm-settings/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/easm-settings"
    },
    "/_breadcrumbsLayout/$accountId/platform/risk-score/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/risk-score/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/risk-score"
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/scanner-activation"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets"
    },
    "/_breadcrumbsLayout/$accountId/platform/workflows/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/workflows/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/workflows"
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules"
    },
    "/_breadcrumbsLayout/$accountId/settings/account-settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/account-settings/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/account-settings"
    },
    "/_breadcrumbsLayout/$accountId/settings/account-usage/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/account-usage/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/account-usage"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-accounts"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-users"
    },
    "/_breadcrumbsLayout/$accountId/settings/backoffice-actions/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/backoffice-actions/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/backoffice-actions"
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/global-factor-rules"
    },
    "/_breadcrumbsLayout/$accountId/settings/icons/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/icons/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/icons"
    },
    "/_breadcrumbsLayout/$accountId/settings/profile-settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/profile-settings/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/profile-settings"
    },
    "/_breadcrumbsLayout/$accountId/settings/query/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/query/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/query"
    },
    "/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions"
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/user-management"
    },
    "/_breadcrumbsLayout/$accountId/threats/dashboard/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/dashboard/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/dashboard"
    },
    "/_breadcrumbsLayout/$accountId/threats/users/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/users/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/users"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/explore/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/explore/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/explore"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/overview/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/overview/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/overview"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/pivot/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/remediation/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/remediation/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/remediation"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/risk/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/risk/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/risk"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/roi/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/roi/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/roi"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings"
    },
    "/_breadcrumbsLayout/$accountId/identities/overview/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/overview/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/overview"
    },
    "/_breadcrumbsLayout/$accountId/identities/remediation/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/remediation/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/remediation"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/index.lazy.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/global-scripts",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/lookup-tables",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex",
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex",
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex",
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit",
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex",
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/scanner-activation",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/scanner-activation",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId",
        "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/create/$type": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/create/$type/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/create",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/create/$type/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/",
        "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/workflows",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-accounts",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-users",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/global-factor-rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles/create": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/roles",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/user-management",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions-settings/$.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports"
    },
    "/_breadcrumbsLayout/$accountId/assets/assets/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/assets/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/assets/visual"
    },
    "/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/assets/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/assets/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies/create"
    },
    "/_breadcrumbsLayout/$accountId/assets/policy-violations/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policy-violations/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policy-violations/visual"
    },
    "/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/easm-settings/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/rule-set"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/tickets-statuses"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ui-config/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ui-config/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ui-config"
    },
    "/_breadcrumbsLayout/$accountId/assets/users/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/users/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/users/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/users/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/users/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/users/visual"
    },
    "/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/violation-tickets/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/violation-tickets/visual"
    },
    "/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports"
    },
    "/_breadcrumbsLayout/$accountId/detections/alerts/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/alerts/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/alerts/visual"
    },
    "/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/global-scripts/create"
    },
    "/_breadcrumbsLayout/$accountId/detections/incidents/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/incidents/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/incidents/visual"
    },
    "/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/incidents/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/incidents/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/lookup-tables/create"
    },
    "/_breadcrumbsLayout/$accountId/detections/pivot/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/pivot/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/pivot/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules/create"
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/logs/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/logs/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules/logs"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/tickets-statuses"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/ui-config/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/ui-config/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/ui-config"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports"
    },
    "/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/alerts/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/identities/identity-findings/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/identity-findings/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/identity-findings/$id"
    },
    "/_breadcrumbsLayout/$accountId/identities/identity-findings/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/identity-findings/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/identity-findings/visual"
    },
    "/_breadcrumbsLayout/$accountId/identities/incidents/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/incidents/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/incidents/visual"
    },
    "/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/incidents/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/identities/settings/itdr-config/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/settings/itdr-config/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/settings/itdr-config"
    },
    "/_breadcrumbsLayout/$accountId/identities/settings/ui-config/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/settings/ui-config/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities"
    },
    "/_breadcrumbsLayout/$accountId/identities/tenants/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/tenants/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/tenants"
    },
    "/_breadcrumbsLayout/$accountId/identities/users/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/users/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/users/$id"
    },
    "/_breadcrumbsLayout/$accountId/identities/users/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/users/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/users/visual"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports"
    },
    "/_breadcrumbsLayout/$accountId/incidents/incidents/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/incidents/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/incidents/visual"
    },
    "/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/incidents/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/incidents/pivot/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/pivot/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/pivot/$id"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/tickets-statuses"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/ui-config/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config"
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/fields/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/fields"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-purge/runs/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-purge/runs/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-purge/runs"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-purge/{-$projId}"
    },
    "/_breadcrumbsLayout/$accountId/platform/easm-settings/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/easm-settings/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/easm-settings/create"
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/runs/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/runs/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/model-management/runs"
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/overview/health-dashboard/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard"
    },
    "/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/relations/{-$relationId}"
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/scanner-activation/create"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/create"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/create"
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules/create"
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/runs/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules/runs"
    },
    "/_breadcrumbsLayout/$accountId/risk360/factors/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factors/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factors/visual"
    },
    "/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/settings/account-settings/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/account-settings/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/account-settings/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-accounts/create"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-users/create"
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/create"
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions"
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/roles"
    },
    "/_breadcrumbsLayout/$accountId/settings/profile-settings/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/profile-settings/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/profile-settings/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/user-management/create"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports"
    },
    "/_breadcrumbsLayout/$accountId/threats/alerts/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/alerts/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/alerts/visual"
    },
    "/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/alerts/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/alerts/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/threats/assets/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/assets/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/assets/visual"
    },
    "/_breadcrumbsLayout/$accountId/threats/assets/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/assets/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/assets/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/overview/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/overview/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/incidents/overview"
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/incidents/visual"
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/severity/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/severity/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/severity"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/tickets-statuses"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/ui-config/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/ui-config/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/ui-config"
    },
    "/_breadcrumbsLayout/$accountId/threats/users/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/users/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/users/$id"
    },
    "/_breadcrumbsLayout/$accountId/threats/users/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/users/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/users/visual"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/visual"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/assets/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/exceptions/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/visual"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/findings/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/pivot/$id"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/visual"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/tickets/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit",
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ui-config",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/ui-config",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/",
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id.$organizationId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/easm-settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit",
        "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview",
        "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/create",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/roles",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/severity",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/ui-config",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/create"
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies/duplicate/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/create"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/tickets-statuses"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/create"
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/create"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/create"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/create"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create"
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/create"
    },
    "/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/audit"
    },
    "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/preview"
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/scanner-activation/sensors/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/create/$type/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/create/$type/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/create/$type"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/workflows/audit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/workflows/audit/$id"
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/roles/create"
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/create"
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/visual"
    },
    "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/audit"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/create"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-statuses"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/tickets-statuses"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id.$organizationId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/",
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/",
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/policies/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/create/{-$ruleIndex}"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ui-config/audit/$path"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/global-scripts/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/lookup-tables/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/rules/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/$id/$ruleIndex"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/audit/$id"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex"
    },
    "/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/settings/ui-config/audit/$path"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/settings/ui-config/audit/$path/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/create/$ruleIndex"
    },
    "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/settings/ui-config/audit/$path"
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/{-$ruleId}"
    },
    "/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id.$organizationId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/create/$type/{-$previewId}"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-accounts/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/all-users/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions"
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/user-management/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/ui-config/audit/$path"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/runs/$id"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/$id/{-$ruleIndex}"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/score/audit/$path"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ui-config/audit/$path"
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/audit.$id/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/fields",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/{-$mode}/{-$id}/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/fields",
      "children": [
        "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id.$organizationId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/audit"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/reports/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/reports/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/identities/_externalProjectionsLayout/reports/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/incidents/_externalProjectionsLayout/reports/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/audit"
    },
    "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview"
    },
    "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping"
    },
    "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/risk360/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/{-$mode}/{-$id}/audit"
    },
    "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/reports/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit.$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/edit/$id/audit"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/severity/audit/$automationId"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}",
      "children": [
        "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/route.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}",
      "children": [
        "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/"
      ]
    },
    "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName/audit/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/audit.$id/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id"
    },
    "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/": {
      "filePath": "_breadcrumbsLayout/$accountId/platform/data-entities/fields/set.$fieldName/{-$mode}/{-$id}/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/audit/$automationId"
    },
    "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/": {
      "filePath": "_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId"
    },
    "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/": {
      "filePath": "_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId/index.tsx",
      "parent": "/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/audit/$automationId"
    }
  }
}
ROUTE_MANIFEST_END */
